/**
 * OneAmerica AssetCare Category 2 (MT) Age-Aware Multiplier Bands
 * Generated: 2026-04-01
 * Gender-independent (gender has no effect on non-linearity for Cat 2)
 *
 * Key formats:
 *   Single Life / Joint same-age: "productKey|age|aobInf|cobInf|aobDur|cobDur"
 *   Joint mixed-age: "productKey|age1|age2|aobInf|cobInf|aobDur|cobDur" (age1 < age2)
 * Single Pay / Single Life uses oneAmericaCat2DemographicSinglePayBands.ts.
 * Base premium: $100k (Single Pay), $10k (10-Pay)
 */

import type { BandEntry } from "./oneAmericaPricingUtils";

export const OA_CAT2_DEMO_BANDS: Record<string, BandEntry[]> = {
  "10pay_joint|45|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.979938, ltc: 0.979938 },
    { premium: 7500, db: 1.000005, ltc: 1.000005 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.11092, ltc: 0.971682 },
    { premium: 30000, db: 1.20276, ltc: 0.948231 },
  ],
  "10pay_joint|45|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 0.979976, ltc: 0.979976 },
    { premium: 7500, db: 0.986672, ltc: 0.986672 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.105642, ltc: 0.975618 },
    { premium: 55000, db: 1.594719, ltc: 0.862702 },
  ],
  "10pay_joint|45|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.368499, ltc: 1 },
    { premium: 7500, db: 0.996639, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010112, ltc: 1 },
    { premium: 15500, db: 1.010111, ltc: 1 },
    { premium: 20000, db: 1.010119, ltc: 1 },
    { premium: 25000, db: 1.010117, ltc: 1 },
    { premium: 30000, db: 1.010116, ltc: 1 },
    { premium: 35000, db: 1.010116, ltc: 1 },
    { premium: 40000, db: 1.010119, ltc: 1 },
    { premium: 45000, db: 1.229968, ltc: 1 },
    { premium: 50000, db: 1.434788, ltc: 1 },
    { premium: 55000, db: 1.602367, ltc: 1 },
    { premium: 60000, db: 1.742017, ltc: 1 },
    { premium: 65000, db: 1.860182, ltc: 1 },
  ],
  "10pay_joint|45|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.979933, ltc: 0.979933 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.003748, ltc: 0.998275 },
    { premium: 30000, db: 1.089867, ltc: 0.958601 },
    { premium: 35000, db: 1.151381, ltc: 0.930263 },
    { premium: 40000, db: 1.197516, ltc: 0.909009 },
    { premium: 45000, db: 1.2334, ltc: 0.892478 },
  ],
  "10pay_joint|45|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 0.979971, ltc: 1 },
    { premium: 7500, db: 0.986618, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 0.999999, ltc: 1 },
    { premium: 40000, db: 1.03645, ltc: 1 },
    { premium: 45000, db: 1.186393, ltc: 1 },
    { premium: 50000, db: 1.306348, ltc: 1 },
    { premium: 55000, db: 1.404492, ltc: 1 },
    { premium: 60000, db: 1.486279, ltc: 1 },
  ],
  "10pay_joint|45|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979998, ltc: 0.979998 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.034557, ltc: 0.962481 },
    { premium: 40000, db: 1.069648, ltc: 0.924376 },
    { premium: 45000, db: 1.09694, ltc: 0.894738 },
  ],
  "10pay_joint|45|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980059, ltc: 1 },
    { premium: 7500, db: 0.999996, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1 },
    { premium: 40000, db: 1.017324, ltc: 1 },
    { premium: 45000, db: 1.086809, ltc: 1 },
    { premium: 50000, db: 1.142398, ltc: 1 },
  ],
  "10pay_joint|45|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.980018, ltc: 0.980018 },
    { premium: 7500, db: 0.986583, ltc: 0.986583 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1.171446, ltc: 0.997724 },
    { premium: 25000, db: 1.331982, ltc: 0.995592 },
    { premium: 30000, db: 1.439009, ltc: 0.994172 },
  ],
  "10pay_joint|45|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.152484, ltc: 1.152484 },
    { premium: 7500, db: 0.996616, ltc: 0.996616 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010075, ltc: 1.010075 },
    { premium: 15500, db: 1.010076, ltc: 1.010076 },
    { premium: 20000, db: 1.010077, ltc: 1.010077 },
    { premium: 25000, db: 1.163011, ltc: 1.00223 },
    { premium: 30000, db: 1.429285, ltc: 0.988562 },
    { premium: 35000, db: 1.619481, ltc: 0.978798 },
    { premium: 40000, db: 1.762128, ltc: 0.971476 },
    { premium: 45000, db: 1.873075, ltc: 0.965781 },
    { premium: 50000, db: 1.961834, ltc: 0.961224 },
    { premium: 55000, db: 2.034456, ltc: 0.957497 },
  ],
  "10pay_joint|45|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 1.80261, ltc: 1 },
    { premium: 7500, db: 1.20174, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003352, ltc: 1 },
    { premium: 15500, db: 1.003567, ltc: 1 },
    { premium: 20000, db: 1.010093, ltc: 1 },
    { premium: 25000, db: 1.010093, ltc: 1 },
    { premium: 30000, db: 1.010099, ltc: 1 },
    { premium: 35000, db: 1.010098, ltc: 1 },
    { premium: 40000, db: 1.366854, ltc: 1 },
    { premium: 45000, db: 1.694755, ltc: 1 },
    { premium: 50000, db: 1.957076, ltc: 1 },
    { premium: 55000, db: 2.171702, ltc: 1 },
    { premium: 60000, db: 2.350558, ltc: 1 },
    { premium: 65000, db: 2.501899, ltc: 1 },
  ],
  "10pay_joint|45|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.979966, ltc: 0.979966 },
    { premium: 7500, db: 1.000005, ltc: 1.000005 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.0314, ltc: 0.995103 },
    { premium: 25000, db: 1.177535, ltc: 0.97229 },
    { premium: 30000, db: 1.274959, ltc: 0.957081 },
    { premium: 35000, db: 1.344547, ltc: 0.946218 },
    { premium: 40000, db: 1.396739, ltc: 0.938071 },
    { premium: 45000, db: 1.437332, ltc: 0.931734 },
  ],
  "10pay_joint|45|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.248084, ltc: 1 },
    { premium: 7500, db: 0.996647, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1 },
    { premium: 15500, db: 1.010123, ltc: 1 },
    { premium: 20000, db: 1.010121, ltc: 1 },
    { premium: 25000, db: 1.010123, ltc: 1 },
    { premium: 30000, db: 1.010125, ltc: 1 },
    { premium: 35000, db: 1.13041, ltc: 1 },
    { premium: 40000, db: 1.371344, ltc: 1 },
    { premium: 45000, db: 1.558734, ltc: 1 },
    { premium: 50000, db: 1.708643, ltc: 1 },
    { premium: 55000, db: 1.831298, ltc: 1 },
    { premium: 60000, db: 1.933511, ltc: 1 },
  ],
  "10pay_joint|45|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979998, ltc: 0.979998 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.034813, ltc: 0.979888 },
    { premium: 30000, db: 1.106332, ltc: 0.938567 },
    { premium: 35000, db: 1.157415, ltc: 0.909051 },
    { premium: 40000, db: 1.195728, ltc: 0.886915 },
    { premium: 45000, db: 1.225528, ltc: 0.869698 },
  ],
  "10pay_joint|45|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980033, ltc: 1 },
    { premium: 7500, db: 0.98673, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.117369, ltc: 1 },
    { premium: 40000, db: 1.22004, ltc: 1 },
    { premium: 45000, db: 1.299893, ltc: 1 },
    { premium: 50000, db: 1.363776, ltc: 1 },
  ],
  "10pay_joint|45|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979994, ltc: 0.979994 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.021342, ltc: 0.980173 },
  ],
  "10pay_joint|45|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.979983, ltc: 0.979983 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
  ],
  "10pay_joint|45|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 0.979961, ltc: 1 },
    { premium: 7500, db: 0.986698, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000005, ltc: 1 },
    { premium: 30000, db: 1.000006, ltc: 1 },
    { premium: 35000, db: 1.000006, ltc: 1 },
    { premium: 40000, db: 1.000007, ltc: 1 },
    { premium: 45000, db: 1.000007, ltc: 1 },
    { premium: 50000, db: 1.111268, ltc: 1 },
    { premium: 55000, db: 1.207287, ltc: 1 },
    { premium: 60000, db: 1.287303, ltc: 1 },
    { premium: 65000, db: 1.355009, ltc: 1 },
  ],
  "10pay_joint|45|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.980012, ltc: 0.980012 },
    { premium: 7500, db: 1.000003, ltc: 1.000003 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.002763, ltc: 0.996336 },
    { premium: 40000, db: 1.036601, ltc: 0.951386 },
    { premium: 45000, db: 1.06292, ltc: 0.916424 },
  ],
  "10pay_joint|45|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979946, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000003, ltc: 1 },
    { premium: 40000, db: 1.000004, ltc: 1 },
    { premium: 45000, db: 1.000004, ltc: 1 },
    { premium: 50000, db: 1.044556, ltc: 1 },
    { premium: 55000, db: 1.106399, ltc: 1 },
    { premium: 60000, db: 1.157935, ltc: 1 },
  ],
  "10pay_joint|45|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.999995, ltc: 0.999995 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.000001, ltc: 1.000001 },
    { premium: 40000, db: 1.000001, ltc: 1.000001 },
    { premium: 45000, db: 1.000001, ltc: 1.000001 },
  ],
  "10pay_joint|45|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.980051, ltc: 1 },
    { premium: 7500, db: 0.999996, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1 },
    { premium: 40000, db: 1.000001, ltc: 1 },
    { premium: 45000, db: 1.000001, ltc: 1 },
    { premium: 50000, db: 1.000001, ltc: 1 },
  ],
  "10pay_joint|48|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.97992, ltc: 0.97992 },
    { premium: 7500, db: 0.986568, ltc: 0.986568 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.06409, ltc: 0.986006 },
    { premium: 30000, db: 1.169416, ltc: 0.963008 },
  ],
  "10pay_joint|48|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 0.999381, ltc: 0.999381 },
    { premium: 7500, db: 0.986565, ltc: 0.986565 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.001116, ltc: 0.999772 },
  ],
  "10pay_joint|48|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.507885, ltc: 1 },
    { premium: 7500, db: 1.005257, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010121, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.010124, ltc: 1 },
    { premium: 25000, db: 1.010125, ltc: 1 },
    { premium: 30000, db: 1.010126, ltc: 1 },
  ],
  "10pay_joint|48|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.97995, ltc: 0.97995 },
    { premium: 7500, db: 1.000007, ltc: 1.000007 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000007, ltc: 1.000007 },
    { premium: 20000, db: 1.000007, ltc: 1.000007 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.055157, ltc: 0.977182 },
  ],
  "10pay_joint|48|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.083189, ltc: 1 },
    { premium: 7500, db: 0.996592, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010078, ltc: 1 },
    { premium: 15500, db: 1.01008, ltc: 1 },
    { premium: 20000, db: 1.010076, ltc: 1 },
    { premium: 25000, db: 1.01008, ltc: 1 },
    { premium: 30000, db: 1.010078, ltc: 1 },
  ],
  "10pay_joint|48|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979922, ltc: 0.979922 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|48|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979975, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
  ],
  "10pay_joint|48|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.979924, ltc: 0.979924 },
    { premium: 7500, db: 0.986565, ltc: 0.986565 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.099274, ltc: 1.00119 },
    { premium: 25000, db: 1.284307, ltc: 1.003396 },
    { premium: 30000, db: 1.407665, ltc: 1.004868 },
  ],
  "10pay_joint|48|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.271186, ltc: 1.271186 },
    { premium: 7500, db: 0.996628, ltc: 0.996628 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010176, ltc: 1.010176 },
    { premium: 15500, db: 1.010174, ltc: 1.010174 },
    { premium: 20000, db: 1.010174, ltc: 1.010174 },
    { premium: 25000, db: 1.010177, ltc: 1.010177 },
    { premium: 30000, db: 1.306708, ltc: 1.000417 },
  ],
  "10pay_joint|48|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003166, ltc: 1 },
    { premium: 15500, db: 1.003369, ltc: 1 },
    { premium: 20000, db: 1.009909, ltc: 1 },
    { premium: 25000, db: 1.009907, ltc: 1 },
    { premium: 30000, db: 1.009905, ltc: 1 },
  ],
  "10pay_joint|48|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.980016, ltc: 0.980016 },
    { premium: 7500, db: 0.986664, ltc: 0.986664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.130468, ltc: 0.98369 },
    { premium: 30000, db: 1.24205, ltc: 0.969738 },
  ],
  "10pay_joint|48|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.376776, ltc: 1 },
    { premium: 7500, db: 0.99666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010122, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.010124, ltc: 1 },
    { premium: 25000, db: 1.010126, ltc: 1 },
    { premium: 30000, db: 1.010126, ltc: 1 },
  ],
  "10pay_joint|48|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979992, ltc: 0.979992 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.080018, ltc: 0.958011 },
  ],
  "10pay_joint|48|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979993, ltc: 1 },
    { premium: 7500, db: 0.986685, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|48|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979893, ltc: 0.979893 },
    { premium: 7500, db: 1.000004, ltc: 1.000004 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|48|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.979897, ltc: 0.979897 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|48|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 0.994185, ltc: 1 },
    { premium: 7500, db: 0.986597, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000006, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_joint|48|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.980065, ltc: 0.980065 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|48|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979976, ltc: 1 },
    { premium: 7500, db: 0.986643, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
  ],
  "10pay_joint|48|None|None|50 Months|50 Months": [
    { premium: 5000, db: 1, ltc: 1 },
    { premium: 7500, db: 0.999997, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_joint|48|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.97999, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
  ],
  "10pay_joint|50|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.979976, ltc: 0.979976 },
    { premium: 7500, db: 0.986608, ltc: 0.986608 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.026326, ltc: 0.994905 },
    { premium: 30000, db: 1.142063, ltc: 0.972483 },
    { premium: 35000, db: 1.224733, ltc: 0.956468 },
    { premium: 40000, db: 1.286735, ltc: 0.944456 },
    { premium: 45000, db: 1.334959, ltc: 0.935114 },
    { premium: 50000, db: 1.373538, ltc: 0.92764 },
    { premium: 55000, db: 1.405104, ltc: 0.921526 },
  ],
  "10pay_joint|50|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.075995, ltc: 1.075995 },
    { premium: 7500, db: 0.996651, ltc: 0.996651 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010141, ltc: 1.010141 },
    { premium: 15500, db: 1.010135, ltc: 1.010135 },
    { premium: 20000, db: 1.010139, ltc: 1.010139 },
    { premium: 25000, db: 1.010138, ltc: 1.010138 },
    { premium: 30000, db: 1.010141, ltc: 1.010141 },
    { premium: 35000, db: 1.123032, ltc: 0.989087 },
    { premium: 40000, db: 1.270854, ltc: 0.961519 },
    { premium: 45000, db: 1.385828, ltc: 0.940076 },
    { premium: 50000, db: 1.477808, ltc: 0.922923 },
    { premium: 55000, db: 1.553063, ltc: 0.908888 },
    { premium: 60000, db: 1.615776, ltc: 0.897192 },
  ],
  "10pay_joint|50|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.610907, ltc: 1 },
    { premium: 7500, db: 1.073938, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003372, ltc: 1 },
    { premium: 15500, db: 1.00356, ltc: 1 },
    { premium: 20000, db: 1.010107, ltc: 1 },
    { premium: 25000, db: 1.010108, ltc: 1 },
    { premium: 30000, db: 1.010104, ltc: 1 },
    { premium: 35000, db: 1.010105, ltc: 1 },
    { premium: 40000, db: 1.010107, ltc: 1 },
    { premium: 45000, db: 1.010108, ltc: 1 },
    { premium: 50000, db: 1.115832, ltc: 1 },
    { premium: 55000, db: 1.328194, ltc: 1 },
    { premium: 60000, db: 1.505165, ltc: 1 },
    { premium: 65000, db: 1.654907, ltc: 1 },
    { premium: 70000, db: 1.783257, ltc: 1 },
    { premium: 75000, db: 1.894494, ltc: 1 },
  ],
  "10pay_joint|50|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.979925, ltc: 0.979925 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.027969, ltc: 0.989252 },
    { premium: 35000, db: 1.104752, ltc: 0.959748 },
    { premium: 40000, db: 1.162336, ltc: 0.937619 },
    { premium: 45000, db: 1.207126, ltc: 0.920408 },
    { premium: 50000, db: 1.242958, ltc: 0.906639 },
    { premium: 55000, db: 1.272274, ltc: 0.895373 },
  ],
  "10pay_joint|50|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.155186, ltc: 1 },
    { premium: 7500, db: 0.996627, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010141, ltc: 1 },
    { premium: 15500, db: 1.010142, ltc: 1 },
    { premium: 20000, db: 1.010141, ltc: 1 },
    { premium: 25000, db: 1.010146, ltc: 1 },
    { premium: 30000, db: 1.010145, ltc: 1 },
    { premium: 35000, db: 1.010144, ltc: 1 },
    { premium: 40000, db: 1.010144, ltc: 1 },
    { premium: 45000, db: 1.010146, ltc: 1 },
    { premium: 50000, db: 1.140291, ltc: 1 },
    { premium: 55000, db: 1.267194, ltc: 1 },
    { premium: 60000, db: 1.372948, ltc: 1 },
    { premium: 65000, db: 1.46243, ltc: 1 },
    { premium: 70000, db: 1.539131, ltc: 1 },
  ],
  "10pay_joint|50|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979952, ltc: 0.979952 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1.000002 },
    { premium: 40000, db: 1.038815, ltc: 0.962958 },
    { premium: 45000, db: 1.0727, ltc: 0.930617 },
    { premium: 50000, db: 1.09981, ltc: 0.904745 },
  ],
  "10pay_joint|50|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980011, ltc: 1 },
    { premium: 7500, db: 0.999995, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.004346, ltc: 1 },
    { premium: 50000, db: 1.07326, ltc: 1 },
    { premium: 55000, db: 1.129643, ltc: 1 },
    { premium: 60000, db: 1.17663, ltc: 1 },
  ],
  "10pay_joint|50|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.979986, ltc: 0.979986 },
    { premium: 7500, db: 0.986641, ltc: 0.986641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.042399, ltc: 1.001152 },
    { premium: 25000, db: 1.245365, ltc: 1.006644 },
    { premium: 30000, db: 1.380676, ltc: 1.010306 },
    { premium: 35000, db: 1.477326, ltc: 1.012922 },
    { premium: 40000, db: 1.549814, ltc: 1.014883 },
    { premium: 45000, db: 1.606196, ltc: 1.01641 },
    { premium: 50000, db: 1.651299, ltc: 1.017631 },
    { premium: 55000, db: 1.688202, ltc: 1.018629 },
  ],
  "10pay_joint|50|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.358, ltc: 1.358 },
    { premium: 7500, db: 0.996615, ltc: 0.996615 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01012, ltc: 1.01012 },
    { premium: 15500, db: 1.010123, ltc: 1.010123 },
    { premium: 20000, db: 1.010122, ltc: 1.010122 },
    { premium: 25000, db: 1.010124, ltc: 1.010124 },
    { premium: 30000, db: 1.20746, ltc: 1.005958 },
    { premium: 35000, db: 1.45068, ltc: 1.000821 },
    { premium: 40000, db: 1.633096, ltc: 0.996969 },
    { premium: 45000, db: 1.774975, ltc: 0.993972 },
    { premium: 50000, db: 1.888478, ltc: 0.991575 },
    { premium: 55000, db: 1.981344, ltc: 0.989614 },
    { premium: 60000, db: 2.058734, ltc: 0.98798 },
  ],
  "10pay_joint|50|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.935152, ltc: 1 },
    { premium: 15500, db: 0.93537, ltc: 1 },
    { premium: 20000, db: 0.936735, ltc: 1 },
    { premium: 25000, db: 0.941453, ltc: 1 },
    { premium: 30000, db: 0.941451, ltc: 1 },
    { premium: 35000, db: 0.94145, ltc: 1 },
    { premium: 40000, db: 0.941455, ltc: 1 },
    { premium: 45000, db: 1.128452, ltc: 1 },
    { premium: 50000, db: 1.444204, ltc: 1 },
    { premium: 55000, db: 1.702547, ltc: 1 },
    { premium: 60000, db: 1.917833, ltc: 1 },
    { premium: 65000, db: 2.099998, ltc: 1 },
    { premium: 70000, db: 2.256142, ltc: 1 },
    { premium: 75000, db: 2.391465, ltc: 1 },
  ],
  "10pay_joint|50|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.979987, ltc: 0.979987 },
    { premium: 7500, db: 0.986602, ltc: 0.986602 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.092741, ltc: 0.990371 },
    { premium: 30000, db: 1.215296, ltc: 0.977649 },
    { premium: 35000, db: 1.302835, ltc: 0.968561 },
    { premium: 40000, db: 1.368488, ltc: 0.961745 },
    { premium: 45000, db: 1.419553, ltc: 0.956444 },
    { premium: 50000, db: 1.460403, ltc: 0.952202 },
    { premium: 55000, db: 1.493827, ltc: 0.948732 },
  ],
  "10pay_joint|50|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.471977, ltc: 1 },
    { premium: 7500, db: 0.996664, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010155, ltc: 1 },
    { premium: 15500, db: 1.010158, ltc: 1 },
    { premium: 20000, db: 1.010155, ltc: 1 },
    { premium: 25000, db: 1.010155, ltc: 1 },
    { premium: 30000, db: 1.010155, ltc: 1 },
    { premium: 35000, db: 1.010155, ltc: 1 },
    { premium: 40000, db: 1.073844, ltc: 1 },
    { premium: 45000, db: 1.313624, ltc: 1 },
    { premium: 50000, db: 1.505452, ltc: 1 },
    { premium: 55000, db: 1.662398, ltc: 1 },
    { premium: 60000, db: 1.79319, ltc: 1 },
    { premium: 65000, db: 1.90386, ltc: 1 },
    { premium: 70000, db: 1.998717, ltc: 1 },
  ],
  "10pay_joint|50|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.980018, ltc: 0.980018 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.059124, ltc: 0.970963 },
    { premium: 35000, db: 1.122739, ltc: 0.939714 },
    { premium: 40000, db: 1.170452, ltc: 0.916277 },
    { premium: 45000, db: 1.20756, ltc: 0.898048 },
    { premium: 50000, db: 1.237249, ltc: 0.883465 },
  ],
  "10pay_joint|50|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979975, ltc: 1 },
    { premium: 7500, db: 0.986694, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 0.999999, ltc: 1 },
    { premium: 40000, db: 1.112139, ltc: 1 },
    { premium: 45000, db: 1.213367, ltc: 1 },
    { premium: 50000, db: 1.294349, ltc: 1 },
    { premium: 55000, db: 1.360605, ltc: 1 },
    { premium: 60000, db: 1.415819, ltc: 1 },
  ],
  "10pay_joint|50|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.980025, ltc: 0.980025 },
    { premium: 7500, db: 0.999994, ltc: 0.999994 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.030822, ltc: 0.974626 },
    { premium: 40000, db: 1.074199, ltc: 0.938912 },
    { premium: 45000, db: 1.107937, ltc: 0.911135 },
    { premium: 50000, db: 1.134927, ltc: 0.888914 },
    { premium: 55000, db: 1.157011, ltc: 0.870733 },
  ],
  "10pay_joint|50|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.980029, ltc: 0.980029 },
    { premium: 7500, db: 0.986595, ltc: 0.986595 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.01648, ltc: 0.989162 },
    { premium: 45000, db: 1.089374, ltc: 0.941201 },
    { premium: 50000, db: 1.14769, ltc: 0.902832 },
    { premium: 55000, db: 1.195402, ltc: 0.871439 },
    { premium: 60000, db: 1.235163, ltc: 0.845278 },
  ],
  "10pay_joint|50|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.070289, ltc: 1 },
    { premium: 7500, db: 0.996651, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010104, ltc: 1 },
    { premium: 15500, db: 1.010111, ltc: 1 },
    { premium: 20000, db: 1.010106, ltc: 1 },
    { premium: 25000, db: 1.010107, ltc: 1 },
    { premium: 30000, db: 1.010108, ltc: 1 },
    { premium: 35000, db: 1.010109, ltc: 1 },
    { premium: 40000, db: 1.010109, ltc: 1 },
    { premium: 45000, db: 1.010109, ltc: 1 },
    { premium: 50000, db: 1.010109, ltc: 1 },
    { premium: 55000, db: 1.057585, ltc: 1 },
    { premium: 60000, db: 1.160553, ltc: 1 },
    { premium: 65000, db: 1.24768, ltc: 1 },
    { premium: 70000, db: 1.322362, ltc: 1 },
    { premium: 75000, db: 1.387085, ltc: 1 },
  ],
  "10pay_joint|50|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979899, ltc: 0.979899 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.004928, ltc: 0.994132 },
    { premium: 45000, db: 1.037222, ltc: 0.95565 },
    { premium: 50000, db: 1.063057, ltc: 0.924863 },
  ],
  "10pay_joint|50|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979904, ltc: 1 },
    { premium: 7500, db: 0.986551, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000005, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000003, ltc: 1 },
    { premium: 40000, db: 1.000004, ltc: 1 },
    { premium: 45000, db: 1.000005, ltc: 1 },
    { premium: 50000, db: 1.000005, ltc: 1 },
    { premium: 55000, db: 1.009948, ltc: 1 },
    { premium: 60000, db: 1.074849, ltc: 1 },
    { premium: 65000, db: 1.129766, ltc: 1 },
  ],
  "10pay_joint|50|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.979973, ltc: 0.979973 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000002, ltc: 1.000002 },
    { premium: 40000, db: 1.000003, ltc: 1.000003 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
    { premium: 50000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_joint|50|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.980033, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000005, ltc: 1 },
    { premium: 30000, db: 1.000004, ltc: 1 },
    { premium: 35000, db: 1.000003, ltc: 1 },
    { premium: 40000, db: 1.000004, ltc: 1 },
    { premium: 45000, db: 1.000004, ltc: 1 },
    { premium: 50000, db: 1.000004, ltc: 1 },
    { premium: 55000, db: 1.000004, ltc: 1 },
  ],
  "10pay_joint|55|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.979972, ltc: 0.979972 },
    { premium: 7500, db: 0.986667, ltc: 0.986667 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000006 },
    { premium: 15500, db: 1.000008, ltc: 1.000008 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.035115, ltc: 0.994411 },
    { premium: 35000, db: 1.138429, ltc: 0.977946 },
    { premium: 40000, db: 1.215915, ltc: 0.965597 },
    { premium: 45000, db: 1.276181, ltc: 0.955993 },
    { premium: 50000, db: 1.324394, ltc: 0.948309 },
    { premium: 55000, db: 1.363839, ltc: 0.942022 },
    { premium: 60000, db: 1.396712, ltc: 0.936783 },
    { premium: 65000, db: 1.424527, ltc: 0.93235 },
  ],
  "10pay_joint|55|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.289073, ltc: 1.289073 },
    { premium: 7500, db: 0.996657, ltc: 0.996657 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010096, ltc: 1.010096 },
    { premium: 15500, db: 1.010101, ltc: 1.010101 },
    { premium: 20000, db: 1.010098, ltc: 1.010098 },
    { premium: 25000, db: 1.0101, ltc: 1.0101 },
    { premium: 30000, db: 1.010101, ltc: 1.010101 },
    { premium: 35000, db: 1.010101, ltc: 1.010101 },
    { premium: 40000, db: 1.068849, ltc: 1.000729 },
    { premium: 45000, db: 1.214117, ltc: 0.977547 },
    { premium: 50000, db: 1.330333, ltc: 0.959001 },
    { premium: 55000, db: 1.425419, ltc: 0.943828 },
    { premium: 60000, db: 1.504657, ltc: 0.931183 },
    { premium: 65000, db: 1.571705, ltc: 0.920484 },
    { premium: 70000, db: 1.629175, ltc: 0.911313 },
    { premium: 75000, db: 1.678982, ltc: 0.903365 },
  ],
  "10pay_joint|55|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.943225, ltc: 1 },
    { premium: 7500, db: 1.295483, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003368, ltc: 1 },
    { premium: 15500, db: 1.003581, ltc: 1 },
    { premium: 20000, db: 1.010094, ltc: 1 },
    { premium: 25000, db: 1.010096, ltc: 1 },
    { premium: 30000, db: 1.010097, ltc: 1 },
    { premium: 35000, db: 1.010098, ltc: 1 },
    { premium: 40000, db: 1.010099, ltc: 1 },
    { premium: 45000, db: 1.010099, ltc: 1 },
    { premium: 50000, db: 1.0101, ltc: 1 },
    { premium: 55000, db: 1.0101, ltc: 1 },
    { premium: 60000, db: 1.108356, ltc: 1 },
    { premium: 65000, db: 1.298659, ltc: 1 },
    { premium: 70000, db: 1.461775, ltc: 1 },
    { premium: 75000, db: 1.603143, ltc: 1 },
  ],
  "10pay_joint|55|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.979976, ltc: 0.979976 },
    { premium: 7500, db: 0.986631, ltc: 0.986631 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.022588, ltc: 0.992266 },
    { premium: 40000, db: 1.093955, ltc: 0.967828 },
    { premium: 45000, db: 1.149465, ltc: 0.948822 },
    { premium: 50000, db: 1.193871, ltc: 0.933616 },
    { premium: 55000, db: 1.230203, ltc: 0.921175 },
    { premium: 60000, db: 1.26048, ltc: 0.910807 },
    { premium: 65000, db: 1.286099, ltc: 0.902034 },
  ],
  "10pay_joint|55|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.3788, ltc: 1 },
    { premium: 7500, db: 0.996678, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010114, ltc: 1 },
    { premium: 15500, db: 1.01011, ltc: 1 },
    { premium: 20000, db: 1.010112, ltc: 1 },
    { premium: 25000, db: 1.010116, ltc: 1 },
    { premium: 30000, db: 1.010114, ltc: 1 },
    { premium: 35000, db: 1.010113, ltc: 1 },
    { premium: 40000, db: 1.010116, ltc: 1 },
    { premium: 45000, db: 1.010114, ltc: 1 },
    { premium: 50000, db: 1.010116, ltc: 1 },
    { premium: 55000, db: 1.021984, ltc: 1 },
    { premium: 60000, db: 1.154319, ltc: 1 },
    { premium: 65000, db: 1.266295, ltc: 1 },
    { premium: 70000, db: 1.362274, ltc: 1 },
    { premium: 75000, db: 1.445456, ltc: 1 },
  ],
  "10pay_joint|55|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979957, ltc: 0.979957 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.02708, ltc: 0.976207 },
    { premium: 50000, db: 1.060638, ltc: 0.946719 },
    { premium: 55000, db: 1.088093, ltc: 0.922592 },
    { premium: 60000, db: 1.110973, ltc: 0.902487 },
  ],
  "10pay_joint|55|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980033, ltc: 1 },
    { premium: 7500, db: 0.986706, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1, ltc: 1 },
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 55000, db: 1.026585, ltc: 1 },
    { premium: 60000, db: 1.085598, ltc: 1 },
    { premium: 65000, db: 1.135532, ltc: 1 },
    { premium: 70000, db: 1.178332, ltc: 1 },
  ],
  "10pay_joint|55|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.151688, ltc: 1.151688 },
    { premium: 7500, db: 0.996618, ltc: 0.996618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010083, ltc: 1.010083 },
    { premium: 15500, db: 1.010084, ltc: 1.010084 },
    { premium: 20000, db: 1.010087, ltc: 1.010087 },
    { premium: 25000, db: 1.108023, ltc: 1.014613 },
    { premium: 30000, db: 1.277182, ltc: 1.022426 },
    { premium: 35000, db: 1.398011, ltc: 1.028006 },
    { premium: 40000, db: 1.488632, ltc: 1.032192 },
    { premium: 45000, db: 1.559115, ltc: 1.035447 },
    { premium: 50000, db: 1.615499, ltc: 1.03805 },
    { premium: 55000, db: 1.661634, ltc: 1.040181 },
    { premium: 60000, db: 1.700079, ltc: 1.041957 },
    { premium: 65000, db: 1.73261, ltc: 1.04346 },
  ],
  "10pay_joint|55|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.629099, ltc: 1.629099 },
    { premium: 7500, db: 1.086066, ltc: 1.086066 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003383, ltc: 1.003383 },
    { premium: 15500, db: 1.003573, ltc: 1.003573 },
    { premium: 20000, db: 1.010107, ltc: 1.010107 },
    { premium: 25000, db: 1.010109, ltc: 1.010109 },
    { premium: 30000, db: 1.010105, ltc: 1.010105 },
    { premium: 35000, db: 1.166588, ltc: 1.009397 },
    { premium: 40000, db: 1.396157, ltc: 1.008354 },
    { premium: 45000, db: 1.574711, ltc: 1.007542 },
    { premium: 50000, db: 1.717555, ltc: 1.006892 },
    { premium: 55000, db: 1.834426, ltc: 1.006361 },
    { premium: 60000, db: 1.93182, ltc: 1.005918 },
    { premium: 65000, db: 2.014229, ltc: 1.005544 },
    { premium: 70000, db: 2.084866, ltc: 1.005223 },
    { premium: 75000, db: 2.146082, ltc: 1.004944 },
  ],
  "10pay_joint|55|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.776176, ltc: 1 },
    { premium: 15500, db: 0.776348, ltc: 1 },
    { premium: 20000, db: 0.777462, ltc: 1 },
    { premium: 25000, db: 0.77825, ltc: 1 },
    { premium: 30000, db: 0.781382, ltc: 1 },
    { premium: 35000, db: 0.781385, ltc: 1 },
    { premium: 40000, db: 0.781382, ltc: 1 },
    { premium: 45000, db: 0.781384, ltc: 1 },
    { premium: 50000, db: 0.781382, ltc: 1 },
    { premium: 55000, db: 0.982873, ltc: 1 },
    { premium: 60000, db: 1.208213, ltc: 1 },
    { premium: 65000, db: 1.398885, ltc: 1 },
    { premium: 70000, db: 1.562315, ltc: 1 },
    { premium: 75000, db: 1.703958, ltc: 1 },
  ],
  "10pay_joint|55|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.990385, ltc: 0.990385 },
    { premium: 7500, db: 0.986655, ltc: 0.986655 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000006, ltc: 1.000006 },
    { premium: 30000, db: 1.10481, ltc: 0.992498 },
    { premium: 35000, db: 1.214791, ltc: 0.984618 },
    { premium: 40000, db: 1.297277, ltc: 0.978708 },
    { premium: 45000, db: 1.361433, ltc: 0.974112 },
    { premium: 50000, db: 1.412758, ltc: 0.970434 },
    { premium: 55000, db: 1.454751, ltc: 0.967426 },
    { premium: 60000, db: 1.489746, ltc: 0.964919 },
    { premium: 65000, db: 1.519357, ltc: 0.962798 },
  ],
  "10pay_joint|55|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.767679, ltc: 1 },
    { premium: 7500, db: 1.178453, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003399, ltc: 1 },
    { premium: 15500, db: 1.003577, ltc: 1 },
    { premium: 20000, db: 1.01011, ltc: 1 },
    { premium: 25000, db: 1.010114, ltc: 1 },
    { premium: 30000, db: 1.010116, ltc: 1 },
    { premium: 35000, db: 1.010113, ltc: 1 },
    { premium: 40000, db: 1.010115, ltc: 1 },
    { premium: 45000, db: 1.010116, ltc: 1 },
    { premium: 50000, db: 1.166106, ltc: 1 },
    { premium: 55000, db: 1.364303, ltc: 1 },
    { premium: 60000, db: 1.529467, ltc: 1 },
    { premium: 65000, db: 1.669221, ltc: 1 },
    { premium: 70000, db: 1.789011, ltc: 1 },
    { premium: 75000, db: 1.89283, ltc: 1 },
  ],
  "10pay_joint|55|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.980035, ltc: 0.980035 },
    { premium: 7500, db: 0.986614, ltc: 0.986614 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
    { premium: 35000, db: 1.057395, ltc: 0.974871 },
    { premium: 40000, db: 1.116857, ltc: 0.948831 },
    { premium: 45000, db: 1.163106, ltc: 0.928577 },
    { premium: 50000, db: 1.200105, ltc: 0.912374 },
    { premium: 55000, db: 1.230376, ltc: 0.899117 },
    { premium: 60000, db: 1.255603, ltc: 0.88807 },
  ],
  "10pay_joint|55|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 1.070501, ltc: 1 },
    { premium: 7500, db: 0.996643, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.0101, ltc: 1 },
    { premium: 15500, db: 1.010102, ltc: 1 },
    { premium: 20000, db: 1.010104, ltc: 1 },
    { premium: 25000, db: 1.010106, ltc: 1 },
    { premium: 30000, db: 1.010104, ltc: 1 },
    { premium: 35000, db: 1.010105, ltc: 1 },
    { premium: 40000, db: 1.010104, ltc: 1 },
    { premium: 45000, db: 1.073553, ltc: 1 },
    { premium: 50000, db: 1.17635, ltc: 1 },
    { premium: 55000, db: 1.260458, ltc: 1 },
    { premium: 60000, db: 1.330547, ltc: 1 },
    { premium: 65000, db: 1.389853, ltc: 1 },
    { premium: 70000, db: 1.440687, ltc: 1 },
  ],
  "10pay_joint|55|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979995, ltc: 0.979995 },
    { premium: 7500, db: 0.98662, ltc: 0.98662 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.020388, ltc: 0.984696 },
    { premium: 45000, db: 1.062536, ltc: 0.953047 },
    { premium: 50000, db: 1.096253, ltc: 0.927728 },
    { premium: 55000, db: 1.123841, ltc: 0.907013 },
    { premium: 60000, db: 1.14683, ltc: 0.88975 },
    { premium: 65000, db: 1.166282, ltc: 0.875143 },
  ],
  "10pay_joint|55|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.980034, ltc: 0.980034 },
    { premium: 7500, db: 0.986705, ltc: 0.986705 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000001, ltc: 1.000001 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
    { premium: 50000, db: 1.051073, ltc: 0.96916 },
    { premium: 55000, db: 1.111093, ltc: 0.932912 },
    { premium: 60000, db: 1.16111, ltc: 0.902705 },
    { premium: 65000, db: 1.203431, ltc: 0.877146 },
    { premium: 70000, db: 1.239706, ltc: 0.855237 },
  ],
  "10pay_joint|55|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.27959, ltc: 1 },
    { premium: 7500, db: 0.996644, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010112, ltc: 1 },
    { premium: 15500, db: 1.010107, ltc: 1 },
    { premium: 20000, db: 1.010114, ltc: 1 },
    { premium: 25000, db: 1.01011, ltc: 1 },
    { premium: 30000, db: 1.010112, ltc: 1 },
    { premium: 35000, db: 1.010113, ltc: 1 },
    { premium: 40000, db: 1.010114, ltc: 1 },
    { premium: 45000, db: 1.010112, ltc: 1 },
    { premium: 50000, db: 1.010112, ltc: 1 },
    { premium: 55000, db: 1.010113, ltc: 1 },
    { premium: 60000, db: 1.010114, ltc: 1 },
    { premium: 65000, db: 1.044765, ltc: 1 },
    { premium: 70000, db: 1.138624, ltc: 1 },
    { premium: 75000, db: 1.219967, ltc: 1 },
  ],
  "10pay_joint|55|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.980059, ltc: 0.980059 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.000001, ltc: 1.000001 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000001, ltc: 1.000001 },
    { premium: 50000, db: 1.023686, ltc: 0.973911 },
    { premium: 55000, db: 1.049915, ltc: 0.945019 },
    { premium: 60000, db: 1.071772, ltc: 0.920943 },
  ],
  "10pay_joint|55|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.980006, ltc: 1 },
    { premium: 7500, db: 0.986613, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000003, ltc: 1 },
    { premium: 40000, db: 1.000002, ltc: 1 },
    { premium: 45000, db: 1.000002, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.000004, ltc: 1 },
    { premium: 60000, db: 1.000003, ltc: 1 },
    { premium: 65000, db: 1.007738, ltc: 1 },
    { premium: 70000, db: 1.066376, ltc: 1 },
    { premium: 75000, db: 1.117195, ltc: 1 },
  ],
  "10pay_joint|55|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.979934, ltc: 0.979934 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.000005, ltc: 1.000005 },
    { premium: 45000, db: 1.000004, ltc: 1.000004 },
    { premium: 50000, db: 1.000004, ltc: 1.000004 },
    { premium: 55000, db: 1.000004, ltc: 1.000004 },
    { premium: 60000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_joint|55|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.979975, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1 },
    { premium: 40000, db: 1.000004, ltc: 1 },
    { premium: 45000, db: 1.000003, ltc: 1 },
    { premium: 50000, db: 1.000003, ltc: 1 },
    { premium: 55000, db: 1.000003, ltc: 1 },
    { premium: 60000, db: 1.000004, ltc: 1 },
    { premium: 65000, db: 1.000003, ltc: 1 },
    { premium: 70000, db: 1.000003, ltc: 1 },
  ],
  "10pay_joint|60|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 1.143403, ltc: 1.143403 },
    { premium: 7500, db: 0.99659, ltc: 0.99659 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010078, ltc: 1.010078 },
    { premium: 15500, db: 1.010077, ltc: 1.010077 },
    { premium: 20000, db: 1.010076, ltc: 1.010076 },
    { premium: 25000, db: 1.010075, ltc: 1.010075 },
    { premium: 30000, db: 1.010075, ltc: 1.010075 },
    { premium: 35000, db: 1.034203, ltc: 1.007004 },
    { premium: 40000, db: 1.131806, ltc: 0.994567 },
    { premium: 45000, db: 1.207719, ltc: 0.984894 },
    { premium: 50000, db: 1.268451, ltc: 0.977157 },
    { premium: 55000, db: 1.31814, ltc: 0.970826 },
    { premium: 60000, db: 1.359547, ltc: 0.96555 },
    { premium: 65000, db: 1.394583, ltc: 0.961085 },
    { premium: 70000, db: 1.424616, ltc: 0.957259 },
    { premium: 75000, db: 1.450643, ltc: 0.953943 },
  ],
  "10pay_joint|60|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.536589, ltc: 1.536589 },
    { premium: 7500, db: 1.024393, ltc: 1.024393 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003395, ltc: 1.003395 },
    { premium: 15500, db: 1.010122, ltc: 1.010122 },
    { premium: 20000, db: 1.010125, ltc: 1.010125 },
    { premium: 25000, db: 1.010125, ltc: 1.010125 },
    { premium: 30000, db: 1.010125, ltc: 1.010125 },
    { premium: 35000, db: 1.010125, ltc: 1.010125 },
    { premium: 40000, db: 1.010125, ltc: 1.010125 },
    { premium: 45000, db: 1.010125, ltc: 1.010125 },
    { premium: 50000, db: 1.135056, ltc: 0.992914 },
    { premium: 55000, db: 1.253642, ltc: 0.976574 },
    { premium: 60000, db: 1.352464, ltc: 0.962956 },
    { premium: 65000, db: 1.436085, ltc: 0.951435 },
    { premium: 70000, db: 1.507758, ltc: 0.941559 },
    { premium: 75000, db: 1.569874, ltc: 0.932999 },
  ],
  "10pay_joint|60|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.855065, ltc: 1 },
    { premium: 15500, db: 0.855248, ltc: 1 },
    { premium: 20000, db: 0.856491, ltc: 1 },
    { premium: 25000, db: 0.860811, ltc: 1 },
    { premium: 30000, db: 0.860811, ltc: 1 },
    { premium: 35000, db: 0.860811, ltc: 1 },
    { premium: 40000, db: 0.860811, ltc: 1 },
    { premium: 45000, db: 0.860811, ltc: 1 },
    { premium: 50000, db: 0.860811, ltc: 1 },
    { premium: 55000, db: 0.860811, ltc: 1 },
    { premium: 60000, db: 0.860811, ltc: 1 },
    { premium: 65000, db: 0.860811, ltc: 1 },
    { premium: 70000, db: 0.870865, ltc: 1 },
    { premium: 75000, db: 1.024497, ltc: 1 },
  ],
  "10pay_joint|60|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.99958, ltc: 0.99958 },
    { premium: 7500, db: 0.986661, ltc: 0.986661 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1.000377, ltc: 0.999889 },
    { premium: 45000, db: 1.070225, ltc: 0.97929 },
    { premium: 50000, db: 1.126104, ltc: 0.962812 },
    { premium: 55000, db: 1.171824, ltc: 0.94933 },
    { premium: 60000, db: 1.209922, ltc: 0.938095 },
    { premium: 65000, db: 1.242161, ltc: 0.928588 },
    { premium: 70000, db: 1.269792, ltc: 0.920439 },
    { premium: 75000, db: 1.293741, ltc: 0.913377 },
  ],
  "10pay_joint|60|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.659802, ltc: 1 },
    { premium: 7500, db: 1.106535, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00338, ltc: 1 },
    { premium: 15500, db: 1.003571, ltc: 1 },
    { premium: 20000, db: 1.010106, ltc: 1 },
    { premium: 25000, db: 1.0101, ltc: 1 },
    { premium: 30000, db: 1.010101, ltc: 1 },
    { premium: 35000, db: 1.010102, ltc: 1 },
    { premium: 40000, db: 1.010102, ltc: 1 },
    { premium: 45000, db: 1.010103, ltc: 1 },
    { premium: 50000, db: 1.010103, ltc: 1 },
    { premium: 55000, db: 1.010103, ltc: 1 },
    { premium: 60000, db: 1.010104, ltc: 1 },
    { premium: 65000, db: 1.010104, ltc: 1 },
    { premium: 70000, db: 1.11383, ltc: 1 },
    { premium: 75000, db: 1.219907, ltc: 1 },
  ],
  "10pay_joint|60|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.980016, ltc: 0.980016 },
    { premium: 7500, db: 0.986623, ltc: 0.986623 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1, ltc: 1 },
    { premium: 50000, db: 1.006636, ltc: 0.994718 },
    { premium: 55000, db: 1.041105, ltc: 0.96728 },
    { premium: 60000, db: 1.069828, ltc: 0.944414 },
    { premium: 65000, db: 1.094132, ltc: 0.925066 },
    { premium: 70000, db: 1.114965, ltc: 0.908483 },
  ],
  "10pay_joint|60|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 1.069498, ltc: 1 },
    { premium: 7500, db: 0.996636, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010107, ltc: 1 },
    { premium: 15500, db: 1.010103, ltc: 1 },
    { premium: 20000, db: 1.010104, ltc: 1 },
    { premium: 25000, db: 1.010106, ltc: 1 },
    { premium: 30000, db: 1.010104, ltc: 1 },
    { premium: 35000, db: 1.010105, ltc: 1 },
    { premium: 40000, db: 1.010107, ltc: 1 },
    { premium: 45000, db: 1.010105, ltc: 1 },
    { premium: 50000, db: 1.010106, ltc: 1 },
    { premium: 55000, db: 1.010107, ltc: 1 },
    { premium: 60000, db: 1.010106, ltc: 1 },
    { premium: 65000, db: 1.028423, ltc: 1 },
    { premium: 70000, db: 1.084189, ltc: 1 },
    { premium: 75000, db: 1.132518, ltc: 1 },
  ],
  "10pay_joint|60|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.375091, ltc: 1.375091 },
    { premium: 7500, db: 0.996595, ltc: 0.996595 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010077, ltc: 1.010077 },
    { premium: 15500, db: 1.010073, ltc: 1.010073 },
    { premium: 20000, db: 1.010071, ltc: 1.010071 },
    { premium: 25000, db: 1.010077, ltc: 1.010077 },
    { premium: 30000, db: 1.118683, ltc: 1.017614 },
    { premium: 35000, db: 1.270719, ltc: 1.028164 },
    { premium: 40000, db: 1.384746, ltc: 1.036077 },
    { premium: 45000, db: 1.473436, ltc: 1.042233 },
    { premium: 50000, db: 1.544386, ltc: 1.047156 },
    { premium: 55000, db: 1.602436, ltc: 1.051184 },
    { premium: 60000, db: 1.65081, ltc: 1.054541 },
    { premium: 65000, db: 1.691745, ltc: 1.057383 },
    { premium: 70000, db: 1.72683, ltc: 1.059817 },
    { premium: 75000, db: 1.757237, ltc: 1.061927 },
  ],
  "10pay_joint|60|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.952329, ltc: 1.952329 },
    { premium: 7500, db: 1.301553, ltc: 1.301553 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003358, ltc: 1.003358 },
    { premium: 15500, db: 1.003611, ltc: 1.003611 },
    { premium: 20000, db: 1.010102, ltc: 1.010102 },
    { premium: 25000, db: 1.010104, ltc: 1.010104 },
    { premium: 30000, db: 1.010106, ltc: 1.010106 },
    { premium: 35000, db: 1.010106, ltc: 1.010106 },
    { premium: 40000, db: 1.080521, ltc: 1.010885 },
    { premium: 45000, db: 1.304867, ltc: 1.013366 },
    { premium: 50000, db: 1.48434, ltc: 1.015349 },
    { premium: 55000, db: 1.631182, ltc: 1.016972 },
    { premium: 60000, db: 1.75355, ltc: 1.018324 },
    { premium: 65000, db: 1.857095, ltc: 1.019469 },
    { premium: 70000, db: 1.945845, ltc: 1.02045 },
    { premium: 75000, db: 2.022762, ltc: 1.0213 },
  ],
  "10pay_joint|60|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.666667, ltc: 1 },
    { premium: 15500, db: 0.645161, ltc: 1 },
    { premium: 20000, db: 0.640539, ltc: 1 },
    { premium: 25000, db: 0.641173, ltc: 1 },
    { premium: 30000, db: 0.641609, ltc: 1 },
    { premium: 35000, db: 0.64376, ltc: 1 },
    { premium: 40000, db: 0.643758, ltc: 1 },
    { premium: 45000, db: 0.643757, ltc: 1 },
    { premium: 50000, db: 0.643756, ltc: 1 },
    { premium: 55000, db: 0.643759, ltc: 1 },
    { premium: 60000, db: 0.643758, ltc: 1 },
    { premium: 65000, db: 0.75554, ltc: 1 },
    { premium: 70000, db: 0.928383, ltc: 1 },
    { premium: 75000, db: 1.07818, ltc: 1 },
  ],
  "10pay_joint|60|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 1.18768, ltc: 1.18768 },
    { premium: 7500, db: 0.996636, ltc: 0.996636 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010117, ltc: 1.010117 },
    { premium: 15500, db: 1.010113, ltc: 1.010113 },
    { premium: 20000, db: 1.010117, ltc: 1.010117 },
    { premium: 25000, db: 1.010117, ltc: 1.010117 },
    { premium: 30000, db: 1.010117, ltc: 1.010117 },
    { premium: 35000, db: 1.106703, ltc: 1.005693 },
    { premium: 40000, db: 1.210294, ltc: 1.000945 },
    { premium: 45000, db: 1.290867, ltc: 0.997254 },
    { premium: 50000, db: 1.355325, ltc: 0.994302 },
    { premium: 55000, db: 1.408062, ltc: 0.991885 },
    { premium: 60000, db: 1.452011, ltc: 0.989872 },
    { premium: 65000, db: 1.489197, ltc: 0.988167 },
    { premium: 70000, db: 1.521073, ltc: 0.986707 },
    { premium: 75000, db: 1.548698, ltc: 0.985442 },
  ],
  "10pay_joint|60|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.942471, ltc: 1 },
    { premium: 15500, db: 0.942647, ltc: 1 },
    { premium: 20000, db: 0.944024, ltc: 1 },
    { premium: 25000, db: 0.94878, ltc: 1 },
    { premium: 30000, db: 0.948777, ltc: 1 },
    { premium: 35000, db: 0.948776, ltc: 1 },
    { premium: 40000, db: 0.948779, ltc: 1 },
    { premium: 45000, db: 0.948777, ltc: 1 },
    { premium: 50000, db: 0.94878, ltc: 1 },
    { premium: 55000, db: 0.948779, ltc: 1 },
    { premium: 60000, db: 1.094829, ltc: 1 },
    { premium: 65000, db: 1.261358, ltc: 1 },
    { premium: 70000, db: 1.404099, ltc: 1 },
    { premium: 75000, db: 1.527808, ltc: 1 },
  ],
  "10pay_joint|60|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979979, ltc: 0.979979 },
    { premium: 7500, db: 0.986665, ltc: 0.986665 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000006 },
    { premium: 15500, db: 1.000005, ltc: 1.000005 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
    { premium: 35000, db: 1.000005, ltc: 1.000005 },
    { premium: 40000, db: 1.042305, ltc: 0.983756 },
    { premium: 45000, db: 1.100436, ltc: 0.961421 },
    { premium: 50000, db: 1.146941, ltc: 0.943553 },
    { premium: 55000, db: 1.184992, ltc: 0.928935 },
    { premium: 60000, db: 1.2167, ltc: 0.916752 },
    { premium: 65000, db: 1.243531, ltc: 0.906445 },
    { premium: 70000, db: 1.266528, ltc: 0.897609 },
  ],
  "10pay_joint|60|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 1.282987, ltc: 1 },
    { premium: 7500, db: 0.996571, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010083, ltc: 1 },
    { premium: 15500, db: 1.010083, ltc: 1 },
    { premium: 20000, db: 1.010083, ltc: 1 },
    { premium: 25000, db: 1.010083, ltc: 1 },
    { premium: 30000, db: 1.010083, ltc: 1 },
    { premium: 35000, db: 1.010083, ltc: 1 },
    { premium: 40000, db: 1.010083, ltc: 1 },
    { premium: 45000, db: 1.010083, ltc: 1 },
    { premium: 50000, db: 1.010083, ltc: 1 },
    { premium: 55000, db: 1.098704, ltc: 1 },
    { premium: 60000, db: 1.188025, ltc: 1 },
    { premium: 65000, db: 1.263605, ltc: 1 },
    { premium: 70000, db: 1.32839, ltc: 1 },
    { premium: 75000, db: 1.384534, ltc: 1 },
  ],
  "10pay_joint|60|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.980024, ltc: 0.980024 },
    { premium: 7500, db: 0.986698, ltc: 0.986698 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000001, ltc: 1.000001 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.001042, ltc: 0.999301 },
    { premium: 50000, db: 1.043491, ltc: 0.970647 },
    { premium: 55000, db: 1.078224, ltc: 0.947204 },
    { premium: 60000, db: 1.107166, ltc: 0.927668 },
    { premium: 65000, db: 1.131656, ltc: 0.911137 },
    { premium: 70000, db: 1.152648, ltc: 0.896968 },
    { premium: 75000, db: 1.170841, ltc: 0.884688 },
  ],
  "10pay_joint|60|None|None|25 Months|50 Months": [
    { premium: 5000, db: 1.117585, ltc: 1.117585 },
    { premium: 7500, db: 0.996696, ltc: 0.996696 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010127, ltc: 1.010127 },
    { premium: 15500, db: 1.010128, ltc: 1.010128 },
    { premium: 20000, db: 1.010129, ltc: 1.010129 },
    { premium: 25000, db: 1.010126, ltc: 1.010126 },
    { premium: 30000, db: 1.010127, ltc: 1.010127 },
    { premium: 35000, db: 1.010128, ltc: 1.010128 },
    { premium: 40000, db: 1.010129, ltc: 1.010129 },
    { premium: 45000, db: 1.01013, ltc: 1.01013 },
    { premium: 50000, db: 1.010128, ltc: 1.010128 },
    { premium: 55000, db: 1.010129, ltc: 1.010129 },
    { premium: 60000, db: 1.069856, ltc: 0.9774 },
    { premium: 65000, db: 1.124038, ltc: 0.947708 },
    { premium: 70000, db: 1.170479, ltc: 0.922258 },
    { premium: 75000, db: 1.210729, ltc: 0.900201 },
  ],
  "10pay_joint|60|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.544205, ltc: 1 },
    { premium: 7500, db: 1.02947, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003325, ltc: 1 },
    { premium: 15500, db: 1.010088, ltc: 1 },
    { premium: 20000, db: 1.010082, ltc: 1 },
    { premium: 25000, db: 1.010086, ltc: 1 },
    { premium: 30000, db: 1.010088, ltc: 1 },
    { premium: 35000, db: 1.010085, ltc: 1 },
    { premium: 40000, db: 1.010086, ltc: 1 },
    { premium: 45000, db: 1.010088, ltc: 1 },
    { premium: 50000, db: 1.010086, ltc: 1 },
    { premium: 55000, db: 1.010087, ltc: 1 },
    { premium: 60000, db: 1.010088, ltc: 1 },
    { premium: 65000, db: 1.010086, ltc: 1 },
    { premium: 70000, db: 1.010087, ltc: 1 },
    { premium: 75000, db: 1.010088, ltc: 1 },
  ],
  "10pay_joint|60|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.97997, ltc: 0.97997 },
    { premium: 7500, db: 0.986706, ltc: 0.986706 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1, ltc: 1 },
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 55000, db: 1.003254, ltc: 0.996718 },
    { premium: 60000, db: 1.030612, ltc: 0.96914 },
    { premium: 65000, db: 1.05376, ltc: 0.945803 },
    { premium: 70000, db: 1.073602, ltc: 0.925801 },
  ],
  "10pay_joint|60|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 1.16649, ltc: 1 },
    { premium: 7500, db: 0.99666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1 },
    { premium: 15500, db: 1.010131, ltc: 1 },
    { premium: 20000, db: 1.010135, ltc: 1 },
    { premium: 25000, db: 1.010135, ltc: 1 },
    { premium: 30000, db: 1.010135, ltc: 1 },
    { premium: 35000, db: 1.010135, ltc: 1 },
    { premium: 40000, db: 1.010135, ltc: 1 },
    { premium: 45000, db: 1.010135, ltc: 1 },
    { premium: 50000, db: 1.010135, ltc: 1 },
    { premium: 55000, db: 1.010135, ltc: 1 },
    { premium: 60000, db: 1.010135, ltc: 1 },
    { premium: 65000, db: 1.010135, ltc: 1 },
    { premium: 70000, db: 1.010135, ltc: 1 },
    { premium: 75000, db: 1.010135, ltc: 1 },
  ],
  "10pay_joint|60|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.980022, ltc: 0.980022 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000002, ltc: 1.000002 },
    { premium: 50000, db: 1.000003, ltc: 1.000003 },
    { premium: 55000, db: 1.000002, ltc: 1.000002 },
    { premium: 60000, db: 1.000002, ltc: 1.000002 },
    { premium: 65000, db: 1.000003, ltc: 1.000003 },
    { premium: 70000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_joint|60|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.980047, ltc: 1 },
    { premium: 7500, db: 0.986656, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000005, ltc: 1 },
    { premium: 30000, db: 1.000006, ltc: 1 },
    { premium: 35000, db: 1.000006, ltc: 1 },
    { premium: 40000, db: 1.000006, ltc: 1 },
    { premium: 45000, db: 1.000006, ltc: 1 },
    { premium: 50000, db: 1.000007, ltc: 1 },
    { premium: 55000, db: 1.000007, ltc: 1 },
    { premium: 60000, db: 1.000006, ltc: 1 },
    { premium: 65000, db: 1.000006, ltc: 1 },
    { premium: 70000, db: 1.000006, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1 },
  ],
  "10pay_joint|65|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 1.340994, ltc: 1.340994 },
    { premium: 7500, db: 0.996648, ltc: 0.996648 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010092, ltc: 1.010092 },
    { premium: 15500, db: 1.010094, ltc: 1.010094 },
    { premium: 20000, db: 1.010096, ltc: 1.010096 },
    { premium: 25000, db: 1.010099, ltc: 1.010099 },
    { premium: 30000, db: 1.010096, ltc: 1.010096 },
    { premium: 35000, db: 1.010098, ltc: 1.010098 },
    { premium: 40000, db: 1.013921, ltc: 1.009763 },
    { premium: 45000, db: 1.108957, ltc: 1.001414 },
    { premium: 50000, db: 1.184986, ltc: 0.994735 },
    { premium: 55000, db: 1.247191, ltc: 0.98927 },
    { premium: 60000, db: 1.299029, ltc: 0.984716 },
    { premium: 65000, db: 1.342889, ltc: 0.980862 },
    { premium: 70000, db: 1.380486, ltc: 0.977559 },
    { premium: 75000, db: 1.41307, ltc: 0.974696 },
  ],
  "10pay_joint|65|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.836403, ltc: 1.836403 },
    { premium: 7500, db: 1.224268, ltc: 1.224268 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003385, ltc: 1.003385 },
    { premium: 15500, db: 1.003605, ltc: 1.003605 },
    { premium: 20000, db: 1.010126, ltc: 1.010126 },
    { premium: 25000, db: 1.010124, ltc: 1.010124 },
    { premium: 30000, db: 1.010123, ltc: 1.010123 },
    { premium: 35000, db: 1.010127, ltc: 1.010127 },
    { premium: 40000, db: 1.010126, ltc: 1.010126 },
    { premium: 45000, db: 1.010125, ltc: 1.010125 },
    { premium: 50000, db: 1.010124, ltc: 1.010124 },
    { premium: 55000, db: 1.02334, ltc: 1.008789 },
    { premium: 60000, db: 1.151375, ltc: 0.995828 },
    { premium: 65000, db: 1.259712, ltc: 0.984861 },
    { premium: 70000, db: 1.352572, ltc: 0.97546 },
    { premium: 75000, db: 1.433049, ltc: 0.967312 },
  ],
  "10pay_joint|65|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.708369, ltc: 1 },
    { premium: 15500, db: 0.70851, ltc: 1 },
    { premium: 20000, db: 0.709549, ltc: 1 },
    { premium: 25000, db: 0.710257, ltc: 1 },
    { premium: 30000, db: 0.713115, ltc: 1 },
    { premium: 35000, db: 0.713117, ltc: 1 },
    { premium: 40000, db: 0.713119, ltc: 1 },
    { premium: 45000, db: 0.713115, ltc: 1 },
    { premium: 50000, db: 0.713117, ltc: 1 },
    { premium: 55000, db: 0.713118, ltc: 1 },
    { premium: 60000, db: 0.713119, ltc: 1 },
    { premium: 65000, db: 0.713116, ltc: 1 },
    { premium: 70000, db: 0.713117, ltc: 1 },
    { premium: 75000, db: 0.713118, ltc: 1 },
  ],
  "10pay_joint|65|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 1.180991, ltc: 1.180991 },
    { premium: 7500, db: 0.996627, ltc: 0.996627 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1.010095 },
    { premium: 15500, db: 1.010099, ltc: 1.010099 },
    { premium: 20000, db: 1.010101, ltc: 1.010101 },
    { premium: 25000, db: 1.0101, ltc: 1.0101 },
    { premium: 30000, db: 1.010099, ltc: 1.010099 },
    { premium: 35000, db: 1.010098, ltc: 1.010098 },
    { premium: 40000, db: 1.010101, ltc: 1.010101 },
    { premium: 45000, db: 1.0101, ltc: 1.0101 },
    { premium: 50000, db: 1.054376, ltc: 0.999471 },
    { premium: 55000, db: 1.112389, ltc: 0.985543 },
    { premium: 60000, db: 1.160736, ltc: 0.973937 },
    { premium: 65000, db: 1.201642, ltc: 0.964116 },
    { premium: 70000, db: 1.236705, ltc: 0.955697 },
    { premium: 75000, db: 1.267093, ltc: 0.948402 },
  ],
  "10pay_joint|65|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.99231, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003373, ltc: 1 },
    { premium: 15500, db: 1.003574, ltc: 1 },
    { premium: 20000, db: 1.01009, ltc: 1 },
    { premium: 25000, db: 1.010096, ltc: 1 },
    { premium: 30000, db: 1.010093, ltc: 1 },
    { premium: 35000, db: 1.010091, ltc: 1 },
    { premium: 40000, db: 1.010095, ltc: 1 },
    { premium: 45000, db: 1.010093, ltc: 1 },
    { premium: 50000, db: 1.010092, ltc: 1 },
    { premium: 55000, db: 1.010095, ltc: 1 },
    { premium: 60000, db: 1.010093, ltc: 1 },
    { premium: 65000, db: 1.010095, ltc: 1 },
    { premium: 70000, db: 1.010094, ltc: 1 },
    { premium: 75000, db: 1.010096, ltc: 1 },
  ],
  "10pay_joint|65|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979942, ltc: 0.979942 },
    { premium: 7500, db: 0.986647, ltc: 0.986647 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000006 },
    { premium: 15500, db: 1.000007, ltc: 1.000007 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
    { premium: 35000, db: 1.000005, ltc: 1.000005 },
    { premium: 40000, db: 1.000007, ltc: 1.000007 },
    { premium: 45000, db: 1.000006, ltc: 1.000006 },
    { premium: 50000, db: 1.000006, ltc: 1.000006 },
    { premium: 55000, db: 1.000007, ltc: 1.000007 },
    { premium: 60000, db: 1.019724, ltc: 0.986515 },
    { premium: 65000, db: 1.050684, ltc: 0.96533 },
    { premium: 70000, db: 1.077222, ltc: 0.947171 },
    { premium: 75000, db: 1.100221, ltc: 0.931433 },
  ],
  "10pay_joint|65|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 1.258788, ltc: 1 },
    { premium: 7500, db: 0.996673, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010114, ltc: 1 },
    { premium: 15500, db: 1.010121, ltc: 1 },
    { premium: 20000, db: 1.010118, ltc: 1 },
    { premium: 25000, db: 1.010121, ltc: 1 },
    { premium: 30000, db: 1.010118, ltc: 1 },
    { premium: 35000, db: 1.01012, ltc: 1 },
    { premium: 40000, db: 1.010122, ltc: 1 },
    { premium: 45000, db: 1.01012, ltc: 1 },
    { premium: 50000, db: 1.010121, ltc: 1 },
    { premium: 55000, db: 1.010122, ltc: 1 },
    { premium: 60000, db: 1.010121, ltc: 1 },
    { premium: 65000, db: 1.010121, ltc: 1 },
    { premium: 70000, db: 1.01012, ltc: 1 },
    { premium: 75000, db: 1.012967, ltc: 1 },
  ],
  "10pay_joint|65|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.608298, ltc: 1.608298 },
    { premium: 7500, db: 1.072199, ltc: 1.072199 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003372, ltc: 1.003372 },
    { premium: 15500, db: 1.003613, ltc: 1.003613 },
    { premium: 20000, db: 1.010115, ltc: 1.010115 },
    { premium: 25000, db: 1.010115, ltc: 1.010115 },
    { premium: 30000, db: 1.010115, ltc: 1.010115 },
    { premium: 35000, db: 1.121327, ltc: 1.020122 },
    { premium: 40000, db: 1.261397, ltc: 1.032725 },
    { premium: 45000, db: 1.370338, ltc: 1.042525 },
    { premium: 50000, db: 1.457493, ltc: 1.050367 },
    { premium: 55000, db: 1.528802, ltc: 1.056784 },
    { premium: 60000, db: 1.588226, ltc: 1.06213 },
    { premium: 65000, db: 1.638508, ltc: 1.066655 },
    { premium: 70000, db: 1.681607, ltc: 1.070533 },
    { premium: 75000, db: 1.718957, ltc: 1.073892 },
  ],
  "10pay_joint|65|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 2, ltc: 2 },
    { premium: 7500, db: 1.333333, ltc: 1.333333 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.866029, ltc: 0.866029 },
    { premium: 15500, db: 0.866219, ltc: 0.866219 },
    { premium: 20000, db: 0.867496, ltc: 0.867496 },
    { premium: 25000, db: 0.871847, ltc: 0.871847 },
    { premium: 30000, db: 0.871849, ltc: 0.871849 },
    { premium: 35000, db: 0.871844, ltc: 0.871844 },
    { premium: 40000, db: 0.871845, ltc: 0.871845 },
    { premium: 45000, db: 0.871846, ltc: 0.871846 },
    { premium: 50000, db: 1.02996, ltc: 0.876589 },
    { premium: 55000, db: 1.189774, ltc: 0.881382 },
    { premium: 60000, db: 1.322948, ltc: 0.885374 },
    { premium: 65000, db: 1.435637, ltc: 0.888753 },
    { premium: 70000, db: 1.532228, ltc: 0.891649 },
    { premium: 75000, db: 1.615939, ltc: 0.894159 },
  ],
  "10pay_joint|65|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.666667, ltc: 1 },
    { premium: 15500, db: 0.645161, ltc: 1 },
    { premium: 20000, db: 0.531969, ltc: 1 },
    { premium: 25000, db: 0.532515, ltc: 1 },
    { premium: 30000, db: 0.532865, ltc: 1 },
    { premium: 35000, db: 0.533127, ltc: 1 },
    { premium: 40000, db: 0.534649, ltc: 1 },
    { premium: 45000, db: 0.53465, ltc: 1 },
    { premium: 50000, db: 0.534651, ltc: 1 },
    { premium: 55000, db: 0.534651, ltc: 1 },
    { premium: 60000, db: 0.534652, ltc: 1 },
    { premium: 65000, db: 0.534649, ltc: 1 },
    { premium: 70000, db: 0.53465, ltc: 1 },
    { premium: 75000, db: 0.540301, ltc: 1 },
  ],
  "10pay_joint|65|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 1.391906, ltc: 1.391906 },
    { premium: 7500, db: 0.996632, ltc: 0.996632 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010095, ltc: 1.010095 },
    { premium: 15500, db: 1.010095, ltc: 1.010095 },
    { premium: 20000, db: 1.01009, ltc: 1.01009 },
    { premium: 30000, db: 1.010095, ltc: 1.010095 },
    { premium: 35000, db: 1.010096, ltc: 1.010096 },
    { premium: 40000, db: 1.090329, ltc: 1.009069 },
    { premium: 45000, db: 1.19085, ltc: 1.007784 },
    { premium: 50000, db: 1.271264, ltc: 1.006755 },
    { premium: 55000, db: 1.337057, ltc: 1.005914 },
    { premium: 60000, db: 1.391887, ltc: 1.005213 },
    { premium: 65000, db: 1.43828, ltc: 1.004619 },
    { premium: 70000, db: 1.478045, ltc: 1.004111 },
    { premium: 75000, db: 1.51251, ltc: 1.00367 },
  ],
  "10pay_joint|65|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.7797, ltc: 1 },
    { premium: 15500, db: 0.779863, ltc: 1 },
    { premium: 20000, db: 0.781013, ltc: 1 },
    { premium: 25000, db: 0.781809, ltc: 1 },
    { premium: 30000, db: 0.78494, ltc: 1 },
    { premium: 35000, db: 0.784941, ltc: 1 },
    { premium: 40000, db: 0.784943, ltc: 1 },
    { premium: 45000, db: 0.78494, ltc: 1 },
    { premium: 50000, db: 0.784941, ltc: 1 },
    { premium: 55000, db: 0.784942, ltc: 1 },
    { premium: 60000, db: 0.784943, ltc: 1 },
    { premium: 65000, db: 0.784944, ltc: 1 },
    { premium: 70000, db: 0.846166, ltc: 1 },
    { premium: 75000, db: 0.980874, ltc: 1 },
  ],
  "10pay_joint|65|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 1.088501, ltc: 1.088501 },
    { premium: 7500, db: 0.996612, ltc: 0.996612 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010121, ltc: 1.010121 },
    { premium: 15500, db: 1.010116, ltc: 1.010116 },
    { premium: 20000, db: 1.010121, ltc: 1.010121 },
    { premium: 25000, db: 1.010121, ltc: 1.010121 },
    { premium: 30000, db: 1.010121, ltc: 1.010121 },
    { premium: 35000, db: 1.010121, ltc: 1.010121 },
    { premium: 40000, db: 1.010121, ltc: 1.010121 },
    { premium: 45000, db: 1.036079, ltc: 1.00173 },
    { premium: 50000, db: 1.094831, ltc: 0.982737 },
    { premium: 55000, db: 1.142902, ltc: 0.967198 },
    { premium: 60000, db: 1.18296, ltc: 0.954249 },
    { premium: 65000, db: 1.216857, ltc: 0.943292 },
    { premium: 70000, db: 1.24591, ltc: 0.933899 },
    { premium: 75000, db: 1.271091, ltc: 0.92576 },
  ],
  "10pay_joint|65|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 1.522206, ltc: 1 },
    { premium: 7500, db: 1.014804, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003369, ltc: 1 },
    { premium: 15500, db: 1.010103, ltc: 1 },
    { premium: 20000, db: 1.010099, ltc: 1 },
    { premium: 25000, db: 1.0101, ltc: 1 },
    { premium: 30000, db: 1.010101, ltc: 1 },
    { premium: 35000, db: 1.010102, ltc: 1 },
    { premium: 40000, db: 1.010102, ltc: 1 },
    { premium: 45000, db: 1.010103, ltc: 1 },
    { premium: 50000, db: 1.010103, ltc: 1 },
    { premium: 55000, db: 1.010103, ltc: 1 },
    { premium: 60000, db: 1.010101, ltc: 1 },
    { premium: 65000, db: 1.101793, ltc: 1 },
    { premium: 70000, db: 1.185285, ltc: 1 },
    { premium: 75000, db: 1.257642, ltc: 1 },
  ],
  "10pay_joint|65|None|None|25 Months|25 Months": [
    { premium: 5000, db: 1.063591, ltc: 1.063591 },
    { premium: 7500, db: 0.996618, ltc: 0.996618 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010067, ltc: 1.010067 },
    { premium: 15500, db: 1.010065, ltc: 1.010065 },
    { premium: 20000, db: 1.010065, ltc: 1.010065 },
    { premium: 25000, db: 1.010068, ltc: 1.010068 },
    { premium: 30000, db: 1.010067, ltc: 1.010067 },
    { premium: 35000, db: 1.010066, ltc: 1.010066 },
    { premium: 40000, db: 1.010068, ltc: 1.010068 },
    { premium: 45000, db: 1.010067, ltc: 1.010067 },
    { premium: 50000, db: 1.010068, ltc: 1.010068 },
    { premium: 55000, db: 1.03034, ltc: 0.998533 },
    { premium: 60000, db: 1.06802, ltc: 0.977093 },
    { premium: 65000, db: 1.099902, ltc: 0.958951 },
    { premium: 70000, db: 1.127231, ltc: 0.943401 },
    { premium: 75000, db: 1.150916, ltc: 0.929925 },
  ],
  "10pay_joint|65|None|None|25 Months|50 Months": [
    { premium: 5000, db: 1.325304, ltc: 1.325304 },
    { premium: 7500, db: 0.996692, ltc: 0.996692 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010145, ltc: 1.010145 },
    { premium: 15500, db: 1.010147, ltc: 1.010147 },
    { premium: 20000, db: 1.010143, ltc: 1.010143 },
    { premium: 25000, db: 1.010147, ltc: 1.010147 },
    { premium: 30000, db: 1.010145, ltc: 1.010145 },
    { premium: 35000, db: 1.010148, ltc: 1.010148 },
    { premium: 40000, db: 1.010146, ltc: 1.010146 },
    { premium: 45000, db: 1.010148, ltc: 1.010148 },
    { premium: 50000, db: 1.010147, ltc: 1.010147 },
    { premium: 55000, db: 1.010148, ltc: 1.010148 },
    { premium: 60000, db: 1.010147, ltc: 1.010147 },
    { premium: 65000, db: 1.010149, ltc: 1.010149 },
    { premium: 70000, db: 1.062944, ltc: 0.985273 },
    { premium: 75000, db: 1.115229, ltc: 0.960637 },
  ],
  "10pay_joint|65|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.86339, ltc: 1 },
    { premium: 7500, db: 1.24226, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003335, ltc: 1 },
    { premium: 15500, db: 1.003545, ltc: 1 },
    { premium: 20000, db: 1.01008, ltc: 1 },
    { premium: 25000, db: 1.01008, ltc: 1 },
    { premium: 30000, db: 1.01008, ltc: 1 },
    { premium: 35000, db: 1.010085, ltc: 1 },
    { premium: 40000, db: 1.010085, ltc: 1 },
    { premium: 45000, db: 1.010084, ltc: 1 },
    { premium: 50000, db: 1.010084, ltc: 1 },
    { premium: 55000, db: 1.010083, ltc: 1 },
    { premium: 60000, db: 1.010083, ltc: 1 },
    { premium: 65000, db: 1.010083, ltc: 1 },
    { premium: 70000, db: 1.010085, ltc: 1 },
    { premium: 75000, db: 1.010085, ltc: 1 },
  ],
  "10pay_joint|65|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.97995, ltc: 0.97995 },
    { premium: 7500, db: 0.986649, ltc: 0.986649 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000007, ltc: 1.000007 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000006, ltc: 1.000006 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
    { premium: 35000, db: 1.000007, ltc: 1.000007 },
    { premium: 40000, db: 1.000007, ltc: 1.000007 },
    { premium: 45000, db: 1.000007, ltc: 1.000007 },
    { premium: 50000, db: 1.000006, ltc: 1.000006 },
    { premium: 55000, db: 1.000006, ltc: 1.000006 },
    { premium: 60000, db: 1.000006, ltc: 1.000006 },
    { premium: 65000, db: 1.00813, ltc: 0.992992 },
    { premium: 70000, db: 1.033742, ltc: 0.970875 },
    { premium: 75000, db: 1.055939, ltc: 0.951706 },
  ],
  "10pay_joint|65|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 1.3921, ltc: 1 },
    { premium: 7500, db: 0.996622, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010087, ltc: 1 },
    { premium: 20000, db: 1.010084, ltc: 1 },
    { premium: 25000, db: 1.010089, ltc: 1 },
    { premium: 30000, db: 1.010087, ltc: 1 },
    { premium: 35000, db: 1.010089, ltc: 1 },
    { premium: 40000, db: 1.010088, ltc: 1 },
    { premium: 45000, db: 1.01009, ltc: 1 },
    { premium: 50000, db: 1.010089, ltc: 1 },
    { premium: 55000, db: 1.01009, ltc: 1 },
    { premium: 60000, db: 1.010089, ltc: 1 },
    { premium: 65000, db: 1.01009, ltc: 1 },
    { premium: 70000, db: 1.010089, ltc: 1 },
    { premium: 75000, db: 1.01009, ltc: 1 },
  ],
  "10pay_joint|65|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.980033, ltc: 0.980033 },
    { premium: 7500, db: 0.986637, ltc: 0.986637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1.000001 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.000001, ltc: 1.000001 },
    { premium: 50000, db: 1.000002, ltc: 1.000002 },
    { premium: 55000, db: 1.000001, ltc: 1.000001 },
    { premium: 60000, db: 1.000001, ltc: 1.000001 },
    { premium: 65000, db: 1.000002, ltc: 1.000002 },
    { premium: 70000, db: 1.000001, ltc: 1.000001 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
  ],
  "10pay_joint|65|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.97996, ltc: 1 },
    { premium: 7500, db: 0.986617, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1 },
    { premium: 40000, db: 1.000002, ltc: 1 },
    { premium: 45000, db: 1.000001, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.000001, ltc: 1 },
    { premium: 60000, db: 1.000002, ltc: 1 },
    { premium: 65000, db: 1.000002, ltc: 1 },
    { premium: 70000, db: 1.000001, ltc: 1 },
    { premium: 75000, db: 1.000002, ltc: 1 },
  ],
  "10pay_joint|70|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 1.610292, ltc: 1.610292 },
    { premium: 7500, db: 1.073528, ltc: 1.073528 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00336, ltc: 1.00336 },
    { premium: 15500, db: 1.003548, ltc: 1.003548 },
    { premium: 20000, db: 1.010095, ltc: 1.010095 },
    { premium: 25000, db: 1.010099, ltc: 1.010099 },
    { premium: 30000, db: 1.010095, ltc: 1.010095 },
    { premium: 35000, db: 1.010098, ltc: 1.010098 },
    { premium: 40000, db: 1.010099, ltc: 1.010099 },
    { premium: 45000, db: 1.010097, ltc: 1.010097 },
    { premium: 50000, db: 1.047176, ltc: 1.006618 },
    { premium: 55000, db: 1.121117, ltc: 0.999677 },
    { premium: 60000, db: 1.182735, ltc: 0.993892 },
    { premium: 65000, db: 1.234871, ltc: 0.988997 },
    { premium: 70000, db: 1.279561, ltc: 0.984802 },
    { premium: 75000, db: 1.318293, ltc: 0.981166 },
  ],
  "10pay_joint|70|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 2, ltc: 2 },
    { premium: 7500, db: 1.333333, ltc: 1.333333 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.908634, ltc: 0.908634 },
    { premium: 15500, db: 0.908843, ltc: 0.908843 },
    { premium: 20000, db: 0.910167, ltc: 0.910167 },
    { premium: 25000, db: 0.914751, ltc: 0.914751 },
    { premium: 30000, db: 0.914753, ltc: 0.914753 },
    { premium: 35000, db: 0.914755, ltc: 0.914755 },
    { premium: 40000, db: 0.914752, ltc: 0.914752 },
    { premium: 45000, db: 0.914753, ltc: 0.914753 },
    { premium: 50000, db: 0.914755, ltc: 0.914755 },
    { premium: 55000, db: 0.914756, ltc: 0.914756 },
    { premium: 60000, db: 0.914753, ltc: 0.914753 },
    { premium: 65000, db: 0.914755, ltc: 0.914755 },
    { premium: 70000, db: 1.002791, ltc: 0.905647 },
    { premium: 75000, db: 1.089998, ltc: 0.896623 },
  ],
  "10pay_joint|70|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.666667, ltc: 1 },
    { premium: 15500, db: 0.645161, ltc: 1 },
    { premium: 20000, db: 0.584813, ltc: 1 },
    { premium: 25000, db: 0.585401, ltc: 1 },
    { premium: 30000, db: 0.585793, ltc: 1 },
    { premium: 35000, db: 0.587753, ltc: 1 },
    { premium: 40000, db: 0.587753, ltc: 1 },
    { premium: 45000, db: 0.587753, ltc: 1 },
    { premium: 50000, db: 0.587753, ltc: 1 },
    { premium: 55000, db: 0.587753, ltc: 1 },
    { premium: 60000, db: 0.587753, ltc: 1 },
    { premium: 65000, db: 0.587756, ltc: 1 },
    { premium: 70000, db: 0.587756, ltc: 1 },
    { premium: 75000, db: 0.587756, ltc: 1 },
  ],
  "10pay_joint|70|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 1.426509, ltc: 1.426509 },
    { premium: 7500, db: 0.996648, ltc: 0.996648 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010132, ltc: 1.010132 },
    { premium: 15500, db: 1.010131, ltc: 1.010131 },
    { premium: 20000, db: 1.010134, ltc: 1.010134 },
    { premium: 25000, db: 1.01013, ltc: 1.01013 },
    { premium: 30000, db: 1.010132, ltc: 1.010132 },
    { premium: 35000, db: 1.010133, ltc: 1.010133 },
    { premium: 40000, db: 1.010134, ltc: 1.010134 },
    { premium: 45000, db: 1.010132, ltc: 1.010132 },
    { premium: 50000, db: 1.010133, ltc: 1.010133 },
    { premium: 55000, db: 1.010133, ltc: 1.010133 },
    { premium: 60000, db: 1.050121, ltc: 1.000497 },
    { premium: 65000, db: 1.099476, ltc: 0.988603 },
    { premium: 70000, db: 1.141781, ltc: 0.978408 },
    { premium: 75000, db: 1.178446, ltc: 0.969572 },
  ],
  "10pay_joint|70|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.827774, ltc: 1 },
    { premium: 15500, db: 0.82796, ltc: 1 },
    { premium: 20000, db: 0.829154, ltc: 1 },
    { premium: 25000, db: 0.833333, ltc: 1 },
    { premium: 30000, db: 0.833333, ltc: 1 },
    { premium: 35000, db: 0.833333, ltc: 1 },
    { premium: 40000, db: 0.833333, ltc: 1 },
    { premium: 45000, db: 0.833333, ltc: 1 },
    { premium: 50000, db: 0.833333, ltc: 1 },
    { premium: 55000, db: 0.833333, ltc: 1 },
    { premium: 60000, db: 0.833333, ltc: 1 },
    { premium: 65000, db: 0.833333, ltc: 1 },
    { premium: 70000, db: 0.833336, ltc: 1 },
    { premium: 75000, db: 0.833336, ltc: 1 },
  ],
  "10pay_joint|70|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 1.166694, ltc: 1.166694 },
    { premium: 7500, db: 0.996664, ltc: 0.996664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010133, ltc: 1.010133 },
    { premium: 15500, db: 1.010135, ltc: 1.010135 },
    { premium: 20000, db: 1.010137, ltc: 1.010137 },
    { premium: 25000, db: 1.010135, ltc: 1.010135 },
    { premium: 30000, db: 1.010137, ltc: 1.010137 },
    { premium: 35000, db: 1.010135, ltc: 1.010135 },
    { premium: 40000, db: 1.010137, ltc: 1.010137 },
    { premium: 45000, db: 1.010136, ltc: 1.010136 },
    { premium: 50000, db: 1.010137, ltc: 1.010137 },
    { premium: 55000, db: 1.010136, ltc: 1.010136 },
    { premium: 60000, db: 1.010137, ltc: 1.010137 },
    { premium: 65000, db: 1.010138, ltc: 1.010138 },
    { premium: 70000, db: 1.014496, ltc: 1.00718 },
    { premium: 75000, db: 1.042778, ltc: 0.987992 },
  ],
  "10pay_joint|70|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 1.530685, ltc: 1 },
    { premium: 7500, db: 1.020456, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003346, ltc: 1 },
    { premium: 15500, db: 1.0101, ltc: 1 },
    { premium: 20000, db: 1.010101, ltc: 1 },
    { premium: 25000, db: 1.010101, ltc: 1 },
    { premium: 30000, db: 1.010101, ltc: 1 },
    { premium: 35000, db: 1.010101, ltc: 1 },
    { premium: 40000, db: 1.010105, ltc: 1 },
    { premium: 45000, db: 1.010104, ltc: 1 },
    { premium: 50000, db: 1.010104, ltc: 1 },
    { premium: 55000, db: 1.010103, ltc: 1 },
    { premium: 60000, db: 1.010103, ltc: 1 },
    { premium: 65000, db: 1.010103, ltc: 1 },
    { premium: 70000, db: 1.010103, ltc: 1 },
    { premium: 75000, db: 1.010103, ltc: 1 },
  ],
  "10pay_joint|70|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.90318, ltc: 1.90318 },
    { premium: 7500, db: 1.268787, ltc: 1.268787 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003381, ltc: 1.003381 },
    { premium: 15500, db: 1.003584, ltc: 1.003584 },
    { premium: 20000, db: 1.010085, ltc: 1.010085 },
    { premium: 25000, db: 1.010089, ltc: 1.010089 },
    { premium: 30000, db: 1.010092, ltc: 1.010092 },
    { premium: 35000, db: 1.010088, ltc: 1.010088 },
    { premium: 40000, db: 1.079099, ltc: 1.015278 },
    { premium: 45000, db: 1.203521, ltc: 1.02463 },
    { premium: 50000, db: 1.303058, ltc: 1.032112 },
    { premium: 55000, db: 1.384494, ltc: 1.038231 },
    { premium: 60000, db: 1.452361, ltc: 1.043333 },
    { premium: 65000, db: 1.509786, ltc: 1.047649 },
    { premium: 70000, db: 1.559008, ltc: 1.051349 },
    { premium: 75000, db: 1.601664, ltc: 1.054554 },
  ],
  "10pay_joint|70|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 2, ltc: 2 },
    { premium: 7500, db: 1.333333, ltc: 1.333333 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.731369, ltc: 0.731369 },
    { premium: 15500, db: 0.73153, ltc: 0.73153 },
    { premium: 20000, db: 0.732606, ltc: 0.732606 },
    { premium: 25000, db: 0.733332, ltc: 0.733332 },
    { premium: 30000, db: 0.736276, ltc: 0.736276 },
    { premium: 35000, db: 0.736276, ltc: 0.736276 },
    { premium: 40000, db: 0.736276, ltc: 0.736276 },
    { premium: 45000, db: 0.736276, ltc: 0.736276 },
    { premium: 50000, db: 0.736276, ltc: 0.736276 },
    { premium: 55000, db: 0.755631, ltc: 0.736696 },
    { premium: 60000, db: 0.88524, ltc: 0.739498 },
    { premium: 65000, db: 0.994906, ltc: 0.741867 },
    { premium: 70000, db: 1.088909, ltc: 0.743899 },
    { premium: 75000, db: 1.170378, ltc: 0.74566 },
  ],
  "10pay_joint|70|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.666667, ltc: 1 },
    { premium: 15500, db: 0.645161, ltc: 1 },
    { premium: 20000, db: 0.5, ltc: 1 },
    { premium: 25000, db: 0.445381, ltc: 1 },
    { premium: 30000, db: 0.445673, ltc: 1 },
    { premium: 35000, db: 0.445893, ltc: 1 },
    { premium: 40000, db: 0.446053, ltc: 1 },
    { premium: 45000, db: 0.447169, ltc: 1 },
    { premium: 50000, db: 0.447169, ltc: 1 },
    { premium: 55000, db: 0.44717, ltc: 1 },
    { premium: 60000, db: 0.44717, ltc: 1 },
    { premium: 65000, db: 0.44717, ltc: 1 },
    { premium: 70000, db: 0.44717, ltc: 1 },
    { premium: 75000, db: 0.447168, ltc: 1 },
  ],
  "10pay_joint|70|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 1.661015, ltc: 1.661015 },
    { premium: 7500, db: 1.107343, ltc: 1.107343 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003393, ltc: 1.003393 },
    { premium: 15500, db: 1.003576, ltc: 1.003576 },
    { premium: 20000, db: 1.010105, ltc: 1.010105 },
    { premium: 25000, db: 1.0101, ltc: 1.0101 },
    { premium: 30000, db: 1.010103, ltc: 1.010103 },
    { premium: 35000, db: 1.010104, ltc: 1.010104 },
    { premium: 40000, db: 1.010105, ltc: 1.010105 },
    { premium: 45000, db: 1.034785, ltc: 1.009457 },
    { premium: 50000, db: 1.128284, ltc: 1.007 },
    { premium: 55000, db: 1.204783, ltc: 1.00499 },
    { premium: 60000, db: 1.268532, ltc: 1.003315 },
    { premium: 65000, db: 1.322474, ltc: 1.001897 },
    { premium: 70000, db: 1.36871, ltc: 1.000682 },
    { premium: 75000, db: 1.408781, ltc: 0.999629 },
  ],
  "10pay_joint|70|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.666667, ltc: 1 },
    { premium: 15500, db: 0.652967, ltc: 1 },
    { premium: 20000, db: 0.653918, ltc: 1 },
    { premium: 25000, db: 0.654588, ltc: 1 },
    { premium: 30000, db: 0.655021, ltc: 1 },
    { premium: 35000, db: 0.65721, ltc: 1 },
    { premium: 40000, db: 0.657212, ltc: 1 },
    { premium: 45000, db: 0.657214, ltc: 1 },
    { premium: 50000, db: 0.657211, ltc: 1 },
    { premium: 55000, db: 0.657213, ltc: 1 },
    { premium: 60000, db: 0.657214, ltc: 1 },
    { premium: 65000, db: 0.657215, ltc: 1 },
    { premium: 70000, db: 0.657213, ltc: 1 },
    { premium: 75000, db: 0.657214, ltc: 1 },
  ],
  "10pay_joint|70|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 1.314884, ltc: 1.314884 },
    { premium: 7500, db: 0.996577, ltc: 0.996577 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010057, ltc: 1.010057 },
    { premium: 15500, db: 1.010063, ltc: 1.010063 },
    { premium: 20000, db: 1.010064, ltc: 1.010064 },
    { premium: 25000, db: 1.010063, ltc: 1.010063 },
    { premium: 30000, db: 1.010062, ltc: 1.010062 },
    { premium: 35000, db: 1.010061, ltc: 1.010061 },
    { premium: 40000, db: 1.010064, ltc: 1.010064 },
    { premium: 45000, db: 1.010063, ltc: 1.010063 },
    { premium: 50000, db: 1.010063, ltc: 1.010063 },
    { premium: 55000, db: 1.042703, ltc: 0.999424 },
    { premium: 60000, db: 1.090933, ltc: 0.9837 },
    { premium: 65000, db: 1.131746, ltc: 0.970396 },
    { premium: 70000, db: 1.166726, ltc: 0.958992 },
    { premium: 75000, db: 1.197045, ltc: 0.949109 },
  ],
  "10pay_joint|70|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 1.840415, ltc: 1 },
    { premium: 7500, db: 1.226943, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003392, ltc: 1 },
    { premium: 15500, db: 1.003615, ltc: 1 },
    { premium: 20000, db: 1.010112, ltc: 1 },
    { premium: 25000, db: 1.01011, ltc: 1 },
    { premium: 30000, db: 1.010115, ltc: 1 },
    { premium: 35000, db: 1.010113, ltc: 1 },
    { premium: 40000, db: 1.010117, ltc: 1 },
    { premium: 45000, db: 1.010115, ltc: 1 },
    { premium: 50000, db: 1.010114, ltc: 1 },
    { premium: 55000, db: 1.010116, ltc: 1 },
    { premium: 60000, db: 1.010115, ltc: 1 },
    { premium: 65000, db: 1.010114, ltc: 1 },
    { premium: 70000, db: 1.010116, ltc: 1 },
    { premium: 75000, db: 1.045852, ltc: 1 },
  ],
  "10pay_joint|70|None|None|25 Months|25 Months": [
    { premium: 5000, db: 1.298599, ltc: 1.298599 },
    { premium: 7500, db: 0.996637, ltc: 0.996637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010123, ltc: 1.010123 },
    { premium: 15500, db: 1.010121, ltc: 1.010121 },
    { premium: 20000, db: 1.01012, ltc: 1.01012 },
    { premium: 25000, db: 1.010124, ltc: 1.010124 },
    { premium: 30000, db: 1.010123, ltc: 1.010123 },
    { premium: 35000, db: 1.010121, ltc: 1.010121 },
    { premium: 40000, db: 1.010124, ltc: 1.010124 },
    { premium: 45000, db: 1.010123, ltc: 1.010123 },
    { premium: 50000, db: 1.010124, ltc: 1.010124 },
    { premium: 55000, db: 1.010123, ltc: 1.010123 },
    { premium: 60000, db: 1.010125, ltc: 1.010125 },
    { premium: 65000, db: 1.015667, ltc: 1.007185 },
    { premium: 70000, db: 1.050278, ltc: 0.988822 },
    { premium: 75000, db: 1.080276, ltc: 0.972909 },
  ],
  "10pay_joint|70|None|None|25 Months|50 Months": [
    { premium: 5000, db: 1.631703, ltc: 1.631703 },
    { premium: 7500, db: 1.087802, ltc: 1.087802 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003377, ltc: 1.003377 },
    { premium: 15500, db: 1.003567, ltc: 1.003567 },
    { premium: 20000, db: 1.010091, ltc: 1.010091 },
    { premium: 25000, db: 1.010093, ltc: 1.010093 },
    { premium: 30000, db: 1.010094, ltc: 1.010094 },
    { premium: 35000, db: 1.010094, ltc: 1.010094 },
    { premium: 40000, db: 1.010095, ltc: 1.010095 },
    { premium: 45000, db: 1.010095, ltc: 1.010095 },
    { premium: 50000, db: 1.010096, ltc: 1.010096 },
    { premium: 55000, db: 1.010096, ltc: 1.010096 },
    { premium: 60000, db: 1.010096, ltc: 1.010096 },
    { premium: 65000, db: 1.010094, ltc: 1.010094 },
    { premium: 70000, db: 1.010094, ltc: 1.010094 },
    { premium: 75000, db: 1.010095, ltc: 1.010095 },
  ],
  "10pay_joint|70|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.868917, ltc: 1 },
    { premium: 15500, db: 0.869118, ltc: 1 },
    { premium: 20000, db: 0.87036, ltc: 1 },
    { premium: 25000, db: 0.874738, ltc: 1 },
    { premium: 30000, db: 0.874743, ltc: 1 },
    { premium: 35000, db: 0.874741, ltc: 1 },
    { premium: 40000, db: 0.87474, ltc: 1 },
    { premium: 45000, db: 0.874743, ltc: 1 },
    { premium: 50000, db: 0.874742, ltc: 1 },
    { premium: 55000, db: 0.874741, ltc: 1 },
    { premium: 60000, db: 0.874743, ltc: 1 },
    { premium: 65000, db: 0.874742, ltc: 1 },
    { premium: 70000, db: 0.874741, ltc: 1 },
    { premium: 75000, db: 0.874743, ltc: 1 },
  ],
  "10pay_joint|70|None|None|33 Months|33 Months": [
    { premium: 5000, db: 1.175978, ltc: 1.175978 },
    { premium: 7500, db: 0.996677, ltc: 0.996677 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010134, ltc: 1.010134 },
    { premium: 15500, db: 1.010128, ltc: 1.010128 },
    { premium: 20000, db: 1.010134, ltc: 1.010134 },
    { premium: 25000, db: 1.010134, ltc: 1.010134 },
    { premium: 30000, db: 1.010134, ltc: 1.010134 },
    { premium: 35000, db: 1.010134, ltc: 1.010134 },
    { premium: 40000, db: 1.010134, ltc: 1.010134 },
    { premium: 45000, db: 1.010134, ltc: 1.010134 },
    { premium: 50000, db: 1.010134, ltc: 1.010134 },
    { premium: 55000, db: 1.010134, ltc: 1.010134 },
    { premium: 60000, db: 1.010134, ltc: 1.010134 },
    { premium: 65000, db: 1.010134, ltc: 1.010134 },
    { premium: 70000, db: 1.010134, ltc: 1.010134 },
    { premium: 75000, db: 1.010134, ltc: 1.010134 },
  ],
  "10pay_joint|70|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 1.717972, ltc: 1 },
    { premium: 7500, db: 1.145314, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003378, ltc: 1 },
    { premium: 15500, db: 1.003616, ltc: 1 },
    { premium: 20000, db: 1.010109, ltc: 1 },
    { premium: 25000, db: 1.010108, ltc: 1 },
    { premium: 30000, db: 1.010112, ltc: 1 },
    { premium: 35000, db: 1.01011, ltc: 1 },
    { premium: 40000, db: 1.010114, ltc: 1 },
    { premium: 45000, db: 1.010112, ltc: 1 },
    { premium: 50000, db: 1.010111, ltc: 1 },
    { premium: 55000, db: 1.010113, ltc: 1 },
    { premium: 60000, db: 1.010112, ltc: 1 },
    { premium: 65000, db: 1.010114, ltc: 1 },
    { premium: 70000, db: 1.010113, ltc: 1 },
    { premium: 75000, db: 1.010112, ltc: 1 },
  ],
  "10pay_joint|70|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.99999, ltc: 0.99999 },
    { premium: 7500, db: 0.986674, ltc: 0.986674 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00001, ltc: 1.00001 },
    { premium: 15500, db: 1.000007, ltc: 1.000007 },
    { premium: 20000, db: 1.00001, ltc: 1.00001 },
    { premium: 25000, db: 1.00001, ltc: 1.00001 },
    { premium: 30000, db: 1.00001, ltc: 1.00001 },
    { premium: 35000, db: 1.00001, ltc: 1.00001 },
    { premium: 40000, db: 1.00001, ltc: 1.00001 },
    { premium: 45000, db: 1.00001, ltc: 1.00001 },
    { premium: 50000, db: 1.00001, ltc: 1.00001 },
    { premium: 55000, db: 1.00001, ltc: 1.00001 },
    { premium: 60000, db: 1.00001, ltc: 1.00001 },
    { premium: 65000, db: 1.00001, ltc: 1.00001 },
    { premium: 70000, db: 1.00001, ltc: 1.00001 },
    { premium: 75000, db: 1.00001, ltc: 1.00001 },
  ],
  "10pay_joint|70|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 1.205695, ltc: 1 },
    { premium: 7500, db: 0.996693, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010138, ltc: 1 },
    { premium: 15500, db: 1.010141, ltc: 1 },
    { premium: 20000, db: 1.010138, ltc: 1 },
    { premium: 25000, db: 1.010138, ltc: 1 },
    { premium: 30000, db: 1.010138, ltc: 1 },
    { premium: 35000, db: 1.010138, ltc: 1 },
    { premium: 40000, db: 1.010138, ltc: 1 },
    { premium: 45000, db: 1.010138, ltc: 1 },
    { premium: 50000, db: 1.010141, ltc: 1 },
    { premium: 55000, db: 1.01014, ltc: 1 },
    { premium: 60000, db: 1.01014, ltc: 1 },
    { premium: 65000, db: 1.01014, ltc: 1 },
    { premium: 70000, db: 1.01014, ltc: 1 },
    { premium: 75000, db: 1.01014, ltc: 1 },
  ],
  "10pay_single|45|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.980019, ltc: 0.980019 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.02617, ltc: 0.973061 },
    { premium: 25000, db: 1.086321, ltc: 0.911141 },
    { premium: 30000, db: 1.12642, ltc: 0.869861 },
  ],
  "10pay_single|45|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 0.979948, ltc: 0.979948 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000007, ltc: 1.000007 },
    { premium: 25000, db: 1.076529, ltc: 0.933407 },
    { premium: 30000, db: 1.15609, ltc: 0.864167 },
  ],
  "10pay_single|45|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 0.979922, ltc: 1 },
    { premium: 7500, db: 0.986669, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.092661, ltc: 1 },
    { premium: 35000, db: 1.215605, ltc: 1 },
    { premium: 40000, db: 1.307816, ltc: 1 },
    { premium: 45000, db: 1.379533, ltc: 1 },
    { premium: 50000, db: 1.436907, ltc: 1 },
    { premium: 55000, db: 1.48385, ltc: 1 },
  ],
  "10pay_single|45|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.979945, ltc: 0.979945 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 0.999997, ltc: 0.999997 },
    { premium: 25000, db: 1.022085, ltc: 0.964642 },
    { premium: 30000, db: 1.058068, ltc: 0.907034 },
    { premium: 35000, db: 1.083771, ltc: 0.865885 },
    { premium: 40000, db: 1.103049, ltc: 0.835024 },
    { premium: 45000, db: 1.118042, ltc: 0.811021 },
    { premium: 50000, db: 1.130037, ltc: 0.791818 },
  ],
  "10pay_single|45|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 0.980004, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000007, ltc: 1 },
    { premium: 15500, db: 1.000007, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.025933, ltc: 1 },
    { premium: 35000, db: 1.102516, ltc: 1 },
    { premium: 40000, db: 1.159956, ltc: 1 },
    { premium: 45000, db: 1.204629, ltc: 1 },
    { premium: 50000, db: 1.240367, ltc: 1 },
    { premium: 55000, db: 1.269609, ltc: 1 },
  ],
  "10pay_single|45|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979986, ltc: 0.979986 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.016064, ltc: 0.944662 },
    { premium: 40000, db: 1.029901, ltc: 0.897001 },
    { premium: 45000, db: 1.04066, ltc: 0.859931 },
  ],
  "10pay_single|45|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979973, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.010176, ltc: 1 },
    { premium: 40000, db: 1.038183, ltc: 1 },
    { premium: 45000, db: 1.059968, ltc: 1 },
    { premium: 50000, db: 1.077395, ltc: 1 },
  ],
  "10pay_single|45|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.979934, ltc: 0.979934 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.042274, ltc: 0.977071 },
    { premium: 15500, db: 1.056384, ltc: 0.969419 },
    { premium: 20000, db: 1.151621, ltc: 0.917761 },
    { premium: 25000, db: 1.217232, ltc: 0.882176 },
    { premium: 30000, db: 1.26097, ltc: 0.858452 },
  ],
  "10pay_single|45|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 0.979918, ltc: 0.979918 },
    { premium: 7500, db: 0.986598, ltc: 0.986598 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1.131159, ltc: 0.93652 },
    { premium: 25000, db: 1.268059, ltc: 0.87026 },
    { premium: 30000, db: 1.359326, ltc: 0.826087 },
    { premium: 35000, db: 1.424519, ltc: 0.794535 },
    { premium: 40000, db: 1.473412, ltc: 0.770871 },
    { premium: 45000, db: 1.51144, ltc: 0.752465 },
    { premium: 50000, db: 1.541862, ltc: 0.737741 },
  ],
  "10pay_single|45|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 1.119586, ltc: 1 },
    { premium: 7500, db: 0.996616, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010108, ltc: 1 },
    { premium: 15500, db: 1.01011, ltc: 1 },
    { premium: 20000, db: 1.010108, ltc: 1 },
    { premium: 25000, db: 1.170264, ltc: 1 },
    { premium: 30000, db: 1.378875, ltc: 1 },
    { premium: 35000, db: 1.527879, ltc: 1 },
    { premium: 40000, db: 1.639632, ltc: 1 },
    { premium: 45000, db: 1.726551, ltc: 1 },
    { premium: 50000, db: 1.796089, ltc: 1 },
    { premium: 55000, db: 1.852981, ltc: 1 },
  ],
  "10pay_single|45|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.979856, ltc: 0.979856 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.061497, ltc: 0.942683 },
    { premium: 25000, db: 1.119023, ltc: 0.889059 },
    { premium: 30000, db: 1.157373, ltc: 0.85331 },
    { premium: 35000, db: 1.184767, ltc: 0.827775 },
    { premium: 40000, db: 1.205313, ltc: 0.808624 },
    { premium: 45000, db: 1.221293, ltc: 0.793729 },
    { premium: 50000, db: 1.234076, ltc: 0.781812 },
  ],
  "10pay_single|45|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 0.979893, ltc: 1 },
    { premium: 7500, db: 0.986584, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.087734, ltc: 1 },
    { premium: 30000, db: 1.211577, ltc: 1 },
    { premium: 35000, db: 1.300038, ltc: 1 },
    { premium: 40000, db: 1.366382, ltc: 1 },
    { premium: 45000, db: 1.417983, ltc: 1 },
    { premium: 50000, db: 1.459265, ltc: 1 },
    { premium: 55000, db: 1.49304, ltc: 1 },
  ],
  "10pay_single|45|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979908, ltc: 0.979908 },
    { premium: 7500, db: 0.999995, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.026436, ltc: 0.942418 },
    { premium: 30000, db: 1.053144, ltc: 0.884239 },
    { premium: 35000, db: 1.072221, ltc: 0.842683 },
    { premium: 40000, db: 1.08653, ltc: 0.811515 },
    { premium: 45000, db: 1.097658, ltc: 0.787274 },
  ],
  "10pay_single|45|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979911, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.008638, ltc: 1 },
    { premium: 30000, db: 1.065225, ltc: 1 },
    { premium: 35000, db: 1.105644, ltc: 1 },
    { premium: 40000, db: 1.135959, ltc: 1 },
    { premium: 45000, db: 1.159537, ltc: 1 },
    { premium: 50000, db: 1.178399, ltc: 1 },
  ],
  "10pay_single|45|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979948, ltc: 0.979948 },
    { premium: 7500, db: 0.999993, ltc: 0.999993 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999996, ltc: 0.999996 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 0.999997, ltc: 0.999997 },
    { premium: 25000, db: 0.999998, ltc: 0.999998 },
    { premium: 30000, db: 1.016965, ltc: 0.956482 },
  ],
  "10pay_single|45|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.979883, ltc: 0.979883 },
    { premium: 7500, db: 1.000004, ltc: 1.000004 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.00478, ltc: 0.99004 },
  ],
  "10pay_single|45|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 0.979932, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 0.999997, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.007776, ltc: 1 },
    { premium: 40000, db: 1.068115, ltc: 1 },
    { premium: 45000, db: 1.115044, ltc: 1 },
    { premium: 50000, db: 1.152587, ltc: 1 },
    { premium: 55000, db: 1.183306, ltc: 1 },
  ],
  "10pay_single|45|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979918, ltc: 0.979918 },
    { premium: 7500, db: 0.999997, ltc: 0.999997 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.002869, ltc: 0.98934 },
    { premium: 40000, db: 1.01733, ltc: 0.935582 },
    { premium: 45000, db: 1.028577, ltc: 0.893771 },
  ],
  "10pay_single|45|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979894, ltc: 1 },
    { premium: 7500, db: 0.999994, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 1 },
    { premium: 30000, db: 0.999998, ltc: 1 },
    { premium: 35000, db: 0.999999, ltc: 1 },
    { premium: 40000, db: 1.004891, ltc: 1 },
    { premium: 45000, db: 1.036323, ltc: 1 },
    { premium: 50000, db: 1.061468, ltc: 1 },
  ],
  "10pay_single|45|None|None|50 Months|50 Months": [
    { premium: 5000, db: 1, ltc: 1 },
    { premium: 7500, db: 1.000003, ltc: 1.000003 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000002, ltc: 1.000002 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|45|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.97989, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1 },
    { premium: 40000, db: 1.000003, ltc: 1 },
    { premium: 45000, db: 1.000002, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
  ],
  "10pay_single|48|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.979994, ltc: 0.979994 },
    { premium: 7500, db: 0.999993, ltc: 0.999993 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1.000237, ltc: 0.999768 },
    { premium: 25000, db: 1.068441, ltc: 0.933941 },
    { premium: 30000, db: 1.113909, ltc: 0.890055 },
    { premium: 35000, db: 1.146388, ltc: 0.858708 },
    { premium: 40000, db: 1.170745, ltc: 0.835198 },
    { premium: 45000, db: 1.18969, ltc: 0.816912 },
    { premium: 50000, db: 1.204847, ltc: 0.802284 },
  ],
  "10pay_single|48|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 0.980049, ltc: 0.980049 },
    { premium: 7500, db: 0.986694, ltc: 0.986694 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.033026, ltc: 0.973223 },
    { premium: 30000, db: 1.124629, ltc: 0.898944 },
    { premium: 35000, db: 1.190061, ltc: 0.845888 },
    { premium: 40000, db: 1.239134, ltc: 0.806096 },
    { premium: 45000, db: 1.277302, ltc: 0.775146 },
    { premium: 50000, db: 1.307837, ltc: 0.750387 },
    { premium: 55000, db: 1.33282, ltc: 0.730128 },
  ],
  "10pay_single|48|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 0.994581, ltc: 1 },
    { premium: 7500, db: 0.986693, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1.005711, ltc: 1 },
    { premium: 35000, db: 1.148013, ltc: 1 },
    { premium: 40000, db: 1.254738, ltc: 1 },
    { premium: 45000, db: 1.337746, ltc: 1 },
    { premium: 50000, db: 1.404154, ltc: 1 },
    { premium: 55000, db: 1.458487, ltc: 1 },
    { premium: 60000, db: 1.503765, ltc: 1 },
  ],
  "10pay_single|48|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.97992, ltc: 0.97992 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.004004, ltc: 0.994004 },
    { premium: 30000, db: 1.045004, ltc: 0.932503 },
    { premium: 35000, db: 1.07429, ltc: 0.888575 },
    { premium: 40000, db: 1.096254, ltc: 0.855628 },
    { premium: 45000, db: 1.113337, ltc: 0.830003 },
    { premium: 50000, db: 1.127004, ltc: 0.809503 },
  ],
  "10pay_single|48|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 0.979928, ltc: 1 },
    { premium: 7500, db: 0.986611, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000005, ltc: 1 },
    { premium: 30000, db: 1.000005, ltc: 1 },
    { premium: 35000, db: 1.062972, ltc: 1 },
    { premium: 40000, db: 1.128603, ltc: 1 },
    { premium: 45000, db: 1.179649, ltc: 1 },
    { premium: 50000, db: 1.220487, ltc: 1 },
    { premium: 55000, db: 1.253899, ltc: 1 },
    { premium: 60000, db: 1.281742, ltc: 1 },
  ],
  "10pay_single|48|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979877, ltc: 0.979877 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.007559, ltc: 0.975551 },
    { premium: 40000, db: 1.023353, ltc: 0.924477 },
    { premium: 45000, db: 1.035638, ltc: 0.884752 },
    { premium: 50000, db: 1.045465, ltc: 0.852973 },
  ],
  "10pay_single|48|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979925, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1.022719, ltc: 1 },
    { premium: 45000, db: 1.047664, ltc: 1 },
    { premium: 50000, db: 1.06762, ltc: 1 },
    { premium: 55000, db: 1.083946, ltc: 1 },
  ],
  "10pay_single|48|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.980027, ltc: 0.980027 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.002809, ltc: 0.998605 },
    { premium: 15500, db: 1.018894, ltc: 0.990609 },
    { premium: 20000, db: 1.127484, ltc: 0.936642 },
    { premium: 25000, db: 1.202291, ltc: 0.899466 },
    { premium: 30000, db: 1.25216, ltc: 0.874681 },
    { premium: 35000, db: 1.287781, ltc: 0.856977 },
    { premium: 40000, db: 1.314499, ltc: 0.8437 },
    { premium: 45000, db: 1.335277, ltc: 0.833372 },
    { premium: 50000, db: 1.3519, ltc: 0.82511 },
  ],
  "10pay_single|48|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 0.97996, ltc: 0.97996 },
    { premium: 7500, db: 0.986692, ltc: 0.986692 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 0.999997 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.068384, ltc: 0.969262 },
    { premium: 25000, db: 1.225031, ltc: 0.898851 },
    { premium: 30000, db: 1.329464, ltc: 0.851911 },
    { premium: 35000, db: 1.404057, ltc: 0.818381 },
    { premium: 40000, db: 1.460002, ltc: 0.793234 },
    { premium: 45000, db: 1.503517, ltc: 0.773676 },
    { premium: 50000, db: 1.538327, ltc: 0.758029 },
    { premium: 55000, db: 1.566809, ltc: 0.745228 },
  ],
  "10pay_single|48|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 1.234697, ltc: 1 },
    { premium: 7500, db: 0.996605, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01006, ltc: 1 },
    { premium: 15500, db: 1.010058, ltc: 1 },
    { premium: 20000, db: 1.01006, ltc: 1 },
    { premium: 25000, db: 1.042989, ltc: 1 },
    { premium: 30000, db: 1.283357, ltc: 1 },
    { premium: 35000, db: 1.455048, ltc: 1 },
    { premium: 40000, db: 1.583819, ltc: 1 },
    { premium: 45000, db: 1.683972, ltc: 1 },
    { premium: 50000, db: 1.764096, ltc: 1 },
    { premium: 55000, db: 1.829651, ltc: 1 },
    { premium: 60000, db: 1.884281, ltc: 1 },
  ],
  "10pay_single|48|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.979987, ltc: 0.979987 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1.038352, ltc: 0.966445 },
    { premium: 25000, db: 1.103406, ltc: 0.909518 },
    { premium: 30000, db: 1.146776, ltc: 0.871567 },
    { premium: 35000, db: 1.177754, ltc: 0.844459 },
    { premium: 40000, db: 1.200987, ltc: 0.824128 },
    { premium: 45000, db: 1.219058, ltc: 0.808315 },
    { premium: 50000, db: 1.233514, ltc: 0.795665 },
  ],
  "10pay_single|48|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 0.980029, ltc: 1 },
    { premium: 7500, db: 0.986661, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.018187, ltc: 1 },
    { premium: 30000, db: 1.159398, ltc: 1 },
    { premium: 35000, db: 1.260262, ltc: 1 },
    { premium: 40000, db: 1.335911, ltc: 1 },
    { premium: 45000, db: 1.394749, ltc: 1 },
    { premium: 50000, db: 1.441817, ltc: 1 },
    { premium: 55000, db: 1.480331, ltc: 1 },
    { premium: 60000, db: 1.512424, ltc: 1 },
  ],
  "10pay_single|48|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979876, ltc: 0.979876 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.014101, ltc: 0.970732 },
    { premium: 30000, db: 1.044096, ltc: 0.90845 },
    { premium: 35000, db: 1.065522, ltc: 0.863962 },
    { premium: 40000, db: 1.081591, ltc: 0.830597 },
    { premium: 45000, db: 1.094088, ltc: 0.804645 },
    { premium: 50000, db: 1.104086, ltc: 0.783884 },
  ],
  "10pay_single|48|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979985, ltc: 1 },
    { premium: 7500, db: 0.999996, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999996, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 0.999997, ltc: 1 },
    { premium: 25000, db: 0.999997, ltc: 1 },
    { premium: 30000, db: 1.042928, ltc: 1 },
    { premium: 35000, db: 1.088476, ltc: 1 },
    { premium: 40000, db: 1.122637, ltc: 1 },
    { premium: 45000, db: 1.149207, ltc: 1 },
    { premium: 50000, db: 1.170463, ltc: 1 },
    { premium: 55000, db: 1.187853, ltc: 1 },
  ],
  "10pay_single|48|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979942, ltc: 0.979942 },
    { premium: 7500, db: 1.000004, ltc: 1.000004 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.005289, ltc: 0.987146 },
    { premium: 35000, db: 1.028896, ltc: 0.929735 },
    { premium: 40000, db: 1.046599, ltc: 0.886676 },
    { premium: 45000, db: 1.060369, ltc: 0.853186 },
    { premium: 50000, db: 1.071386, ltc: 0.826394 },
  ],
  "10pay_single|48|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.979946, ltc: 0.979946 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000005, ltc: 1.000005 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
    { premium: 35000, db: 1.024661, ltc: 0.951366 },
    { premium: 40000, db: 1.057719, ltc: 0.886159 },
    { premium: 45000, db: 1.083429, ltc: 0.835442 },
    { premium: 50000, db: 1.103997, ltc: 0.794868 },
    { premium: 55000, db: 1.120826, ltc: 0.761671 },
  ],
  "10pay_single|48|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 0.980022, ltc: 1 },
    { premium: 7500, db: 0.986721, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1 },
    { premium: 40000, db: 1.031619, ltc: 1 },
    { premium: 45000, db: 1.084882, ltc: 1 },
    { premium: 50000, db: 1.127491, ltc: 1 },
    { premium: 55000, db: 1.162354, ltc: 1 },
    { premium: 60000, db: 1.191406, ltc: 1 },
  ],
  "10pay_single|48|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979961, ltc: 0.979961 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1.000001 },
    { premium: 40000, db: 1.009722, ltc: 0.965529 },
    { premium: 45000, db: 1.022373, ltc: 0.920669 },
    { premium: 50000, db: 1.032494, ltc: 0.884781 },
  ],
  "10pay_single|48|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.97992, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.015767, ltc: 1 },
    { premium: 50000, db: 1.04417, ltc: 1 },
    { premium: 55000, db: 1.067409, ltc: 1 },
  ],
  "10pay_single|48|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.979931, ltc: 0.979931 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.000004, ltc: 1.000004 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
    { premium: 50000, db: 1.000003, ltc: 1.000003 },
  ],
  "10pay_single|48|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.979905, ltc: 1 },
    { premium: 7500, db: 0.999998, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.000001, ltc: 1 },
    { premium: 50000, db: 1, ltc: 1 },
  ],
  "10pay_single|50|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.979947, ltc: 0.979947 },
    { premium: 7500, db: 0.999995, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.054847, ltc: 0.949584 },
    { premium: 30000, db: 1.104421, ltc: 0.904011 },
    { premium: 35000, db: 1.139832, ltc: 0.871459 },
    { premium: 40000, db: 1.166391, ltc: 0.847046 },
    { premium: 45000, db: 1.187047, ltc: 0.828057 },
    { premium: 50000, db: 1.203573, ltc: 0.812867 },
    { premium: 55000, db: 1.217093, ltc: 0.800438 },
  ],
  "10pay_single|50|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 0.980022, ltc: 0.980022 },
    { premium: 7500, db: 0.986637, ltc: 0.986637 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.099943, ltc: 0.922982 },
    { premium: 35000, db: 1.171936, ltc: 0.867503 },
    { premium: 40000, db: 1.225929, ltc: 0.825894 },
    { premium: 45000, db: 1.267925, ltc: 0.793531 },
    { premium: 50000, db: 1.30152, ltc: 0.767641 },
    { premium: 55000, db: 1.329008, ltc: 0.746458 },
    { premium: 60000, db: 1.351915, ltc: 0.728806 },
  ],
  "10pay_single|50|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.069894, ltc: 1 },
    { premium: 7500, db: 0.996634, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010105, ltc: 1 },
    { premium: 15500, db: 1.010102, ltc: 1 },
    { premium: 20000, db: 1.010103, ltc: 1 },
    { premium: 25000, db: 1.010102, ltc: 1 },
    { premium: 30000, db: 1.010105, ltc: 1 },
    { premium: 35000, db: 1.106619, ltc: 1 },
    { premium: 40000, db: 1.225285, ltc: 1 },
    { premium: 45000, db: 1.317578, ltc: 1 },
    { premium: 50000, db: 1.391412, ltc: 1 },
    { premium: 55000, db: 1.451825, ltc: 1 },
    { premium: 60000, db: 1.502166, ltc: 1 },
    { premium: 65000, db: 1.544765, ltc: 1 },
  ],
  "10pay_single|50|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.980052, ltc: 0.980052 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.035047, ltc: 0.949857 },
    { premium: 35000, db: 1.067038, ltc: 0.904091 },
    { premium: 40000, db: 1.09103, ltc: 0.869765 },
    { premium: 45000, db: 1.109692, ltc: 0.843068 },
    { premium: 50000, db: 1.12462, ltc: 0.82171 },
    { premium: 55000, db: 1.136835, ltc: 0.804236 },
  ],
  "10pay_single|50|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 0.979999, ltc: 1 },
    { premium: 7500, db: 0.986658, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000005, ltc: 1 },
    { premium: 30000, db: 1.000006, ltc: 1 },
    { premium: 35000, db: 1.032517, ltc: 1 },
    { premium: 40000, db: 1.104435, ltc: 1 },
    { premium: 45000, db: 1.160369, ltc: 1 },
    { premium: 50000, db: 1.205118, ltc: 1 },
    { premium: 55000, db: 1.24173, ltc: 1 },
    { premium: 60000, db: 1.272241, ltc: 1 },
  ],
  "10pay_single|50|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.980017, ltc: 0.980017 },
    { premium: 7500, db: 0.999994, ltc: 0.999994 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.001104, ltc: 0.996581 },
    { premium: 40000, db: 1.018335, ltc: 0.943193 },
    { premium: 45000, db: 1.031737, ltc: 0.901669 },
    { premium: 50000, db: 1.042457, ltc: 0.868449 },
    { premium: 55000, db: 1.051229, ltc: 0.841269 },
  ],
  "10pay_single|50|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980034, ltc: 1 },
    { premium: 7500, db: 0.999996, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1.010904, ltc: 1 },
    { premium: 45000, db: 1.038165, ltc: 1 },
    { premium: 50000, db: 1.059973, ltc: 1 },
    { premium: 55000, db: 1.077816, ltc: 1 },
  ],
  "10pay_single|50|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.980018, ltc: 0.980018 },
    { premium: 7500, db: 0.986631, ltc: 0.986631 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.108878, ltc: 0.94934 },
    { premium: 25000, db: 1.190699, ltc: 0.91127 },
    { premium: 30000, db: 1.245244, ltc: 0.885889 },
    { premium: 35000, db: 1.284205, ltc: 0.86776 },
    { premium: 40000, db: 1.313427, ltc: 0.854164 },
    { premium: 45000, db: 1.336154, ltc: 0.843588 },
    { premium: 50000, db: 1.354337, ltc: 0.835129 },
    { premium: 55000, db: 1.369212, ltc: 0.828207 },
  ],
  "10pay_single|50|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 0.980049, ltc: 0.980049 },
    { premium: 7500, db: 0.986683, ltc: 0.986683 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.019775, ltc: 0.991597 },
    { premium: 25000, db: 1.19157, ltc: 0.918527 },
    { premium: 30000, db: 1.306097, ltc: 0.869813 },
    { premium: 35000, db: 1.387904, ltc: 0.835019 },
    { premium: 40000, db: 1.449258, ltc: 0.808922 },
    { premium: 45000, db: 1.496979, ltc: 0.788625 },
    { premium: 50000, db: 1.535154, ltc: 0.772387 },
    { premium: 55000, db: 1.566388, ltc: 0.759101 },
    { premium: 60000, db: 1.592418, ltc: 0.74803 },
  ],
  "10pay_single|50|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 1.318195, ltc: 1 },
    { premium: 7500, db: 0.99667, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010113, ltc: 1 },
    { premium: 15500, db: 1.010119, ltc: 1 },
    { premium: 20000, db: 1.010115, ltc: 1 },
    { premium: 25000, db: 1.010116, ltc: 1 },
    { premium: 30000, db: 1.208396, ltc: 1 },
    { premium: 35000, db: 1.397619, ltc: 1 },
    { premium: 40000, db: 1.539537, ltc: 1 },
    { premium: 45000, db: 1.64992, ltc: 1 },
    { premium: 50000, db: 1.738225, ltc: 1 },
    { premium: 55000, db: 1.810476, ltc: 1 },
    { premium: 60000, db: 1.870683, ltc: 1 },
    { premium: 65000, db: 1.921629, ltc: 1 },
  ],
  "10pay_single|50|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.979942, ltc: 0.979942 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1.020777, ltc: 0.982723 },
    { premium: 25000, db: 1.091713, ltc: 0.923724 },
    { premium: 30000, db: 1.139006, ltc: 0.884393 },
    { premium: 35000, db: 1.172784, ltc: 0.856298 },
    { premium: 40000, db: 1.19812, ltc: 0.835227 },
    { premium: 45000, db: 1.217824, ltc: 0.818839 },
    { premium: 50000, db: 1.233589, ltc: 0.805728 },
    { premium: 55000, db: 1.246486, ltc: 0.795001 },
  ],
  "10pay_single|50|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 0.979984, ltc: 1 },
    { premium: 7500, db: 0.986643, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1 },
    { premium: 15500, db: 1.000008, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.119319, ltc: 1 },
    { premium: 35000, db: 1.229683, ltc: 1 },
    { premium: 40000, db: 1.312459, ltc: 1 },
    { premium: 45000, db: 1.376837, ltc: 1 },
    { premium: 50000, db: 1.428343, ltc: 1 },
    { premium: 55000, db: 1.470481, ltc: 1 },
    { premium: 60000, db: 1.505599, ltc: 1 },
  ],
  "10pay_single|50|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979913, ltc: 0.979913 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 0.999998 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.004869, ltc: 0.990275 },
    { premium: 30000, db: 1.037417, ltc: 0.925242 },
    { premium: 35000, db: 1.060665, ltc: 0.87879 },
    { premium: 40000, db: 1.078102, ltc: 0.843951 },
    { premium: 45000, db: 1.091664, ltc: 0.816854 },
    { premium: 50000, db: 1.102514, ltc: 0.795177 },
  ],
  "10pay_single|50|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979908, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000005, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000004, ltc: 1 },
    { premium: 30000, db: 1.026134, ltc: 1 },
    { premium: 35000, db: 1.075625, ltc: 1 },
    { premium: 40000, db: 1.112744, ltc: 1 },
    { premium: 45000, db: 1.141612, ltc: 1 },
    { premium: 50000, db: 1.164709, ltc: 1 },
    { premium: 55000, db: 1.183605, ltc: 1 },
  ],
  "10pay_single|50|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.97999, ltc: 0.97999 },
    { premium: 7500, db: 0.999996, ltc: 0.999996 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.022157, ltc: 0.948437 },
    { premium: 40000, db: 1.04149, ltc: 0.903434 },
    { premium: 45000, db: 1.056528, ltc: 0.868432 },
    { premium: 50000, db: 1.068557, ltc: 0.84043 },
    { premium: 55000, db: 1.078399, ltc: 0.817519 },
  ],
  "10pay_single|50|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.980009, ltc: 0.980009 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.010083, ltc: 0.980983 },
    { premium: 40000, db: 1.046349, ltc: 0.912535 },
    { premium: 45000, db: 1.074557, ltc: 0.859299 },
    { premium: 50000, db: 1.097123, ltc: 0.81671 },
    { premium: 55000, db: 1.115585, ltc: 0.781864 },
  ],
  "10pay_single|50|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 0.980016, ltc: 1 },
    { premium: 7500, db: 0.986715, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 0.999996, ltc: 1 },
    { premium: 25000, db: 0.999997, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 0.999998, ltc: 1 },
    { premium: 40000, db: 1.003364, ltc: 1 },
    { premium: 45000, db: 1.061631, ltc: 1 },
    { premium: 50000, db: 1.108245, ltc: 1 },
    { premium: 55000, db: 1.146384, ltc: 1 },
    { premium: 60000, db: 1.178166, ltc: 1 },
    { premium: 65000, db: 1.20506, ltc: 1 },
  ],
  "10pay_single|50|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979935, ltc: 0.979935 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1.000001 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.000002, ltc: 1.000002 },
    { premium: 40000, db: 1.004037, ltc: 0.98627 },
    { premium: 45000, db: 1.017826, ltc: 0.939359 },
    { premium: 50000, db: 1.028857, ltc: 0.90183 },
    { premium: 55000, db: 1.037882, ltc: 0.871124 },
  ],
  "10pay_single|50|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979958, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.000091, ltc: 1 },
    { premium: 50000, db: 1.031087, ltc: 1 },
    { premium: 55000, db: 1.056445, ltc: 1 },
    { premium: 60000, db: 1.077578, ltc: 1 },
  ],
  "10pay_single|50|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.979965, ltc: 0.979965 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
    { premium: 35000, db: 1.000004, ltc: 1.000004 },
    { premium: 40000, db: 1.000004, ltc: 1.000004 },
    { premium: 45000, db: 1.000004, ltc: 1.000004 },
    { premium: 50000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_single|50|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.98001, ltc: 1 },
    { premium: 7500, db: 1.000002, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000001, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1 },
    { premium: 40000, db: 1.000003, ltc: 1 },
    { premium: 45000, db: 1.000002, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|55|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.979954, ltc: 0.979954 },
    { premium: 7500, db: 0.986707, ltc: 0.986707 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1.000005 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000008, ltc: 1.000008 },
    { premium: 25000, db: 1.007924, ltc: 0.993686 },
    { premium: 30000, db: 1.070776, ltc: 0.943491 },
    { premium: 35000, db: 1.115673, ltc: 0.907639 },
    { premium: 40000, db: 1.149343, ltc: 0.880749 },
    { premium: 45000, db: 1.175532, ltc: 0.859835 },
    { premium: 50000, db: 1.196484, ltc: 0.843104 },
    { premium: 55000, db: 1.213625, ltc: 0.829414 },
    { premium: 60000, db: 1.227911, ltc: 0.818007 },
    { premium: 65000, db: 1.239997, ltc: 0.808354 },
  ],
  "10pay_single|55|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 0.979984, ltc: 0.979984 },
    { premium: 7500, db: 0.986643, ltc: 0.986643 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000006 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.016674, ltc: 0.988563 },
    { premium: 35000, db: 1.107675, ltc: 0.926086 },
    { premium: 40000, db: 1.175923, ltc: 0.879228 },
    { premium: 45000, db: 1.229005, ltc: 0.842782 },
    { premium: 50000, db: 1.271472, ltc: 0.813627 },
    { premium: 55000, db: 1.306217, ltc: 0.789772 },
    { premium: 60000, db: 1.335172, ltc: 0.769893 },
    { premium: 65000, db: 1.359671, ltc: 0.753072 },
    { premium: 70000, db: 1.38067, ltc: 0.738654 },
  ],
  "10pay_single|55|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.255086, ltc: 1 },
    { premium: 7500, db: 0.996582, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010069, ltc: 1 },
    { premium: 15500, db: 1.010065, ltc: 1 },
    { premium: 20000, db: 1.010064, ltc: 1 },
    { premium: 25000, db: 1.010067, ltc: 1 },
    { premium: 30000, db: 1.010069, ltc: 1 },
    { premium: 35000, db: 1.010066, ltc: 1 },
    { premium: 40000, db: 1.086413, ltc: 1 },
    { premium: 45000, db: 1.20231, ltc: 1 },
    { premium: 50000, db: 1.295029, ltc: 1 },
    { premium: 55000, db: 1.370889, ltc: 1 },
    { premium: 60000, db: 1.434107, ltc: 1 },
    { premium: 65000, db: 1.487597, ltc: 1 },
    { premium: 70000, db: 1.533446, ltc: 1 },
    { premium: 75000, db: 1.573183, ltc: 1 },
  ],
  "10pay_single|55|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.980039, ltc: 0.980039 },
    { premium: 7500, db: 1.000005, ltc: 1.000005 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.001311, ltc: 0.998324 },
    { premium: 35000, db: 1.041156, ltc: 0.947151 },
    { premium: 40000, db: 1.071041, ltc: 0.908772 },
    { premium: 45000, db: 1.094283, ltc: 0.878921 },
    { premium: 50000, db: 1.112879, ltc: 0.85504 },
    { premium: 55000, db: 1.128093, ltc: 0.835502 },
    { premium: 60000, db: 1.14077, ltc: 0.819219 },
  ],
  "10pay_single|55|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 0.979941, ltc: 1 },
    { premium: 7500, db: 0.986666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999995, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1.024399, ltc: 1 },
    { premium: 45000, db: 1.093985, ltc: 1 },
    { premium: 50000, db: 1.149652, ltc: 1 },
    { premium: 55000, db: 1.195199, ltc: 1 },
    { premium: 60000, db: 1.233153, ltc: 1 },
    { premium: 65000, db: 1.26527, ltc: 1 },
    { premium: 70000, db: 1.292798, ltc: 1 },
  ],
  "10pay_single|55|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.979988, ltc: 0.979988 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
    { premium: 35000, db: 1.000004, ltc: 1.000004 },
    { premium: 40000, db: 1.001299, ltc: 0.996327 },
    { premium: 45000, db: 1.017777, ltc: 0.949491 },
    { premium: 50000, db: 1.030958, ltc: 0.912021 },
    { premium: 55000, db: 1.041744, ltc: 0.881365 },
    { premium: 60000, db: 1.050732, ltc: 0.855818 },
  ],
  "10pay_single|55|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980048, ltc: 1 },
    { premium: 7500, db: 0.999995, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000005, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000004, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000005, ltc: 1 },
    { premium: 35000, db: 1.000004, ltc: 1 },
    { premium: 40000, db: 1.000004, ltc: 1 },
    { premium: 45000, db: 1.006595, ltc: 1 },
    { premium: 50000, db: 1.033245, ltc: 1 },
    { premium: 55000, db: 1.05505, ltc: 1 },
    { premium: 60000, db: 1.073221, ltc: 1 },
    { premium: 65000, db: 1.088595, ltc: 1 },
  ],
  "10pay_single|55|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 0.979988, ltc: 0.979988 },
    { premium: 7500, db: 0.986708, ltc: 0.986708 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.044686, ltc: 0.982596 },
    { premium: 25000, db: 1.148153, ltc: 0.942279 },
    { premium: 30000, db: 1.217135, ltc: 0.915403 },
    { premium: 35000, db: 1.266405, ltc: 0.896204 },
    { premium: 40000, db: 1.303357, ltc: 0.881805 },
    { premium: 45000, db: 1.3321, ltc: 0.870607 },
    { premium: 50000, db: 1.355092, ltc: 0.861647 },
    { premium: 55000, db: 1.373906, ltc: 0.854318 },
    { premium: 60000, db: 1.389582, ltc: 0.848209 },
    { premium: 65000, db: 1.402848, ltc: 0.84304 },
  ],
  "10pay_single|55|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.16418, ltc: 1.16418 },
    { premium: 7500, db: 0.996563, ltc: 0.996563 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010064, ltc: 1.010064 },
    { premium: 15500, db: 1.010063, ltc: 1.010063 },
    { premium: 20000, db: 1.010062, ltc: 1.010062 },
    { premium: 25000, db: 1.085491, ltc: 0.982577 },
    { premium: 30000, db: 1.23375, ltc: 0.928539 },
    { premium: 35000, db: 1.339649, ltc: 0.88994 },
    { premium: 40000, db: 1.419077, ltc: 0.860992 },
    { premium: 45000, db: 1.480851, ltc: 0.838476 },
    { premium: 50000, db: 1.530273, ltc: 0.820464 },
    { premium: 55000, db: 1.570707, ltc: 0.805727 },
    { premium: 60000, db: 1.604404, ltc: 0.793446 },
    { premium: 65000, db: 1.632915, ltc: 0.783054 },
    { premium: 70000, db: 1.657353, ltc: 0.774146 },
  ],
  "10pay_single|55|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 1.560392, ltc: 1 },
    { premium: 7500, db: 1.040261, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003349, ltc: 1 },
    { premium: 15500, db: 1.010107, ltc: 1 },
    { premium: 20000, db: 1.010102, ltc: 1 },
    { premium: 25000, db: 1.010103, ltc: 1 },
    { premium: 30000, db: 1.010104, ltc: 1 },
    { premium: 35000, db: 1.202369, ltc: 1 },
    { premium: 40000, db: 1.382999, ltc: 1 },
    { premium: 45000, db: 1.523487, ltc: 1 },
    { premium: 50000, db: 1.635879, ltc: 1 },
    { premium: 55000, db: 1.727834, ltc: 1 },
    { premium: 60000, db: 1.804466, ltc: 1 },
    { premium: 65000, db: 1.869306, ltc: 1 },
    { premium: 70000, db: 1.924883, ltc: 1 },
    { premium: 75000, db: 1.973052, ltc: 1 },
  ],
  "10pay_single|55|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.979965, ltc: 0.979965 },
    { premium: 7500, db: 0.986679, ltc: 0.986679 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.050459, ltc: 0.963686 },
    { premium: 30000, db: 1.110362, ltc: 0.920561 },
    { premium: 35000, db: 1.153152, ltc: 0.889759 },
    { premium: 40000, db: 1.185243, ltc: 0.866657 },
    { premium: 45000, db: 1.210204, ltc: 0.848689 },
    { premium: 50000, db: 1.230171, ltc: 0.834314 },
    { premium: 55000, db: 1.24651, ltc: 0.822553 },
    { premium: 60000, db: 1.260125, ltc: 0.812753 },
  ],
  "10pay_single|55|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.152285, ltc: 1 },
    { premium: 7500, db: 0.996613, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010077, ltc: 1 },
    { premium: 15500, db: 1.01008, ltc: 1 },
    { premium: 20000, db: 1.010081, ltc: 1 },
    { premium: 25000, db: 1.010079, ltc: 1 },
    { premium: 30000, db: 1.010081, ltc: 1 },
    { premium: 35000, db: 1.136563, ltc: 1 },
    { premium: 40000, db: 1.241472, ltc: 1 },
    { premium: 45000, db: 1.323064, ltc: 1 },
    { premium: 50000, db: 1.388341, ltc: 1 },
    { premium: 55000, db: 1.441749, ltc: 1 },
    { premium: 60000, db: 1.486254, ltc: 1 },
    { premium: 65000, db: 1.523913, ltc: 1 },
    { premium: 70000, db: 1.556191, ltc: 1 },
  ],
  "10pay_single|55|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.980002, ltc: 0.980002 },
    { premium: 7500, db: 0.999995, ltc: 0.999995 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.014385, ltc: 0.974327 },
    { premium: 35000, db: 1.043592, ltc: 0.922197 },
    { premium: 40000, db: 1.065495, ltc: 0.883098 },
    { premium: 45000, db: 1.082532, ltc: 0.852689 },
    { premium: 50000, db: 1.096162, ltc: 0.828362 },
    { premium: 55000, db: 1.107312, ltc: 0.808457 },
    { premium: 60000, db: 1.116605, ltc: 0.79187 },
  ],
  "10pay_single|55|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.979944, ltc: 1 },
    { premium: 7500, db: 0.986656, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999996, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.031666, ltc: 1 },
    { premium: 40000, db: 1.077978, ltc: 1 },
    { premium: 45000, db: 1.113999, ltc: 1 },
    { premium: 50000, db: 1.142814, ltc: 1 },
    { premium: 55000, db: 1.166391, ltc: 1 },
    { premium: 60000, db: 1.186039, ltc: 1 },
    { premium: 65000, db: 1.202662, ltc: 1 },
  ],
  "10pay_single|55|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979991, ltc: 0.979991 },
    { premium: 7500, db: 0.999998, ltc: 0.999998 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000002, ltc: 1.000002 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.023305, ltc: 0.952467 },
    { premium: 45000, db: 1.042589, ltc: 0.913129 },
    { premium: 50000, db: 1.058014, ltc: 0.881659 },
    { premium: 55000, db: 1.070635, ltc: 0.85591 },
    { premium: 60000, db: 1.081153, ltc: 0.834453 },
  ],
  "10pay_single|55|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.98003, ltc: 0.98003 },
    { premium: 7500, db: 0.986689, ltc: 0.986689 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
    { premium: 35000, db: 1.000006, ltc: 1.000006 },
    { premium: 40000, db: 1.006118, ltc: 0.989794 },
    { premium: 45000, db: 1.042393, ltc: 0.929172 },
    { premium: 50000, db: 1.071416, ltc: 0.880675 },
    { premium: 55000, db: 1.09516, ltc: 0.840996 },
    { premium: 60000, db: 1.114948, ltc: 0.80793 },
    { premium: 65000, db: 1.13169, ltc: 0.779951 },
  ],
  "10pay_single|55|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 0.979965, ltc: 1 },
    { premium: 7500, db: 0.986628, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000006, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000004, ltc: 1 },
    { premium: 40000, db: 1.000005, ltc: 1 },
    { premium: 45000, db: 1.000005, ltc: 1 },
    { premium: 50000, db: 1.040613, ltc: 1 },
    { premium: 55000, db: 1.089433, ltc: 1 },
    { premium: 60000, db: 1.130117, ltc: 1 },
    { premium: 65000, db: 1.164543, ltc: 1 },
    { premium: 70000, db: 1.194049, ltc: 1 },
    { premium: 75000, db: 1.219623, ltc: 1 },
  ],
  "10pay_single|55|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979983, ltc: 0.979983 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000004, ltc: 1.000004 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
    { premium: 35000, db: 1.000004, ltc: 1.000004 },
    { premium: 40000, db: 1.000003, ltc: 1.000003 },
    { premium: 45000, db: 1.001918, ltc: 0.994221 },
    { premium: 50000, db: 1.015927, ltc: 0.951899 },
    { premium: 55000, db: 1.027389, ltc: 0.917272 },
    { premium: 60000, db: 1.03694, ltc: 0.888416 },
  ],
  "10pay_single|55|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979923, ltc: 1 },
    { premium: 7500, db: 0.986602, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 0.999998, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1 },
    { premium: 40000, db: 1.000002, ltc: 1 },
    { premium: 45000, db: 1.000003, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.018135, ltc: 1 },
    { premium: 60000, db: 1.044893, ltc: 1 },
    { premium: 65000, db: 1.067534, ltc: 1 },
    { premium: 70000, db: 1.08694, ltc: 1 },
  ],
  "10pay_single|55|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.980035, ltc: 0.980035 },
    { premium: 7500, db: 1.000002, ltc: 1.000002 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000002, ltc: 1.000002 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000003, ltc: 1.000003 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000004, ltc: 1.000004 },
    { premium: 35000, db: 1.000004, ltc: 1.000004 },
    { premium: 40000, db: 1.000005, ltc: 1.000005 },
    { premium: 45000, db: 1.000005, ltc: 1.000005 },
    { premium: 50000, db: 1.000005, ltc: 1.000005 },
    { premium: 55000, db: 1.000004, ltc: 1.000004 },
    { premium: 60000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_single|55|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.979986, ltc: 1 },
    { premium: 7500, db: 1, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1 },
    { premium: 20000, db: 1.000003, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000002, ltc: 1 },
    { premium: 35000, db: 1.000004, ltc: 1 },
    { premium: 40000, db: 1.000003, ltc: 1 },
    { premium: 45000, db: 1.000003, ltc: 1 },
    { premium: 50000, db: 1.000003, ltc: 1 },
    { premium: 55000, db: 1.000004, ltc: 1 },
    { premium: 60000, db: 1.000003, ltc: 1 },
    { premium: 65000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|60|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 0.980011, ltc: 0.980011 },
    { premium: 7500, db: 0.986655, ltc: 0.986655 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.016142, ltc: 0.988572 },
  ],
  "10pay_single|60|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.169078, ltc: 1.169078 },
    { premium: 7500, db: 0.996673, ltc: 0.996673 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010106, ltc: 1.010106 },
    { premium: 15500, db: 1.010105, ltc: 1.010105 },
    { premium: 20000, db: 1.010104, ltc: 1.010104 },
    { premium: 25000, db: 1.010108, ltc: 1.010108 },
    { premium: 30000, db: 1.010106, ltc: 1.010106 },
    { premium: 55000, db: 1.271801, ltc: 0.848951 },
    { premium: 60000, db: 1.309114, ltc: 0.825971 },
    { premium: 65000, db: 1.340688, ltc: 0.806526 },
    { premium: 70000, db: 1.367752, ltc: 0.78986 },
    { premium: 75000, db: 1.391208, ltc: 0.775415 },
  ],
  "10pay_single|60|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.50081, ltc: 1 },
    { premium: 7500, db: 1.00054, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010103, ltc: 1 },
    { premium: 15500, db: 1.010105, ltc: 1 },
    { premium: 20000, db: 1.010098, ltc: 1 },
    { premium: 25000, db: 1.010101, ltc: 1 },
    { premium: 30000, db: 1.010103, ltc: 1 },
    { premium: 35000, db: 1.010101, ltc: 1 },
    { premium: 40000, db: 1.010102, ltc: 1 },
    { premium: 45000, db: 1.021681, ltc: 1 },
    { premium: 50000, db: 1.140271, ltc: 1 },
    { premium: 55000, db: 1.237302, ltc: 1 },
    { premium: 60000, db: 1.318161, ltc: 1 },
    { premium: 65000, db: 1.38658, ltc: 1 },
    { premium: 70000, db: 1.445225, ltc: 1 },
    { premium: 75000, db: 1.496051, ltc: 1 },
  ],
  "10pay_single|60|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 0.979956, ltc: 0.979956 },
    { premium: 7500, db: 0.986585, ltc: 0.986585 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000004, ltc: 1.000004 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.037658, ltc: 0.956481 },
    { premium: 45000, db: 1.067023, ltc: 0.922536 },
    { premium: 50000, db: 1.090517, ltc: 0.89538 },
    { premium: 55000, db: 1.109738, ltc: 0.873161 },
    { premium: 60000, db: 1.125756, ltc: 0.854646 },
    { premium: 65000, db: 1.139309, ltc: 0.838979 },
    { premium: 70000, db: 1.150927, ltc: 0.825551 },
    { premium: 75000, db: 1.160996, ltc: 0.813913 },
  ],
  "10pay_single|60|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.149301, ltc: 1 },
    { premium: 7500, db: 0.996614, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010111, ltc: 1 },
    { premium: 15500, db: 1.010107, ltc: 1 },
    { premium: 20000, db: 1.010111, ltc: 1 },
    { premium: 25000, db: 1.010111, ltc: 1 },
    { premium: 30000, db: 1.010111, ltc: 1 },
    { premium: 35000, db: 1.010111, ltc: 1 },
    { premium: 40000, db: 1.010111, ltc: 1 },
    { premium: 45000, db: 1.010111, ltc: 1 },
    { premium: 50000, db: 1.073017, ltc: 1 },
    { premium: 55000, db: 1.13084, ltc: 1 },
    { premium: 60000, db: 1.179024, ltc: 1 },
    { premium: 65000, db: 1.219797, ltc: 1 },
    { premium: 70000, db: 1.254744, ltc: 1 },
    { premium: 75000, db: 1.285032, ltc: 1 },
  ],
  "10pay_single|60|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.980003, ltc: 0.980003 },
    { premium: 7500, db: 0.986661, ltc: 0.986661 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
    { premium: 50000, db: 1.01249, ltc: 0.967887 },
    { premium: 55000, db: 1.026151, ltc: 0.932749 },
    { premium: 60000, db: 1.037535, ltc: 0.903469 },
    { premium: 65000, db: 1.047169, ltc: 0.878693 },
    { premium: 70000, db: 1.055426, ltc: 0.857457 },
  ],
  "10pay_single|60|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.97997, ltc: 1 },
    { premium: 7500, db: 0.986629, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000002, ltc: 1 },
    { premium: 40000, db: 1.000002, ltc: 1 },
    { premium: 45000, db: 1.000004, ltc: 1 },
    { premium: 50000, db: 1.000003, ltc: 1 },
    { premium: 55000, db: 1.019436, ltc: 1 },
    { premium: 60000, db: 1.042287, ltc: 1 },
    { premium: 65000, db: 1.061622, ltc: 1 },
    { premium: 70000, db: 1.078195, ltc: 1 },
    { premium: 75000, db: 1.092558, ltc: 1 },
  ],
  "10pay_single|60|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.098982, ltc: 1.098982 },
    { premium: 7500, db: 0.996634, ltc: 0.996634 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010104, ltc: 1.010104 },
    { premium: 15500, db: 1.010106, ltc: 1.010106 },
    { premium: 20000, db: 1.010108, ltc: 1.010108 },
    { premium: 25000, db: 1.088834, ltc: 0.983895 },
    { premium: 30000, db: 1.176769, ltc: 0.954617 },
  ],
  "10pay_single|60|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.391679, ltc: 1.391679 },
    { premium: 7500, db: 0.996633, ltc: 0.996633 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010083, ltc: 1.010083 },
    { premium: 15500, db: 1.010085, ltc: 1.010085 },
    { premium: 20000, db: 1.010088, ltc: 1.010088 },
    { premium: 25000, db: 1.01009, ltc: 1.01009 },
    { premium: 30000, db: 1.094778, ltc: 0.983326 },
    { premium: 35000, db: 1.230822, ltc: 0.940331 },
    { premium: 40000, db: 1.332854, ltc: 0.908085 },
    { premium: 45000, db: 1.412213, ltc: 0.883005 },
    { premium: 50000, db: 1.475698, ltc: 0.86294 },
    { premium: 55000, db: 1.527642, ltc: 0.846523 },
    { premium: 60000, db: 1.570929, ltc: 0.832843 },
    { premium: 65000, db: 1.607556, ltc: 0.821268 },
    { premium: 70000, db: 1.638951, ltc: 0.811346 },
    { premium: 75000, db: 1.66616, ltc: 0.802747 },
  ],
  "10pay_single|60|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 1.862002, ltc: 1 },
    { premium: 7500, db: 1.241335, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003345, ltc: 1 },
    { premium: 15500, db: 1.003567, ltc: 1 },
    { premium: 20000, db: 1.010091, ltc: 1 },
    { premium: 25000, db: 1.010095, ltc: 1 },
    { premium: 30000, db: 1.010097, ltc: 1 },
    { premium: 35000, db: 1.010099, ltc: 1 },
    { premium: 40000, db: 1.145659, ltc: 1 },
    { premium: 45000, db: 1.322713, ltc: 1 },
    { premium: 50000, db: 1.464359, ltc: 1 },
    { premium: 55000, db: 1.580252, ltc: 1 },
    { premium: 60000, db: 1.676829, ltc: 1 },
    { premium: 65000, db: 1.758548, ltc: 1 },
    { premium: 70000, db: 1.828593, ltc: 1 },
    { premium: 75000, db: 1.889299, ltc: 1 },
  ],
  "10pay_single|60|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 0.97996, ltc: 0.97996 },
    { premium: 7500, db: 0.986662, ltc: 0.986662 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000006, ltc: 1.000006 },
    { premium: 30000, db: 1.061277, ltc: 0.961131 },
    { premium: 35000, db: 1.115484, ltc: 0.926736 },
    { premium: 40000, db: 1.156142, ltc: 0.900941 },
    { premium: 45000, db: 1.187765, ltc: 0.880877 },
    { premium: 50000, db: 1.213061, ltc: 0.864826 },
    { premium: 55000, db: 1.233759, ltc: 0.851694 },
    { premium: 60000, db: 1.251007, ltc: 0.84075 },
    { premium: 65000, db: 1.265602, ltc: 0.83149 },
    { premium: 70000, db: 1.278111, ltc: 0.823552 },
    { premium: 75000, db: 1.288953, ltc: 0.816674 },
  ],
  "10pay_single|60|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.364094, ltc: 1 },
    { premium: 7500, db: 0.996631, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010143, ltc: 1 },
    { premium: 15500, db: 1.010142, ltc: 1 },
    { premium: 20000, db: 1.010147, ltc: 1 },
    { premium: 25000, db: 1.010145, ltc: 1 },
    { premium: 30000, db: 1.010147, ltc: 1 },
    { premium: 35000, db: 1.010145, ltc: 1 },
    { premium: 40000, db: 1.111867, ltc: 1 },
    { premium: 45000, db: 1.213737, ltc: 1 },
    { premium: 50000, db: 1.295236, ltc: 1 },
    { premium: 55000, db: 1.361914, ltc: 1 },
    { premium: 60000, db: 1.417482, ltc: 1 },
    { premium: 65000, db: 1.4645, ltc: 1 },
    { premium: 70000, db: 1.5048, ltc: 1 },
    { premium: 75000, db: 1.539728, ltc: 1 },
  ],
  "10pay_single|60|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.979978, ltc: 0.979978 },
    { premium: 7500, db: 0.986608, ltc: 0.986608 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.015407, ltc: 0.975076 },
    { premium: 40000, db: 1.042989, ltc: 0.930446 },
    { premium: 45000, db: 1.064442, ltc: 0.895733 },
    { premium: 50000, db: 1.081602, ltc: 0.867962 },
    { premium: 55000, db: 1.095645, ltc: 0.845242 },
    { premium: 60000, db: 1.107347, ltc: 0.826308 },
    { premium: 65000, db: 1.117247, ltc: 0.810286 },
    { premium: 70000, db: 1.125734, ltc: 0.796553 },
  ],
  "10pay_single|60|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 0.980022, ltc: 1 },
    { premium: 7500, db: 0.986663, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1 },
    { premium: 15500, db: 1.000007, ltc: 1 },
    { premium: 20000, db: 1.000005, ltc: 1 },
    { premium: 25000, db: 1.000008, ltc: 1 },
    { premium: 30000, db: 1.000006, ltc: 1 },
    { premium: 35000, db: 1.000008, ltc: 1 },
    { premium: 40000, db: 1.022929, ltc: 1 },
    { premium: 45000, db: 1.068256, ltc: 1 },
    { premium: 50000, db: 1.104518, ltc: 1 },
    { premium: 55000, db: 1.134187, ltc: 1 },
    { premium: 60000, db: 1.158911, ltc: 1 },
    { premium: 65000, db: 1.179831, ltc: 1 },
    { premium: 70000, db: 1.197763, ltc: 1 },
    { premium: 75000, db: 1.213303, ltc: 1 },
  ],
  "10pay_single|60|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979968, ltc: 0.979968 },
    { premium: 7500, db: 0.98664, ltc: 0.98664 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000006, ltc: 1.000006 },
    { premium: 15500, db: 1.000004, ltc: 1.000004 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000007, ltc: 1.000007 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
  ],
  "10pay_single|60|None|None|25 Months|50 Months": [
    { premium: 5000, db: 0.97998, ltc: 0.97998 },
    { premium: 7500, db: 0.986641, ltc: 0.986641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000002, ltc: 1.000002 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
  ],
  "10pay_single|60|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.115777, ltc: 1 },
    { premium: 7500, db: 0.99669, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010137, ltc: 1 },
    { premium: 15500, db: 1.010135, ltc: 1 },
    { premium: 20000, db: 1.010135, ltc: 1 },
    { premium: 25000, db: 1.010139, ltc: 1 },
    { premium: 30000, db: 1.010137, ltc: 1 },
    { premium: 35000, db: 1.010139, ltc: 1 },
    { premium: 40000, db: 1.010138, ltc: 1 },
    { premium: 45000, db: 1.01014, ltc: 1 },
    { premium: 50000, db: 1.010139, ltc: 1 },
    { premium: 55000, db: 1.010138, ltc: 1 },
    { premium: 60000, db: 1.060423, ltc: 1 },
    { premium: 65000, db: 1.105107, ltc: 1 },
    { premium: 70000, db: 1.143405, ltc: 1 },
    { premium: 75000, db: 1.176599, ltc: 1 },
  ],
  "10pay_single|60|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979946, ltc: 0.979946 },
    { premium: 7500, db: 0.986542, ltc: 0.986542 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000003, ltc: 1.000003 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000002, ltc: 1.000002 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
    { premium: 50000, db: 1.000003, ltc: 1.000003 },
    { premium: 55000, db: 1.009032, ltc: 0.975609 },
    { premium: 60000, db: 1.021296, ltc: 0.942483 },
    { premium: 65000, db: 1.031672, ltc: 0.914453 },
    { premium: 70000, db: 1.040565, ltc: 0.890427 },
  ],
  "10pay_single|60|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 0.979943, ltc: 1 },
    { premium: 7500, db: 0.986586, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.000002, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.000002, ltc: 1 },
    { premium: 60000, db: 1.000002, ltc: 1 },
    { premium: 65000, db: 1.02102, ltc: 1 },
    { premium: 70000, db: 1.04575, ltc: 1 },
    { premium: 75000, db: 1.067184, ltc: 1 },
  ],
  "10pay_single|60|None|None|50 Months|50 Months": [
    { premium: 7500, db: 0.999993, ltc: 0.999993 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999998, ltc: 0.999998 },
    { premium: 15500, db: 0.999996, ltc: 0.999996 },
    { premium: 20000, db: 0.999996, ltc: 0.999996 },
    { premium: 25000, db: 0.999999, ltc: 0.999999 },
    { premium: 30000, db: 0.999998, ltc: 0.999998 },
    { premium: 35000, db: 0.999999, ltc: 0.999999 },
    { premium: 40000, db: 0.999998, ltc: 0.999998 },
    { premium: 45000, db: 0.999999, ltc: 0.999999 },
    { premium: 50000, db: 0.999999, ltc: 0.999999 },
    { premium: 55000, db: 0.999999, ltc: 0.999999 },
    { premium: 60000, db: 0.999999, ltc: 0.999999 },
    { premium: 65000, db: 0.999999, ltc: 0.999999 },
    { premium: 70000, db: 0.999999, ltc: 0.999999 },
  ],
  "10pay_single|60|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.980006, ltc: 1 },
    { premium: 7500, db: 0.986581, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1 },
    { premium: 15500, db: 1.000001, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1.000003, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1 },
    { premium: 40000, db: 1.000002, ltc: 1 },
    { premium: 45000, db: 1.000003, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.000002, ltc: 1 },
    { premium: 60000, db: 1.000003, ltc: 1 },
    { premium: 65000, db: 1.000002, ltc: 1 },
    { premium: 70000, db: 1.000002, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
  ],
  "10pay_single|65|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 1.129102, ltc: 1.129102 },
    { premium: 7500, db: 0.996647, ltc: 0.996647 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010118, ltc: 1.010118 },
    { premium: 15500, db: 1.010116, ltc: 1.010116 },
    { premium: 20000, db: 1.010114, ltc: 1.010114 },
    { premium: 25000, db: 1.010116, ltc: 1.010116 },
    { premium: 30000, db: 1.010118, ltc: 1.010118 },
    { premium: 35000, db: 1.029106, ltc: 0.998328 },
    { premium: 40000, db: 1.083052, ltc: 0.964829 },
    { premium: 45000, db: 1.125011, ltc: 0.938775 },
    { premium: 50000, db: 1.158575, ltc: 0.91793 },
    { premium: 55000, db: 1.186039, ltc: 0.900876 },
    { premium: 60000, db: 1.208925, ltc: 0.886665 },
    { premium: 65000, db: 1.228291, ltc: 0.87464 },
    { premium: 70000, db: 1.24489, ltc: 0.864333 },
    { premium: 75000, db: 1.259274, ltc: 0.855399 },
  ],
  "10pay_single|65|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.37431, ltc: 1.37431 },
    { premium: 7500, db: 0.996601, ltc: 0.996601 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010077, ltc: 1.010077 },
    { premium: 15500, db: 1.010082, ltc: 1.010082 },
    { premium: 20000, db: 1.010079, ltc: 1.010079 },
    { premium: 25000, db: 1.010081, ltc: 1.010081 },
    { premium: 30000, db: 1.010081, ltc: 1.010081 },
    { premium: 35000, db: 1.010082, ltc: 1.010082 },
    { premium: 40000, db: 1.010083, ltc: 1.010083 },
    { premium: 45000, db: 1.081558, ltc: 0.971238 },
    { premium: 50000, db: 1.151213, ltc: 0.933385 },
    { premium: 55000, db: 1.208204, ltc: 0.902414 },
    { premium: 60000, db: 1.255696, ltc: 0.876604 },
    { premium: 65000, db: 1.295879, ltc: 0.854765 },
    { premium: 70000, db: 1.330324, ltc: 0.836046 },
    { premium: 75000, db: 1.360176, ltc: 0.819823 },
  ],
  "10pay_single|65|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 1.778778, ltc: 1 },
    { premium: 7500, db: 1.185852, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003379, ltc: 1 },
    { premium: 15500, db: 1.003601, ltc: 1 },
    { premium: 20000, db: 1.010102, ltc: 1 },
    { premium: 25000, db: 1.010102, ltc: 1 },
    { premium: 30000, db: 1.010108, ltc: 1 },
    { premium: 35000, db: 1.010108, ltc: 1 },
    { premium: 40000, db: 1.010107, ltc: 1 },
    { premium: 45000, db: 1.010106, ltc: 1 },
    { premium: 50000, db: 1.010106, ltc: 1 },
    { premium: 55000, db: 1.0612, ltc: 1 },
    { premium: 60000, db: 1.164559, ltc: 1 },
    { premium: 65000, db: 1.252017, ltc: 1 },
    { premium: 70000, db: 1.326978, ltc: 1 },
    { premium: 75000, db: 1.391946, ltc: 1 },
  ],
  "10pay_single|65|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 1.024691, ltc: 1.024691 },
    { premium: 7500, db: 0.996694, ltc: 0.996694 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010156, ltc: 1.010156 },
    { premium: 15500, db: 1.010156, ltc: 1.010156 },
    { premium: 20000, db: 1.010158, ltc: 1.010158 },
    { premium: 25000, db: 1.010159, ltc: 1.010159 },
    { premium: 30000, db: 1.01016, ltc: 1.01016 },
    { premium: 35000, db: 1.01016, ltc: 1.01016 },
    { premium: 40000, db: 1.010161, ltc: 1.010161 },
    { premium: 45000, db: 1.042811, ltc: 0.976741 },
    { premium: 50000, db: 1.072699, ltc: 0.946152 },
    { premium: 55000, db: 1.097151, ltc: 0.921123 },
    { premium: 60000, db: 1.117528, ltc: 0.900266 },
    { premium: 65000, db: 1.134771, ltc: 0.882618 },
    { premium: 70000, db: 1.14955, ltc: 0.867491 },
    { premium: 75000, db: 1.162358, ltc: 0.854381 },
  ],
  "10pay_single|65|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.353514, ltc: 1 },
    { premium: 7500, db: 0.996617, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010086, ltc: 1 },
    { premium: 15500, db: 1.010085, ltc: 1 },
    { premium: 20000, db: 1.010088, ltc: 1 },
    { premium: 25000, db: 1.010084, ltc: 1 },
    { premium: 30000, db: 1.010086, ltc: 1 },
    { premium: 35000, db: 1.010087, ltc: 1 },
    { premium: 40000, db: 1.010088, ltc: 1 },
    { premium: 45000, db: 1.010089, ltc: 1 },
    { premium: 50000, db: 1.010087, ltc: 1 },
    { premium: 55000, db: 1.029653, ltc: 1 },
    { premium: 60000, db: 1.091527, ltc: 1 },
    { premium: 65000, db: 1.143884, ltc: 1 },
    { premium: 70000, db: 1.18876, ltc: 1 },
    { premium: 75000, db: 1.227653, ltc: 1 },
  ],
  "10pay_single|65|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 0.980026, ltc: 0.980026 },
    { premium: 7500, db: 0.986702, ltc: 0.986702 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 1.000003, ltc: 1.000003 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000003, ltc: 1.000003 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000002, ltc: 1.000002 },
    { premium: 50000, db: 1.000002, ltc: 1.000002 },
    { premium: 55000, db: 1.006452, ltc: 0.984864 },
    { premium: 60000, db: 1.020547, ltc: 0.951775 },
    { premium: 65000, db: 1.032475, ltc: 0.923777 },
    { premium: 70000, db: 1.042701, ltc: 0.89978 },
    { premium: 75000, db: 1.051561, ltc: 0.878982 },
  ],
  "10pay_single|65|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 0.988779, ltc: 1 },
    { premium: 7500, db: 0.986624, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 0.999999, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 0.999998, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 0.999999, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1.000001, ltc: 1 },
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 55000, db: 1.000001, ltc: 1 },
    { premium: 60000, db: 1.003605, ltc: 1 },
    { premium: 65000, db: 1.027651, ltc: 1 },
    { premium: 70000, db: 1.048262, ltc: 1 },
    { premium: 75000, db: 1.066125, ltc: 1 },
  ],
  "10pay_single|65|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.280196, ltc: 1.280196 },
    { premium: 7500, db: 0.996655, ltc: 0.996655 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010112, ltc: 1.010112 },
    { premium: 15500, db: 1.010106, ltc: 1.010106 },
    { premium: 20000, db: 1.010112, ltc: 1.010112 },
    { premium: 25000, db: 1.010112, ltc: 1.010112 },
    { premium: 30000, db: 1.110406, ltc: 0.981875 },
    { premium: 35000, db: 1.188396, ltc: 0.959917 },
    { premium: 40000, db: 1.24689, ltc: 0.943449 },
    { premium: 45000, db: 1.292381, ltc: 0.930639 },
    { premium: 50000, db: 1.328777, ltc: 0.920392 },
    { premium: 55000, db: 1.358556, ltc: 0.912008 },
    { premium: 60000, db: 1.383371, ltc: 0.905022 },
    { premium: 65000, db: 1.404369, ltc: 0.89911 },
    { premium: 70000, db: 1.422365, ltc: 0.894042 },
    { premium: 75000, db: 1.437964, ltc: 0.889651 },
  ],
  "10pay_single|65|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.634717, ltc: 1.634717 },
    { premium: 7500, db: 1.089811, ltc: 1.089811 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003324, ltc: 1.003324 },
    { premium: 15500, db: 1.003575, ltc: 1.003575 },
    { premium: 20000, db: 1.010085, ltc: 1.010085 },
    { premium: 25000, db: 1.010082, ltc: 1.010082 },
    { premium: 30000, db: 1.010085, ltc: 1.010085 },
    { premium: 35000, db: 1.093303, ltc: 0.987109 },
    { premium: 40000, db: 1.221024, ltc: 0.951848 },
    { premium: 45000, db: 1.320363, ltc: 0.924423 },
    { premium: 50000, db: 1.399833, ltc: 0.902483 },
    { premium: 55000, db: 1.464852, ltc: 0.884531 },
    { premium: 60000, db: 1.519037, ltc: 0.869572 },
    { premium: 65000, db: 1.564885, ltc: 0.856915 },
    { premium: 70000, db: 1.604184, ltc: 0.846065 },
    { premium: 75000, db: 1.638243, ltc: 0.836663 },
  ],
  "10pay_single|65|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.903358, ltc: 1 },
    { premium: 15500, db: 0.903556, ltc: 1 },
    { premium: 20000, db: 0.904901, ltc: 1 },
    { premium: 25000, db: 0.909435, ltc: 1 },
    { premium: 30000, db: 0.909431, ltc: 1 },
    { premium: 35000, db: 0.909434, ltc: 1 },
    { premium: 40000, db: 0.909436, ltc: 1 },
    { premium: 45000, db: 0.947549, ltc: 1 },
    { premium: 50000, db: 1.111563, ltc: 1 },
    { premium: 55000, db: 1.245756, ltc: 1 },
    { premium: 60000, db: 1.357584, ltc: 1 },
    { premium: 65000, db: 1.452204, ltc: 1 },
    { premium: 70000, db: 1.53331, ltc: 1 },
    { premium: 75000, db: 1.603602, ltc: 1 },
  ],
  "10pay_single|65|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 1.132889, ltc: 1.132889 },
    { premium: 7500, db: 0.996572, ltc: 0.996572 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010081, ltc: 1.010081 },
    { premium: 15500, db: 1.010083, ltc: 1.010083 },
    { premium: 20000, db: 1.010081, ltc: 1.010081 },
    { premium: 25000, db: 1.010081, ltc: 1.010081 },
    { premium: 30000, db: 1.011595, ltc: 1.009224 },
    { premium: 35000, db: 1.078995, ltc: 0.971006 },
    { premium: 40000, db: 1.129542, ltc: 0.942341 },
    { premium: 45000, db: 1.168857, ltc: 0.920046 },
    { premium: 50000, db: 1.20031, ltc: 0.902211 },
    { premium: 55000, db: 1.226043, ltc: 0.887618 },
    { premium: 60000, db: 1.247487, ltc: 0.875457 },
    { premium: 65000, db: 1.265634, ltc: 0.865168 },
    { premium: 70000, db: 1.281187, ltc: 0.856348 },
    { premium: 75000, db: 1.294666, ltc: 0.848703 },
  ],
  "10pay_single|65|None|5%|33 Months|Lifetime": [
    { premium: 5000, db: 1.609514, ltc: 1 },
    { premium: 7500, db: 1.07301, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00338, ltc: 1 },
    { premium: 15500, db: 1.003562, ltc: 1 },
    { premium: 20000, db: 1.010115, ltc: 1 },
    { premium: 25000, db: 1.010113, ltc: 1 },
    { premium: 30000, db: 1.010117, ltc: 1 },
    { premium: 35000, db: 1.010116, ltc: 1 },
    { premium: 40000, db: 1.010119, ltc: 1 },
    { premium: 45000, db: 1.071443, ltc: 1 },
    { premium: 50000, db: 1.175052, ltc: 1 },
    { premium: 55000, db: 1.259823, ltc: 1 },
    { premium: 60000, db: 1.330469, ltc: 1 },
    { premium: 65000, db: 1.390243, ltc: 1 },
    { premium: 70000, db: 1.441478, ltc: 1 },
    { premium: 75000, db: 1.485882, ltc: 1 },
  ],
  "10pay_single|65|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 0.980012, ltc: 0.980012 },
    { premium: 7500, db: 0.986697, ltc: 0.986697 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 0.999999, ltc: 0.999999 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000004, ltc: 1.000004 },
    { premium: 40000, db: 1.014833, ltc: 0.978169 },
    { premium: 45000, db: 1.041352, ltc: 0.939122 },
    { premium: 50000, db: 1.062567, ltc: 0.907885 },
    { premium: 55000, db: 1.079924, ltc: 0.882327 },
    { premium: 60000, db: 1.094389, ltc: 0.861029 },
    { premium: 65000, db: 1.106628, ltc: 0.843008 },
    { premium: 70000, db: 1.117119, ltc: 0.827561 },
    { premium: 75000, db: 1.126211, ltc: 0.814173 },
  ],
  "10pay_single|65|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 1.107892, ltc: 1 },
    { premium: 7500, db: 0.996666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.01012, ltc: 1 },
    { premium: 15500, db: 1.01012, ltc: 1 },
    { premium: 20000, db: 1.010123, ltc: 1 },
    { premium: 25000, db: 1.010126, ltc: 1 },
    { premium: 30000, db: 1.010123, ltc: 1 },
    { premium: 35000, db: 1.010125, ltc: 1 },
    { premium: 40000, db: 1.010126, ltc: 1 },
    { premium: 45000, db: 1.021892, ltc: 1 },
    { premium: 50000, db: 1.067167, ltc: 1 },
    { premium: 55000, db: 1.10421, ltc: 1 },
    { premium: 60000, db: 1.13508, ltc: 1 },
    { premium: 65000, db: 1.1612, ltc: 1 },
    { premium: 70000, db: 1.183588, ltc: 1 },
    { premium: 75000, db: 1.202993, ltc: 1 },
  ],
  "10pay_single|65|None|None|25 Months|25 Months": [
    { premium: 5000, db: 0.979983, ltc: 0.979983 },
    { premium: 7500, db: 0.986636, ltc: 0.986636 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1, ltc: 1 },
    { premium: 15500, db: 0.999997, ltc: 0.999997 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1, ltc: 1 },
    { premium: 40000, db: 1, ltc: 1 },
    { premium: 45000, db: 1, ltc: 1 },
    { premium: 50000, db: 1.009765, ltc: 0.984683 },
    { premium: 55000, db: 1.030852, ltc: 0.951608 },
    { premium: 60000, db: 1.048425, ltc: 0.924046 },
    { premium: 65000, db: 1.063294, ltc: 0.900724 },
    { premium: 70000, db: 1.076037, ltc: 0.880733 },
    { premium: 75000, db: 1.087083, ltc: 0.863409 },
  ],
  "10pay_single|65|None|None|25 Months|50 Months": [
    { premium: 5000, db: 1.100199, ltc: 1.100199 },
    { premium: 7500, db: 0.996645, ltc: 0.996645 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010102, ltc: 1.010102 },
    { premium: 15500, db: 1.010099, ltc: 1.010099 },
    { premium: 20000, db: 1.010098, ltc: 1.010098 },
    { premium: 25000, db: 1.0101, ltc: 1.0101 },
    { premium: 30000, db: 1.010102, ltc: 1.010102 },
    { premium: 35000, db: 1.0101, ltc: 1.0101 },
    { premium: 40000, db: 1.010101, ltc: 1.010101 },
    { premium: 45000, db: 1.010102, ltc: 1.010102 },
    { premium: 50000, db: 1.0101, ltc: 1.0101 },
    { premium: 55000, db: 1.014235, ltc: 1.004746 },
    { premium: 60000, db: 1.04833, ltc: 0.960555 },
    { premium: 65000, db: 1.077182, ltc: 0.923164 },
    { premium: 70000, db: 1.101912, ltc: 0.891114 },
    { premium: 75000, db: 1.123345, ltc: 0.863338 },
  ],
  "10pay_single|65|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.316997, ltc: 1 },
    { premium: 7500, db: 0.99666, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1 },
    { premium: 15500, db: 1.010127, ltc: 1 },
    { premium: 20000, db: 1.010132, ltc: 1 },
    { premium: 25000, db: 1.010131, ltc: 1 },
    { premium: 30000, db: 1.01013, ltc: 1 },
    { premium: 35000, db: 1.010129, ltc: 1 },
    { premium: 40000, db: 1.010132, ltc: 1 },
    { premium: 45000, db: 1.010131, ltc: 1 },
    { premium: 50000, db: 1.010131, ltc: 1 },
    { premium: 55000, db: 1.01013, ltc: 1 },
    { premium: 60000, db: 1.010132, ltc: 1 },
    { premium: 65000, db: 1.010132, ltc: 1 },
    { premium: 70000, db: 1.057946, ltc: 1 },
    { premium: 75000, db: 1.101005, ltc: 1 },
  ],
  "10pay_single|65|None|None|33 Months|33 Months": [
    { premium: 5000, db: 0.979932, ltc: 0.979932 },
    { premium: 7500, db: 0.986612, ltc: 0.986612 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000006, ltc: 1.000006 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000006, ltc: 1.000006 },
    { premium: 35000, db: 1.000006, ltc: 1.000006 },
    { premium: 40000, db: 1.000007, ltc: 1.000007 },
    { premium: 45000, db: 1.000007, ltc: 1.000007 },
    { premium: 50000, db: 1.000007, ltc: 1.000007 },
    { premium: 55000, db: 1.000007, ltc: 1.000007 },
    { premium: 60000, db: 1.000262, ltc: 0.999413 },
    { premium: 65000, db: 1.013853, ltc: 0.967802 },
    { premium: 70000, db: 1.025501, ltc: 0.940707 },
    { premium: 75000, db: 1.035597, ltc: 0.917224 },
  ],
  "10pay_single|65|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 1.084692, ltc: 1 },
    { premium: 7500, db: 0.996689, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010157, ltc: 1 },
    { premium: 15500, db: 1.01016, ltc: 1 },
    { premium: 20000, db: 1.010161, ltc: 1 },
    { premium: 25000, db: 1.010163, ltc: 1 },
    { premium: 30000, db: 1.010161, ltc: 1 },
    { premium: 35000, db: 1.010162, ltc: 1 },
    { premium: 40000, db: 1.010161, ltc: 1 },
    { premium: 45000, db: 1.010162, ltc: 1 },
    { premium: 50000, db: 1.010163, ltc: 1 },
    { premium: 55000, db: 1.010162, ltc: 1 },
    { premium: 60000, db: 1.010163, ltc: 1 },
    { premium: 65000, db: 1.010163, ltc: 1 },
    { premium: 70000, db: 1.010162, ltc: 1 },
    { premium: 75000, db: 1.028931, ltc: 1 },
  ],
  "10pay_single|65|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.979961, ltc: 0.979961 },
    { premium: 7500, db: 0.986671, ltc: 0.986671 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000005, ltc: 1.000005 },
    { premium: 20000, db: 1.000004, ltc: 1.000004 },
    { premium: 25000, db: 1.000005, ltc: 1.000005 },
    { premium: 30000, db: 1.000005, ltc: 1.000005 },
    { premium: 35000, db: 1.000006, ltc: 1.000006 },
    { premium: 40000, db: 1.000004, ltc: 1.000004 },
    { premium: 45000, db: 1.000005, ltc: 1.000005 },
    { premium: 50000, db: 1.000005, ltc: 1.000005 },
    { premium: 55000, db: 1.000005, ltc: 1.000005 },
    { premium: 60000, db: 1.000005, ltc: 1.000005 },
    { premium: 65000, db: 1.000006, ltc: 1.000006 },
    { premium: 70000, db: 1.000006, ltc: 1.000006 },
    { premium: 75000, db: 1.000006, ltc: 1.000006 },
  ],
  "10pay_single|65|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 0.980021, ltc: 1 },
    { premium: 7500, db: 0.986631, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.999997, ltc: 1 },
    { premium: 15500, db: 1, ltc: 1 },
    { premium: 20000, db: 1, ltc: 1 },
    { premium: 25000, db: 1.000002, ltc: 1 },
    { premium: 30000, db: 1, ltc: 1 },
    { premium: 35000, db: 1.000001, ltc: 1 },
    { premium: 40000, db: 1.000002, ltc: 1 },
    { premium: 45000, db: 1.000001, ltc: 1 },
    { premium: 50000, db: 1.000002, ltc: 1 },
    { premium: 55000, db: 1.000002, ltc: 1 },
    { premium: 60000, db: 1.000001, ltc: 1 },
    { premium: 65000, db: 1.000002, ltc: 1 },
    { premium: 70000, db: 1.000001, ltc: 1 },
    { premium: 75000, db: 1.000002, ltc: 1 },
  ],
  "10pay_single|70|None|3%|25 Months|25 Months": [
    { premium: 5000, db: 1.316391, ltc: 1.316391 },
    { premium: 7500, db: 0.996657, ltc: 0.996657 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1.010125 },
    { premium: 15500, db: 1.010129, ltc: 1.010129 },
    { premium: 20000, db: 1.010127, ltc: 1.010127 },
    { premium: 25000, db: 1.010129, ltc: 1.010129 },
    { premium: 30000, db: 1.01013, ltc: 1.01013 },
    { premium: 35000, db: 1.01013, ltc: 1.01013 },
    { premium: 40000, db: 1.021051, ltc: 1.004063 },
    { premium: 45000, db: 1.073006, ltc: 0.975203 },
    { premium: 50000, db: 1.114569, ltc: 0.952115 },
    { premium: 55000, db: 1.148573, ltc: 0.933223 },
    { premium: 60000, db: 1.176913, ltc: 0.917482 },
    { premium: 65000, db: 1.200892, ltc: 0.904162 },
    { premium: 70000, db: 1.221445, ltc: 0.892744 },
    { premium: 75000, db: 1.239257, ltc: 0.882849 },
  ],
  "10pay_single|70|None|3%|25 Months|50 Months": [
    { premium: 5000, db: 1.6192, ltc: 1.6192 },
    { premium: 7500, db: 1.079467, ltc: 1.079467 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003357, ltc: 1.003357 },
    { premium: 15500, db: 1.003598, ltc: 1.003598 },
    { premium: 20000, db: 1.01011, ltc: 1.01011 },
    { premium: 25000, db: 1.010108, ltc: 1.010108 },
    { premium: 30000, db: 1.010113, ltc: 1.010113 },
    { premium: 35000, db: 1.010111, ltc: 1.010111 },
    { premium: 40000, db: 1.01011, ltc: 1.01011 },
    { premium: 45000, db: 1.010113, ltc: 1.010113 },
    { premium: 50000, db: 1.041622, ltc: 0.994771 },
    { premium: 55000, db: 1.113397, ltc: 0.959827 },
    { premium: 60000, db: 1.17321, ltc: 0.930706 },
    { premium: 65000, db: 1.223818, ltc: 0.906065 },
    { premium: 70000, db: 1.267199, ltc: 0.884945 },
    { premium: 75000, db: 1.304795, ltc: 0.866641 },
  ],
  "10pay_single|70|None|3%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.953297, ltc: 1 },
    { premium: 15500, db: 0.953524, ltc: 1 },
    { premium: 20000, db: 0.954894, ltc: 1 },
    { premium: 25000, db: 0.959707, ltc: 1 },
    { premium: 30000, db: 0.959703, ltc: 1 },
    { premium: 35000, db: 0.959706, ltc: 1 },
    { premium: 40000, db: 0.959708, ltc: 1 },
    { premium: 45000, db: 0.959705, ltc: 1 },
    { premium: 50000, db: 0.959707, ltc: 1 },
    { premium: 55000, db: 0.959705, ltc: 1 },
    { premium: 60000, db: 0.959707, ltc: 1 },
    { premium: 65000, db: 1.009516, ltc: 1 },
    { premium: 70000, db: 1.098978, ltc: 1 },
    { premium: 75000, db: 1.176514, ltc: 1 },
  ],
  "10pay_single|70|None|3%|33 Months|33 Months": [
    { premium: 5000, db: 1.1901, ltc: 1.1901 },
    { premium: 7500, db: 0.996652, ltc: 0.996652 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010106, ltc: 1.010106 },
    { premium: 15500, db: 1.010103, ltc: 1.010103 },
    { premium: 20000, db: 1.010108, ltc: 1.010108 },
    { premium: 25000, db: 1.010109, ltc: 1.010109 },
    { premium: 30000, db: 1.010106, ltc: 1.010106 },
    { premium: 35000, db: 1.010107, ltc: 1.010107 },
    { premium: 40000, db: 1.010108, ltc: 1.010108 },
    { premium: 45000, db: 1.010109, ltc: 1.010109 },
    { premium: 50000, db: 1.030445, ltc: 0.991186 },
    { premium: 55000, db: 1.060692, ltc: 0.96304 },
    { premium: 60000, db: 1.0859, ltc: 0.939586 },
    { premium: 65000, db: 1.107227, ltc: 0.91974 },
    { premium: 70000, db: 1.125508, ltc: 0.902728 },
    { premium: 75000, db: 1.141353, ltc: 0.887986 },
  ],
  "10pay_single|70|None|3%|33 Months|Lifetime": [
    { premium: 5000, db: 1.583395, ltc: 1 },
    { premium: 7500, db: 1.055597, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003362, ltc: 1 },
    { premium: 15500, db: 1.003548, ltc: 1 },
    { premium: 20000, db: 1.010077, ltc: 1 },
    { premium: 25000, db: 1.010079, ltc: 1 },
    { premium: 30000, db: 1.01008, ltc: 1 },
    { premium: 35000, db: 1.01008, ltc: 1 },
    { premium: 40000, db: 1.010081, ltc: 1 },
    { premium: 45000, db: 1.010081, ltc: 1 },
    { premium: 50000, db: 1.010082, ltc: 1 },
    { premium: 55000, db: 1.010082, ltc: 1 },
    { premium: 60000, db: 1.010082, ltc: 1 },
    { premium: 65000, db: 1.038568, ltc: 1 },
    { premium: 70000, db: 1.093938, ltc: 1 },
    { premium: 75000, db: 1.141924, ltc: 1 },
  ],
  "10pay_single|70|None|3%|50 Months|50 Months": [
    { premium: 5000, db: 1.03089, ltc: 1.03089 },
    { premium: 7500, db: 0.996623, ltc: 0.996623 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010097, ltc: 1.010097 },
    { premium: 15500, db: 1.010097, ltc: 1.010097 },
    { premium: 20000, db: 1.010096, ltc: 1.010096 },
    { premium: 25000, db: 1.010099, ltc: 1.010099 },
    { premium: 30000, db: 1.010097, ltc: 1.010097 },
    { premium: 35000, db: 1.010096, ltc: 1.010096 },
    { premium: 40000, db: 1.010098, ltc: 1.010098 },
    { premium: 45000, db: 1.010097, ltc: 1.010097 },
    { premium: 50000, db: 1.010097, ltc: 1.010097 },
    { premium: 55000, db: 1.010098, ltc: 1.010098 },
    { premium: 60000, db: 1.010097, ltc: 1.010097 },
    { premium: 65000, db: 1.021189, ltc: 0.986304 },
    { premium: 70000, db: 1.034032, ltc: 0.958747 },
    { premium: 75000, db: 1.045165, ltc: 0.934864 },
  ],
  "10pay_single|70|None|3%|50 Months|Lifetime": [
    { premium: 5000, db: 1.155772, ltc: 1 },
    { premium: 7500, db: 0.996638, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010134, ltc: 1 },
    { premium: 15500, db: 1.010134, ltc: 1 },
    { premium: 20000, db: 1.010134, ltc: 1 },
    { premium: 25000, db: 1.010134, ltc: 1 },
    { premium: 30000, db: 1.010134, ltc: 1 },
    { premium: 35000, db: 1.010134, ltc: 1 },
    { premium: 40000, db: 1.010134, ltc: 1 },
    { premium: 45000, db: 1.010136, ltc: 1 },
    { premium: 50000, db: 1.010136, ltc: 1 },
    { premium: 55000, db: 1.010136, ltc: 1 },
    { premium: 60000, db: 1.010136, ltc: 1 },
    { premium: 65000, db: 1.010135, ltc: 1 },
    { premium: 70000, db: 1.016699, ltc: 1 },
    { premium: 75000, db: 1.038679, ltc: 1 },
  ],
  "10pay_single|70|None|5%|25 Months|25 Months": [
    { premium: 5000, db: 1.486283, ltc: 1.486283 },
    { premium: 7500, db: 0.996641, ltc: 0.996641 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1.010125 },
    { premium: 15500, db: 1.010129, ltc: 1.010129 },
    { premium: 20000, db: 1.010128, ltc: 1.010128 },
    { premium: 25000, db: 1.010129, ltc: 1.010129 },
    { premium: 30000, db: 1.02301, ltc: 1.006873 },
    { premium: 35000, db: 1.116995, ltc: 0.983099 },
    { premium: 40000, db: 1.187487, ltc: 0.96527 },
    { premium: 45000, db: 1.242314, ltc: 0.951403 },
    { premium: 50000, db: 1.286173, ltc: 0.940308 },
    { premium: 55000, db: 1.322061, ltc: 0.931231 },
    { premium: 60000, db: 1.351967, ltc: 0.923667 },
    { premium: 65000, db: 1.377269, ltc: 0.917266 },
    { premium: 70000, db: 1.39896, ltc: 0.911781 },
    { premium: 75000, db: 1.417758, ltc: 0.907026 },
  ],
  "10pay_single|70|None|5%|25 Months|50 Months": [
    { premium: 5000, db: 1.911473, ltc: 1.911473 },
    { premium: 7500, db: 1.274315, ltc: 1.274315 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003357, ltc: 1.003357 },
    { premium: 15500, db: 1.003568, ltc: 1.003568 },
    { premium: 20000, db: 1.010091, ltc: 1.010091 },
    { premium: 25000, db: 1.010095, ltc: 1.010095 },
    { premium: 30000, db: 1.010098, ltc: 1.010098 },
    { premium: 35000, db: 1.010094, ltc: 1.010094 },
    { premium: 40000, db: 1.072229, ltc: 0.994478 },
    { premium: 45000, db: 1.193284, ltc: 0.964045 },
    { premium: 50000, db: 1.290132, ltc: 0.939699 },
    { premium: 55000, db: 1.369372, ltc: 0.91978 },
    { premium: 60000, db: 1.435401, ltc: 0.903179 },
    { premium: 65000, db: 1.491275, ltc: 0.889134 },
    { premium: 70000, db: 1.539167, ltc: 0.877095 },
    { premium: 75000, db: 1.580671, ltc: 0.86666 },
  ],
  "10pay_single|70|None|5%|25 Months|Lifetime": [
    { premium: 5000, db: 2, ltc: 1 },
    { premium: 7500, db: 1.333333, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 0.772536, ltc: 1 },
    { premium: 15500, db: 0.77271, ltc: 1 },
    { premium: 20000, db: 0.773853, ltc: 1 },
    { premium: 25000, db: 0.774635, ltc: 1 },
    { premium: 30000, db: 0.777736, ltc: 1 },
    { premium: 35000, db: 0.777734, ltc: 1 },
    { premium: 40000, db: 0.777737, ltc: 1 },
    { premium: 45000, db: 0.777736, ltc: 1 },
    { premium: 50000, db: 0.777738, ltc: 1 },
    { premium: 55000, db: 0.874185, ltc: 1 },
    { premium: 60000, db: 0.989834, ltc: 1 },
    { premium: 65000, db: 1.087688, ltc: 1 },
    { premium: 70000, db: 1.171566, ltc: 1 },
    { premium: 75000, db: 1.24426, ltc: 1 },
  ],
  "10pay_single|70|None|5%|33 Months|33 Months": [
    { premium: 5000, db: 1.316788, ltc: 1.316788 },
    { premium: 7500, db: 0.996669, ltc: 0.996669 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010125, ltc: 1.010125 },
    { premium: 15500, db: 1.010124, ltc: 1.010124 },
    { premium: 20000, db: 1.010125, ltc: 1.010125 },
    { premium: 25000, db: 1.01013, ltc: 1.01013 },
    { premium: 30000, db: 1.010129, ltc: 1.010129 },
    { premium: 35000, db: 1.013582, ltc: 1.008355 },
    { premium: 40000, db: 1.075422, ltc: 0.976579 },
    { premium: 45000, db: 1.123522, ltc: 0.951866 },
    { premium: 50000, db: 1.162, ltc: 0.932095 },
    { premium: 55000, db: 1.193482, ltc: 0.915918 },
    { premium: 60000, db: 1.219719, ltc: 0.902439 },
    { premium: 65000, db: 1.241918, ltc: 0.891032 },
    { premium: 70000, db: 1.260945, ltc: 0.881255 },
    { premium: 75000, db: 1.277437, ltc: 0.872782 },
  ],
  "10pay_single|70|None|5%|33 Months|Lifetime": [
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.00336, ltc: 1 },
    { premium: 15500, db: 1.003583, ltc: 1 },
    { premium: 20000, db: 1.010099, ltc: 1 },
    { premium: 25000, db: 1.010103, ltc: 1 },
    { premium: 30000, db: 1.010105, ltc: 1 },
    { premium: 35000, db: 1.010107, ltc: 1 },
    { premium: 40000, db: 1.010104, ltc: 1 },
    { premium: 45000, db: 1.010105, ltc: 1 },
    { premium: 50000, db: 1.018159, ltc: 1 },
    { premium: 55000, db: 1.121461, ltc: 1 },
    { premium: 60000, db: 1.207542, ltc: 1 },
    { premium: 65000, db: 1.28038, ltc: 1 },
    { premium: 70000, db: 1.342815, ltc: 1 },
    { premium: 75000, db: 1.396923, ltc: 1 },
  ],
  "10pay_single|70|None|5%|50 Months|50 Months": [
    { premium: 5000, db: 1.099196, ltc: 1.099196 },
    { premium: 7500, db: 0.99663, ltc: 0.99663 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010103, ltc: 1.010103 },
    { premium: 15500, db: 1.010107, ltc: 1.010107 },
    { premium: 20000, db: 1.010105, ltc: 1.010105 },
    { premium: 25000, db: 1.010106, ltc: 1.010106 },
    { premium: 30000, db: 1.010107, ltc: 1.010107 },
    { premium: 35000, db: 1.010108, ltc: 1.010108 },
    { premium: 40000, db: 1.010108, ltc: 1.010108 },
    { premium: 45000, db: 1.019003, ltc: 0.997945 },
    { premium: 50000, db: 1.04516, ltc: 0.962179 },
    { premium: 55000, db: 1.066563, ltc: 0.932917 },
    { premium: 60000, db: 1.084398, ltc: 0.908531 },
    { premium: 65000, db: 1.09949, ltc: 0.887898 },
    { premium: 70000, db: 1.112424, ltc: 0.870212 },
    { premium: 75000, db: 1.123636, ltc: 0.854884 },
  ],
  "10pay_single|70|None|5%|50 Months|Lifetime": [
    { premium: 5000, db: 1.281184, ltc: 1 },
    { premium: 7500, db: 0.996644, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010094, ltc: 1 },
    { premium: 15500, db: 1.010094, ltc: 1 },
    { premium: 20000, db: 1.010094, ltc: 1 },
    { premium: 25000, db: 1.010094, ltc: 1 },
    { premium: 30000, db: 1.010094, ltc: 1 },
    { premium: 35000, db: 1.010094, ltc: 1 },
    { premium: 40000, db: 1.010094, ltc: 1 },
    { premium: 45000, db: 1.010094, ltc: 1 },
    { premium: 50000, db: 1.010094, ltc: 1 },
    { premium: 55000, db: 1.047603, ltc: 1 },
    { premium: 60000, db: 1.08468, ltc: 1 },
    { premium: 65000, db: 1.116056, ltc: 1 },
    { premium: 70000, db: 1.142947, ltc: 1 },
    { premium: 75000, db: 1.166254, ltc: 1 },
  ],
  "10pay_single|70|None|None|25 Months|25 Months": [
    { premium: 5000, db: 1.138004, ltc: 1.138004 },
    { premium: 7500, db: 0.996666, ltc: 0.996666 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010115, ltc: 1.010115 },
    { premium: 15500, db: 1.010116, ltc: 1.010116 },
    { premium: 20000, db: 1.010115, ltc: 1.010115 },
    { premium: 25000, db: 1.01012, ltc: 1.01012 },
    { premium: 30000, db: 1.010119, ltc: 1.010119 },
    { premium: 35000, db: 1.010118, ltc: 1.010118 },
    { premium: 40000, db: 1.010118, ltc: 1.010118 },
    { premium: 45000, db: 1.010118, ltc: 1.010118 },
    { premium: 50000, db: 1.01012, ltc: 1.01012 },
    { premium: 55000, db: 1.010119, ltc: 1.010119 },
    { premium: 60000, db: 1.027099, ltc: 0.987632 },
    { premium: 65000, db: 1.047088, ltc: 0.961159 },
    { premium: 70000, db: 1.064221, ltc: 0.938467 },
    { premium: 75000, db: 1.07907, ltc: 0.918801 },
  ],
  "10pay_single|70|None|None|25 Months|50 Months": [
    { premium: 5000, db: 1.30589, ltc: 1.30589 },
    { premium: 7500, db: 0.996645, ltc: 0.996645 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010136, ltc: 1.010136 },
    { premium: 15500, db: 1.010132, ltc: 1.010132 },
    { premium: 20000, db: 1.010131, ltc: 1.010131 },
    { premium: 25000, db: 1.010134, ltc: 1.010134 },
    { premium: 30000, db: 1.010136, ltc: 1.010136 },
    { premium: 35000, db: 1.010137, ltc: 1.010137 },
    { premium: 40000, db: 1.010135, ltc: 1.010135 },
    { premium: 45000, db: 1.010136, ltc: 1.010136 },
    { premium: 50000, db: 1.010137, ltc: 1.010137 },
    { premium: 55000, db: 1.010135, ltc: 1.010135 },
    { premium: 60000, db: 1.010136, ltc: 1.010136 },
    { premium: 65000, db: 1.012828, ltc: 1.007149 },
    { premium: 70000, db: 1.045967, ltc: 0.970371 },
    { premium: 75000, db: 1.074687, ltc: 0.938497 },
  ],
  "10pay_single|70|None|None|25 Months|Lifetime": [
    { premium: 5000, db: 1.575985, ltc: 1 },
    { premium: 7500, db: 1.050657, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.003372, ltc: 1 },
    { premium: 15500, db: 1.003619, ltc: 1 },
    { premium: 20000, db: 1.010124, ltc: 1 },
    { premium: 25000, db: 1.010123, ltc: 1 },
    { premium: 30000, db: 1.010122, ltc: 1 },
    { premium: 35000, db: 1.010126, ltc: 1 },
    { premium: 40000, db: 1.010124, ltc: 1 },
    { premium: 45000, db: 1.010124, ltc: 1 },
    { premium: 50000, db: 1.010123, ltc: 1 },
    { premium: 55000, db: 1.010125, ltc: 1 },
    { premium: 60000, db: 1.010124, ltc: 1 },
    { premium: 65000, db: 1.010124, ltc: 1 },
    { premium: 70000, db: 1.010123, ltc: 1 },
    { premium: 75000, db: 1.010125, ltc: 1 },
  ],
  "10pay_single|70|None|None|33 Months|33 Months": [
    { premium: 5000, db: 1.056798, ltc: 1.056798 },
    { premium: 7500, db: 0.99669, ltc: 0.99669 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010135, ltc: 1.010135 },
    { premium: 15500, db: 1.010132, ltc: 1.010132 },
    { premium: 20000, db: 1.010132, ltc: 1.010132 },
    { premium: 25000, db: 1.010134, ltc: 1.010134 },
    { premium: 30000, db: 1.010135, ltc: 1.010135 },
    { premium: 35000, db: 1.010136, ltc: 1.010136 },
    { premium: 40000, db: 1.010134, ltc: 1.010134 },
    { premium: 45000, db: 1.010135, ltc: 1.010135 },
    { premium: 50000, db: 1.010136, ltc: 1.010136 },
    { premium: 55000, db: 1.010135, ltc: 1.010135 },
    { premium: 60000, db: 1.010135, ltc: 1.010135 },
    { premium: 65000, db: 1.010136, ltc: 1.010136 },
    { premium: 70000, db: 1.010917, ltc: 1.008555 },
    { premium: 75000, db: 1.024212, ltc: 0.981663 },
  ],
  "10pay_single|70|None|None|33 Months|Lifetime": [
    { premium: 5000, db: 1.277388, ltc: 1 },
    { premium: 7500, db: 0.996637, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010123, ltc: 1 },
    { premium: 15500, db: 1.010125, ltc: 1 },
    { premium: 20000, db: 1.010127, ltc: 1 },
    { premium: 25000, db: 1.010125, ltc: 1 },
    { premium: 30000, db: 1.010127, ltc: 1 },
    { premium: 35000, db: 1.010129, ltc: 1 },
    { premium: 40000, db: 1.010127, ltc: 1 },
    { premium: 45000, db: 1.010129, ltc: 1 },
    { premium: 50000, db: 1.010127, ltc: 1 },
    { premium: 55000, db: 1.010129, ltc: 1 },
    { premium: 60000, db: 1.010127, ltc: 1 },
    { premium: 65000, db: 1.010128, ltc: 1 },
    { premium: 70000, db: 1.010129, ltc: 1 },
    { premium: 75000, db: 1.010128, ltc: 1 },
  ],
  "10pay_single|70|None|None|50 Months|50 Months": [
    { premium: 5000, db: 0.98003, ltc: 0.98003 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.000003, ltc: 1.000003 },
    { premium: 15500, db: 1.000001, ltc: 1.000001 },
    { premium: 20000, db: 1.000005, ltc: 1.000005 },
    { premium: 25000, db: 1.000002, ltc: 1.000002 },
    { premium: 30000, db: 1.000003, ltc: 1.000003 },
    { premium: 35000, db: 1.000004, ltc: 1.000004 },
    { premium: 40000, db: 1.000002, ltc: 1.000002 },
    { premium: 45000, db: 1.000003, ltc: 1.000003 },
    { premium: 50000, db: 1.000004, ltc: 1.000004 },
    { premium: 55000, db: 1.000004, ltc: 1.000004 },
    { premium: 60000, db: 1.000005, ltc: 1.000005 },
    { premium: 65000, db: 1.000004, ltc: 1.000004 },
    { premium: 70000, db: 1.000004, ltc: 1.000004 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
  ],
  "10pay_single|70|None|None|50 Months|Lifetime": [
    { premium: 5000, db: 1.028082, ltc: 1 },
    { premium: 7500, db: 0.996608, ltc: 1 },
    { premium: 10000, db: 1, ltc: 1 },
    { premium: 15000, db: 1.010115, ltc: 1 },
    { premium: 15500, db: 1.010118, ltc: 1 },
    { premium: 20000, db: 1.010115, ltc: 1 },
    { premium: 25000, db: 1.010119, ltc: 1 },
    { premium: 30000, db: 1.010118, ltc: 1 },
    { premium: 35000, db: 1.010117, ltc: 1 },
    { premium: 40000, db: 1.010117, ltc: 1 },
    { premium: 45000, db: 1.010117, ltc: 1 },
    { premium: 50000, db: 1.010119, ltc: 1 },
    { premium: 55000, db: 1.010118, ltc: 1 },
    { premium: 60000, db: 1.010118, ltc: 1 },
    { premium: 65000, db: 1.010118, ltc: 1 },
    { premium: 70000, db: 1.010119, ltc: 1 },
    { premium: 75000, db: 1.010119, ltc: 1 },
  ],
  "sp_joint|45|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.106119, ltc: 0.971148 },
    { premium: 300000, db: 1.286662, ltc: 0.922056 },
    { premium: 400000, db: 1.376934, ltc: 0.897511 },
  ],
  "sp_joint|45|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.313781, ltc: 0.922363 },
    { premium: 400000, db: 1.522308, ltc: 0.870763 },
  ],
  "sp_joint|45|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.057271, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.440049, ltc: 1 },
  ],
  "sp_joint|45|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.002651, ltc: 0.998697 },
    { premium: 300000, db: 1.169599, ltc: 0.91638 },
  ],
  "sp_joint|45|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.309822, ltc: 1 },
  ],
  "sp_joint|45|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.049919, ltc: 0.94274 },
  ],
  "sp_joint|45|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999995, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.138424, ltc: 1 },
  ],
  "sp_joint|45|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999993, ltc: 0.999993 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 1.113985, ltc: 0.99708 },
    { premium: 200000, db: 1.323306, ltc: 0.991719 },
    { premium: 300000, db: 1.532625, ltc: 0.986356 },
    { premium: 400000, db: 1.637284, ltc: 0.983675 },
  ],
  "sp_joint|45|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.157192, ltc: 0.989995 },
    { premium: 300000, db: 1.664525, ltc: 0.957684 },
    { premium: 400000, db: 1.918191, ltc: 0.941529 },
  ],
  "sp_joint|45|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 1.394242, ltc: 1 },
    { premium: 75000, db: 0.999986, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 0.999995, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.220123, ltc: 1 },
    { premium: 400000, db: 1.945371, ltc: 1 },
  ],
  "sp_joint|45|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.172096, ltc: 0.96973 },
    { premium: 300000, db: 1.36131, ltc: 0.936443 },
  ],
  "sp_joint|45|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.264191, ltc: 1 },
    { premium: 400000, db: 1.682365, ltc: 1 },
  ],
  "sp_joint|45|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.033049, ltc: 0.979306 },
    { premium: 300000, db: 1.170027, ltc: 0.893534 },
  ],
  "sp_joint|45|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 1.000002, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.171153, ltc: 1 },
    { premium: 400000, db: 1.350939, ltc: 1 },
  ],
  "sp_joint|45|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.083491, ltc: 0.921746 },
  ],
  "sp_joint|45|None|None|25 Months|50 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.056059, ltc: 0.9575 },
    { premium: 400000, db: 1.194732, ltc: 0.852354 },
  ],
  "sp_joint|45|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.115728, ltc: 1 },
  ],
  "sp_joint|45|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 0.999999, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.018244, ltc: 0.975022 },
  ],
  "sp_joint|45|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 0.999998, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.046567, ltc: 1 },
  ],
  "sp_joint|45|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 0.999999, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000001, ltc: 1.000001 },
  ],
  "sp_joint|45|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999996, ltc: 1 },
    { premium: 75000, db: 0.999999, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1 },
    { premium: 150000, db: 1.000001, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1 },
    { premium: 300000, db: 1.000001, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|48|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.058506, ltc: 0.986214 },
    { premium: 300000, db: 1.265557, ltc: 0.937419 },
    { premium: 400000, db: 1.369084, ltc: 0.913022 },
  ],
  "sp_joint|48|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.241785, ltc: 0.946559 },
    { premium: 400000, db: 1.48197, ltc: 0.893463 },
  ],
  "sp_joint|48|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.170788, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.271656, ltc: 1 },
  ],
  "sp_joint|48|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.146589, ltc: 0.934289 },
    { premium: 400000, db: 1.241757, ltc: 0.891624 },
  ],
  "sp_joint|48|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.217863, ltc: 1 },
  ],
  "sp_joint|48|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.03046, ltc: 0.967381 },
    { premium: 400000, db: 1.10241, ltc: 0.890318 },
  ],
  "sp_joint|48|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 0.999998, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.101353, ltc: 1 },
  ],
  "sp_joint|48|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.035057, ltc: 0.999911 },
    { premium: 200000, db: 1.27498, ltc: 0.999276 },
    { premium: 300000, db: 1.5149, ltc: 0.998641 },
    { premium: 400000, db: 1.634861, ltc: 0.998324 },
  ],
  "sp_joint|48|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.003804, ltc: 1.003804 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.584624, ltc: 0.974334 },
    { premium: 400000, db: 1.880274, ltc: 0.961353 },
  ],
  "sp_joint|48|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 1.547085, ltc: 1 },
    { premium: 75000, db: 1.03139, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999991, ltc: 1 },
    { premium: 150000, db: 0.999995, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.739422, ltc: 1 },
  ],
  "sp_joint|48|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.125011, ltc: 0.981693 },
    { premium: 300000, db: 1.34116, ltc: 0.950038 },
    { premium: 400000, db: 1.449235, ltc: 0.934211 },
  ],
  "sp_joint|48|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.070638, ltc: 1 },
    { premium: 75000, db: 0.999993, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.097678, ltc: 1 },
    { premium: 400000, db: 1.578153, ltc: 1 },
  ],
  "sp_joint|48|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.153676, ltc: 0.912239 },
    { premium: 400000, db: 1.23196, ltc: 0.867531 },
  ],
  "sp_joint|48|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999993, ltc: 1 },
    { premium: 75000, db: 1.000002, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.110134, ltc: 1 },
    { premium: 400000, db: 1.314305, ltc: 1 },
  ],
  "sp_joint|48|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.063898, ltc: 0.943842 },
    { premium: 400000, db: 1.138575, ltc: 0.878207 },
  ],
  "sp_joint|48|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.005255, ltc: 0.996287 },
    { premium: 400000, db: 1.164072, ltc: 0.883926 },
  ],
  "sp_joint|48|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.016975, ltc: 1 },
  ],
  "sp_joint|48|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1.000002 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.068261, ltc: 0.912482 },
  ],
  "sp_joint|48|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|48|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999999, ltc: 0.999999 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|48|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999995, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000001, ltc: 1 },
  ],
  "sp_joint|50|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.021109, ltc: 0.99553 },
    { premium: 300000, db: 1.248157, ltc: 0.947395 },
    { premium: 400000, db: 1.36168, ltc: 0.923328 },
  ],
  "sp_joint|50|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.18445, ltc: 0.962424 },
    { premium: 400000, db: 1.448668, ltc: 0.908595 },
  ],
  "sp_joint|50|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.252985, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999992, ltc: 1 },
    { premium: 150000, db: 0.999996, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.138546, ltc: 1 },
  ],
  "sp_joint|50|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.128294, ltc: 0.946309 },
    { premium: 400000, db: 1.232305, ltc: 0.902774 },
  ],
  "sp_joint|50|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 0.999991, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.144451, ltc: 1 },
  ],
  "sp_joint|50|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.015287, ltc: 0.984374 },
    { premium: 400000, db: 1.09358, ltc: 0.904338 },
  ],
  "sp_joint|50|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 1 },
    { premium: 150000, db: 0.999998, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.071708, ltc: 1 },
  ],
  "sp_joint|50|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.23636, ltc: 1.003011 },
    { premium: 300000, db: 1.499614, ltc: 1.006361 },
    { premium: 400000, db: 1.631239, ltc: 1.008035 },
  ],
  "sp_joint|50|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.073776, ltc: 1.073776 },
    { premium: 75000, db: 0.999989, ltc: 0.999989 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.519078, ltc: 0.983574 },
    { premium: 400000, db: 1.845954, ltc: 0.973229 },
  ],
  "sp_joint|50|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 1.659316, ltc: 1 },
    { premium: 75000, db: 1.106211, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.99999, ltc: 1 },
    { premium: 150000, db: 0.999994, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.573776, ltc: 1 },
  ],
  "sp_joint|50|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.087661, ltc: 0.988958 },
    { premium: 300000, db: 1.324702, ltc: 0.959103 },
    { premium: 400000, db: 1.443223, ltc: 0.944175 },
  ],
  "sp_joint|50|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.142567, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.495213, ltc: 1 },
  ],
  "sp_joint|50|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.14025, ltc: 0.92482 },
    { premium: 400000, db: 1.225835, ltc: 0.878938 },
  ],
  "sp_joint|50|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.061897, ltc: 1 },
    { premium: 400000, db: 1.285026, ltc: 1 },
  ],
  "sp_joint|50|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.048712, ltc: 0.959149 },
    { premium: 400000, db: 1.12991, ltc: 0.89105 },
  ],
  "sp_joint|50|None|None|25 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.139627, ltc: 0.905821 },
  ],
  "sp_joint|50|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|50|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.058557, ltc: 0.928213 },
  ],
  "sp_joint|50|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|50|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999996, ltc: 0.999996 },
    { premium: 75000, db: 0.999999, ltc: 0.999999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000001, ltc: 1.000001 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.000001, ltc: 1.000001 },
  ],
  "sp_joint|50|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999995, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1.000002, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|55|60|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.165289, ltc: 0.991837 },
    { premium: 325000, db: 1.222578, ltc: 0.989005 },
    { premium: 350000, db: 1.271685, ltc: 0.986578 },
    { premium: 375000, db: 1.314242, ltc: 0.984475 },
    { premium: 400000, db: 1.351482, ltc: 0.982635 },
    { premium: 450000, db: 1.413546, ltc: 0.979568 },
    { premium: 500000, db: 1.463197, ltc: 0.977114 },
  ],
  "sp_joint|55|60|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.121074, ltc: 1.121074 },
    { premium: 75000, db: 1.000007, ltc: 1.000007 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000007, ltc: 1.000007 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000009, ltc: 1.000009 },
    { premium: 350000, db: 1.063224, ltc: 0.995009 },
    { premium: 375000, db: 1.166775, ltc: 0.986819 },
    { premium: 400000, db: 1.257382, ltc: 0.979653 },
    { premium: 450000, db: 1.408389, ltc: 0.967708 },
    { premium: 500000, db: 1.529199, ltc: 0.958153 },
  ],
  "sp_joint|55|60|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.71533, ltc: 1 },
    { premium: 75000, db: 1.143553, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.99999, ltc: 1 },
    { premium: 150000, db: 0.999994, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|60|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.035566, ltc: 0.993013 },
    { premium: 325000, db: 1.088042, ltc: 0.982695 },
    { premium: 350000, db: 1.13302, ltc: 0.97385 },
    { premium: 375000, db: 1.172, ltc: 0.966184 },
    { premium: 400000, db: 1.20611, ltc: 0.959477 },
    { premium: 450000, db: 1.262958, ltc: 0.948299 },
    { premium: 500000, db: 1.308437, ltc: 0.939356 },
  ],
  "sp_joint|55|60|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.193223, ltc: 1 },
    { premium: 75000, db: 0.999992, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000003, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.085257, ltc: 1 },
  ],
  "sp_joint|55|60|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.009431, ltc: 0.994025 },
    { premium: 375000, db: 1.038204, ltc: 0.975791 },
    { premium: 400000, db: 1.06338, ltc: 0.959836 },
    { premium: 450000, db: 1.10534, ltc: 0.933244 },
    { premium: 500000, db: 1.138909, ltc: 0.911971 },
  ],
  "sp_joint|55|60|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.007991, ltc: 1 },
    { premium: 500000, db: 1.094789, ltc: 1 },
  ],
  "sp_joint|55|60|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.006112, ltc: 1.000747 },
    { premium: 300000, db: 1.445128, ltc: 1.054358 },
    { premium: 325000, db: 1.51267, ltc: 1.062606 },
    { premium: 350000, db: 1.570561, ltc: 1.069675 },
    { premium: 375000, db: 1.620736, ltc: 1.075803 },
    { premium: 400000, db: 1.664636, ltc: 1.081163 },
    { premium: 450000, db: 1.737805, ltc: 1.090099 },
    { premium: 500000, db: 1.796341, ltc: 1.097247 },
  ],
  "sp_joint|55|60|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.44066, ltc: 1.44066 },
    { premium: 75000, db: 0.99999, ltc: 0.99999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.093521, ltc: 1.004788 },
    { premium: 325000, db: 1.268048, ltc: 1.013711 },
    { premium: 350000, db: 1.417639, ltc: 1.021358 },
    { premium: 375000, db: 1.547288, ltc: 1.027987 },
    { premium: 400000, db: 1.660728, ltc: 1.033786 },
    { premium: 450000, db: 1.849797, ltc: 1.043453 },
    { premium: 500000, db: 2.001052, ltc: 1.051186 },
  ],
  "sp_joint|55|60|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.869423, ltc: 1 },
    { premium: 150000, db: 0.869423, ltc: 1 },
    { premium: 200000, db: 0.869423, ltc: 1 },
    { premium: 300000, db: 0.869423, ltc: 1 },
    { premium: 325000, db: 0.869423, ltc: 1 },
    { premium: 350000, db: 0.869423, ltc: 1 },
    { premium: 375000, db: 0.869423, ltc: 1 },
    { premium: 400000, db: 0.869423, ltc: 1 },
    { premium: 450000, db: 0.869423, ltc: 1 },
    { premium: 500000, db: 1.172789, ltc: 1 },
  ],
  "sp_joint|55|60|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.257273, ltc: 1.005052 },
    { premium: 325000, db: 1.317547, ltc: 1.006234 },
    { premium: 350000, db: 1.369211, ltc: 1.007247 },
    { premium: 375000, db: 1.413989, ltc: 1.008127 },
    { premium: 400000, db: 1.453167, ltc: 1.008895 },
    { premium: 450000, db: 1.518466, ltc: 1.010176 },
    { premium: 500000, db: 1.570705, ltc: 1.011202 },
  ],
  "sp_joint|55|60|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.544695, ltc: 1 },
    { premium: 75000, db: 1.029797, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999991, ltc: 1 },
    { premium: 150000, db: 0.999995, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.230418, ltc: 1 },
    { premium: 500000, db: 1.479593, ltc: 1 },
  ],
  "sp_joint|55|60|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.084669, ltc: 0.976648 },
    { premium: 325000, db: 1.127733, ltc: 0.964771 },
    { premium: 350000, db: 1.164646, ltc: 0.954592 },
    { premium: 375000, db: 1.196636, ltc: 0.945769 },
    { premium: 400000, db: 1.224628, ltc: 0.938049 },
    { premium: 450000, db: 1.271282, ltc: 0.925183 },
  ],
  "sp_joint|55|60|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000008, ltc: 1 },
    { premium: 375000, db: 1.046977, ltc: 1 },
    { premium: 400000, db: 1.12402, ltc: 1 },
    { premium: 450000, db: 1.252428, ltc: 1 },
    { premium: 500000, db: 1.355154, ltc: 1 },
  ],
  "sp_joint|55|60|None|None|25 Months|25 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.007499, ltc: 0.996168 },
    { premium: 350000, db: 1.042252, ltc: 0.978371 },
    { premium: 375000, db: 1.072373, ltc: 0.962949 },
    { premium: 400000, db: 1.098728, ltc: 0.949453 },
    { premium: 450000, db: 1.142653, ltc: 0.926962 },
    { premium: 500000, db: 1.177793, ltc: 0.908968 },
  ],
  "sp_joint|55|60|None|None|25 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.095009, ltc: 0.959007 },
    { premium: 500000, db: 1.172668, ltc: 0.925493 },
  ],
  "sp_joint|55|60|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.116804, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999993, ltc: 1 },
    { premium: 150000, db: 0.999996, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000001, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|60|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.016026, ltc: 0.987249 },
    { premium: 450000, db: 1.05711, ltc: 0.954542 },
    { premium: 500000, db: 1.089976, ltc: 0.928377 },
  ],
  "sp_joint|55|60|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|60|None|None|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.000001, ltc: 1.000001 },
    { premium: 450000, db: 1.000001, ltc: 1.000001 },
  ],
  "sp_joint|55|60|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999994, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 325000, db: 1.000004, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|55|65|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.070533, ltc: 0.999136 },
    { premium: 325000, db: 1.140176, ltc: 0.998275 },
    { premium: 350000, db: 1.199871, ltc: 0.997538 },
    { premium: 375000, db: 1.251606, ltc: 0.996898 },
    { premium: 400000, db: 1.296872, ltc: 0.996338 },
    { premium: 450000, db: 1.372319, ltc: 0.995406 },
    { premium: 500000, db: 1.432675, ltc: 0.994659 },
  ],
  "sp_joint|55|65|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.286762, ltc: 1.286762 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000004, ltc: 1.000004 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.060837, ltc: 0.99698 },
    { premium: 450000, db: 1.247465, ltc: 0.987705 },
    { premium: 500000, db: 1.396765, ltc: 0.980283 },
  ],
  "sp_joint|55|65|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.99928, ltc: 1 },
    { premium: 75000, db: 1.332854, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 0.999993, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000003, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|55|65|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.009032, ltc: 0.998726 },
    { premium: 350000, db: 1.064104, ltc: 0.990961 },
    { premium: 375000, db: 1.11183, ltc: 0.98423 },
    { premium: 400000, db: 1.153593, ltc: 0.978342 },
    { premium: 450000, db: 1.223196, ltc: 0.968527 },
    { premium: 500000, db: 1.278878, ltc: 0.960675 },
  ],
  "sp_joint|55|65|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.379414, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000004, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|55|65|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.023681, ltc: 0.987626 },
    { premium: 450000, db: 1.075381, ltc: 0.960611 },
    { premium: 500000, db: 1.116743, ltc: 0.939 },
  ],
  "sp_joint|55|65|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000006, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
    { premium: 450000, db: 1.000007, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|55|65|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.125284, ltc: 1.125284 },
    { premium: 75000, db: 1.000008, ltc: 1.000008 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000008, ltc: 1.000008 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.348922, ltc: 1.049541 },
    { premium: 325000, db: 1.429504, ltc: 1.060979 },
    { premium: 350000, db: 1.498577, ltc: 1.070786 },
    { premium: 375000, db: 1.558441, ltc: 1.079284 },
    { premium: 400000, db: 1.610822, ltc: 1.086721 },
    { premium: 450000, db: 1.698121, ltc: 1.099114 },
    { premium: 500000, db: 1.767962, ltc: 1.109029 },
  ],
  "sp_joint|55|65|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.644229, ltc: 1.644229 },
    { premium: 75000, db: 1.096153, ltc: 1.096153 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000013, ltc: 1.000013 },
    { premium: 150000, db: 1.000011, ltc: 1.000011 },
    { premium: 200000, db: 1.000008, ltc: 1.000008 },
    { premium: 300000, db: 1.000011, ltc: 1.000011 },
    { premium: 325000, db: 1.000015, ltc: 1.000015 },
    { premium: 350000, db: 1.151308, ltc: 1.01013 },
    { premium: 375000, db: 1.308004, ltc: 1.020604 },
    { premium: 400000, db: 1.445117, ltc: 1.029771 },
    { premium: 450000, db: 1.673638, ltc: 1.045049 },
    { premium: 500000, db: 1.856452, ltc: 1.05727 },
  ],
  "sp_joint|55|65|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.748945, ltc: 1 },
    { premium: 200000, db: 0.748945, ltc: 1 },
    { premium: 300000, db: 0.748952, ltc: 1 },
    { premium: 325000, db: 0.748951, ltc: 1 },
    { premium: 350000, db: 0.748951, ltc: 1 },
    { premium: 375000, db: 0.74895, ltc: 1 },
    { premium: 400000, db: 0.74895, ltc: 1 },
    { premium: 450000, db: 0.748949, ltc: 1 },
    { premium: 500000, db: 0.748953, ltc: 1 },
  ],
  "sp_joint|55|65|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.166935, ltc: 1.009132 },
    { premium: 325000, db: 1.240462, ltc: 1.013152 },
    { premium: 350000, db: 1.303487, ltc: 1.016599 },
    { premium: 375000, db: 1.358107, ltc: 1.019585 },
    { premium: 400000, db: 1.405902, ltc: 1.022199 },
    { premium: 450000, db: 1.485557, ltc: 1.026555 },
    { premium: 500000, db: 1.549282, ltc: 1.03004 },
  ],
  "sp_joint|55|65|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.788369, ltc: 1 },
    { premium: 75000, db: 1.192246, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1.000012, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1 },
    { premium: 300000, db: 1.000012, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.00001, ltc: 1 },
    { premium: 375000, db: 1.000012, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
    { premium: 450000, db: 1.000012, ltc: 1 },
    { premium: 500000, db: 1.137036, ltc: 1 },
  ],
  "sp_joint|55|65|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.018534, ltc: 0.996301 },
    { premium: 325000, db: 1.072087, ltc: 0.985613 },
    { premium: 350000, db: 1.117987, ltc: 0.976451 },
    { premium: 375000, db: 1.157769, ltc: 0.968512 },
    { premium: 400000, db: 1.192579, ltc: 0.961565 },
    { premium: 450000, db: 1.250593, ltc: 0.949986 },
    { premium: 500000, db: 1.297004, ltc: 0.940722 },
  ],
  "sp_joint|55|65|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.031479, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000007, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000006, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.118189, ltc: 1 },
    { premium: 500000, db: 1.248463, ltc: 1 },
  ],
  "sp_joint|55|65|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000005 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000004, ltc: 1.000004 },
    { premium: 375000, db: 1.018566, ltc: 0.992186 },
    { premium: 400000, db: 1.051326, ltc: 0.978384 },
    { premium: 450000, db: 1.105925, ltc: 0.955381 },
    { premium: 500000, db: 1.149605, ltc: 0.93698 },
  ],
  "sp_joint|55|65|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1.000006 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.000006, ltc: 1.000006 },
    { premium: 500000, db: 1.075977, ltc: 0.972657 },
  ],
  "sp_joint|55|65|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.30233, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.000009, ltc: 1 },
    { premium: 375000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.00001, ltc: 1 },
    { premium: 500000, db: 1.00001, ltc: 1 },
  ],
  "sp_joint|55|65|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000001, ltc: 1.000001 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.019208, ltc: 0.987227 },
    { premium: 500000, db: 1.060203, ltc: 0.959962 },
  ],
  "sp_joint|55|65|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 0.99999, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 325000, db: 1.000005, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
    { premium: 450000, db: 1.000005, ltc: 1 },
    { premium: 500000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|55|65|None|None|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 0.999999, ltc: 0.999999 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|65|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|55|70|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.075173, ltc: 1.075173 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.007648, ltc: 1.000038 },
    { premium: 350000, db: 1.079268, ltc: 1.000404 },
    { premium: 375000, db: 1.141335, ltc: 1.00072 },
    { premium: 400000, db: 1.195647, ltc: 1.000997 },
    { premium: 450000, db: 1.286164, ltc: 1.001459 },
    { premium: 500000, db: 1.358577, ltc: 1.001828 },
  ],
  "sp_joint|55|70|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.503111, ltc: 1.503111 },
    { premium: 75000, db: 1.002074, ltc: 1.002074 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1.000008 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000004, ltc: 1.000004 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000008, ltc: 1.000008 },
    { premium: 450000, db: 1.000007, ltc: 1.000007 },
    { premium: 500000, db: 1.177721, ltc: 0.993806 },
  ],
  "sp_joint|55|70|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.852751, ltc: 1 },
    { premium: 150000, db: 0.852743, ltc: 1 },
    { premium: 200000, db: 0.852743, ltc: 1 },
    { premium: 300000, db: 0.85275, ltc: 1 },
    { premium: 325000, db: 0.852752, ltc: 1 },
    { premium: 350000, db: 0.852749, ltc: 1 },
    { premium: 375000, db: 0.852751, ltc: 1 },
    { premium: 400000, db: 0.852748, ltc: 1 },
    { premium: 450000, db: 0.852752, ltc: 1 },
    { premium: 500000, db: 0.852751, ltc: 1 },
  ],
  "sp_joint|55|70|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000007, ltc: 1.000007 },
    { premium: 375000, db: 1.0087, ltc: 0.999052 },
    { premium: 400000, db: 1.059404, ltc: 0.993485 },
    { premium: 450000, db: 1.143912, ltc: 0.984208 },
    { premium: 500000, db: 1.211517, ltc: 0.976785 },
  ],
  "sp_joint|55|70|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.612025, ltc: 1 },
    { premium: 75000, db: 1.074684, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.000005, ltc: 1 },
    { premium: 500000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|55|70|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.017942, ltc: 0.991986 },
    { premium: 500000, db: 1.068956, ltc: 0.969191 },
  ],
  "sp_joint|55|70|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.99999, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 325000, db: 1.000004, ltc: 1 },
    { premium: 350000, db: 1.000001, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|55|70|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.286696, ltc: 1.286696 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.199936, ltc: 1.028858 },
    { premium: 325000, db: 1.2927, ltc: 1.042248 },
    { premium: 350000, db: 1.372212, ltc: 1.053726 },
    { premium: 375000, db: 1.441119, ltc: 1.063671 },
    { premium: 400000, db: 1.501415, ltc: 1.072375 },
    { premium: 450000, db: 1.601907, ltc: 1.08688 },
    { premium: 500000, db: 1.682301, ltc: 1.098484 },
  ],
  "sp_joint|55|70|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.891327, ltc: 1.891327 },
    { premium: 75000, db: 1.260884, ltc: 1.260884 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000008 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1.000009 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000009, ltc: 1.000009 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.137899, ltc: 1.009729 },
    { premium: 450000, db: 1.404395, ltc: 1.028514 },
    { premium: 500000, db: 1.617593, ltc: 1.043541 },
  ],
  "sp_joint|55|70|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.647207, ltc: 1 },
    { premium: 300000, db: 0.647214, ltc: 1 },
    { premium: 325000, db: 0.647212, ltc: 1 },
    { premium: 350000, db: 0.64721, ltc: 1 },
    { premium: 375000, db: 0.647214, ltc: 1 },
    { premium: 400000, db: 0.647212, ltc: 1 },
    { premium: 450000, db: 0.647214, ltc: 1 },
    { premium: 500000, db: 0.647215, ltc: 1 },
  ],
  "sp_joint|55|70|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.098428, ltc: 1.098428 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.027317, ltc: 1.00184 },
    { premium: 325000, db: 1.114075, ltc: 1.007666 },
    { premium: 350000, db: 1.188438, ltc: 1.01266 },
    { premium: 375000, db: 1.252886, ltc: 1.016988 },
    { premium: 400000, db: 1.309281, ltc: 1.020776 },
    { premium: 450000, db: 1.403268, ltc: 1.027088 },
    { premium: 500000, db: 1.478459, ltc: 1.032138 },
  ],
  "sp_joint|55|70|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.963661, ltc: 1 },
    { premium: 150000, db: 0.963661, ltc: 1 },
    { premium: 200000, db: 0.963661, ltc: 1 },
    { premium: 300000, db: 0.963667, ltc: 1 },
    { premium: 325000, db: 0.963667, ltc: 1 },
    { premium: 350000, db: 0.963666, ltc: 1 },
    { premium: 375000, db: 0.963666, ltc: 1 },
    { premium: 400000, db: 0.963666, ltc: 1 },
    { premium: 450000, db: 0.963665, ltc: 1 },
    { premium: 500000, db: 0.963669, ltc: 1 },
  ],
  "sp_joint|55|70|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.03936, ltc: 0.993384 },
    { premium: 375000, db: 1.086631, ltc: 0.985439 },
    { premium: 400000, db: 1.127991, ltc: 0.978486 },
    { premium: 450000, db: 1.196924, ltc: 0.966898 },
    { premium: 500000, db: 1.25207, ltc: 0.957627 },
  ],
  "sp_joint|55|70|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.185401, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 0.999996, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000001, ltc: 1 },
    { premium: 500000, db: 1.077581, ltc: 1 },
  ],
  "sp_joint|55|70|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.033126, ltc: 0.988397 },
    { premium: 500000, db: 1.088618, ltc: 0.968959 },
  ],
  "sp_joint|55|70|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.091675, ltc: 1.091675 },
    { premium: 75000, db: 0.999993, ltc: 0.999993 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 0.999998, ltc: 0.999998 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|70|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.557348, ltc: 1 },
    { premium: 75000, db: 1.038232, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000009, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.00001, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000009, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.000009, ltc: 1 },
    { premium: 500000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|55|70|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.000004, ltc: 1.000004 },
    { premium: 500000, db: 1.000562, ltc: 0.999691 },
  ],
  "sp_joint|55|70|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.123918, ltc: 1 },
    { premium: 75000, db: 0.999993, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000001, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|55|70|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000004, ltc: 1.000004 },
    { premium: 375000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
    { premium: 450000, db: 1.000003, ltc: 1.000003 },
    { premium: 500000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|55|70|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|55|75|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.293871, ltc: 1.293871 },
    { premium: 75000, db: 0.999987, ltc: 0.999987 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.026838, ltc: 0.998611 },
    { premium: 450000, db: 1.124515, ltc: 0.993539 },
    { premium: 500000, db: 1.202658, ltc: 0.989482 },
  ],
  "sp_joint|55|75|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.785304, ltc: 1.785304 },
    { premium: 75000, db: 1.190202, ltc: 1.190202 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000007 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1.000009 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000008, ltc: 1.000008 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000007, ltc: 1.000007 },
    { premium: 400000, db: 1.000009, ltc: 1.000009 },
    { premium: 450000, db: 1.000008, ltc: 1.000008 },
    { premium: 500000, db: 1.000007, ltc: 1.000007 },
  ],
  "sp_joint|55|75|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.730585, ltc: 1 },
    { premium: 200000, db: 0.730585, ltc: 1 },
    { premium: 300000, db: 0.730585, ltc: 1 },
    { premium: 325000, db: 0.730588, ltc: 1 },
    { premium: 350000, db: 0.730585, ltc: 1 },
    { premium: 375000, db: 0.730588, ltc: 1 },
    { premium: 400000, db: 0.730585, ltc: 1 },
    { premium: 450000, db: 0.730585, ltc: 1 },
    { premium: 500000, db: 0.730589, ltc: 1 },
  ],
  "sp_joint|55|75|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1.123631, ltc: 1.123631 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.000935, ltc: 0.999849 },
    { premium: 500000, db: 1.075601, ltc: 0.987244 },
  ],
  "sp_joint|55|75|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.900239, ltc: 1 },
    { premium: 75000, db: 1.266826, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1.000013, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000013, ltc: 1 },
    { premium: 325000, db: 1.000015, ltc: 1 },
    { premium: 350000, db: 1.000016, ltc: 1 },
    { premium: 375000, db: 1.000013, ltc: 1 },
    { premium: 400000, db: 1.000014, ltc: 1 },
    { premium: 450000, db: 1.000013, ltc: 1 },
    { premium: 500000, db: 1.000015, ltc: 1 },
  ],
  "sp_joint|55|75|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000004, ltc: 1.000004 },
    { premium: 500000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|55|75|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.158526, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
    { premium: 450000, db: 1.000008, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|55|75|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.500653, ltc: 1.500653 },
    { premium: 75000, db: 1.000435, ltc: 1.000435 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000008, ltc: 1.000008 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.09267, ltc: 1.008065 },
    { premium: 350000, db: 1.172518, ltc: 1.015008 },
    { premium: 375000, db: 1.241719, ltc: 1.021026 },
    { premium: 400000, db: 1.30227, ltc: 1.026291 },
    { premium: 450000, db: 1.403189, ltc: 1.035066 },
    { premium: 500000, db: 1.483924, ltc: 1.042086 },
  ],
  "sp_joint|55|75|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.921086, ltc: 0.921086 },
    { premium: 150000, db: 0.921088, ltc: 0.921088 },
    { premium: 200000, db: 0.921092, ltc: 0.921092 },
    { premium: 300000, db: 0.921088, ltc: 0.921088 },
    { premium: 325000, db: 0.921089, ltc: 0.921089 },
    { premium: 350000, db: 0.92109, ltc: 0.92109 },
    { premium: 375000, db: 0.921091, ltc: 0.921091 },
    { premium: 400000, db: 0.921092, ltc: 0.921092 },
    { premium: 450000, db: 0.991931, ltc: 0.923224 },
    { premium: 500000, db: 1.187348, ltc: 0.929105 },
  ],
  "sp_joint|55|75|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.572669, ltc: 1 },
    { premium: 300000, db: 0.572669, ltc: 1 },
    { premium: 325000, db: 0.572672, ltc: 1 },
    { premium: 350000, db: 0.572669, ltc: 1 },
    { premium: 375000, db: 0.572671, ltc: 1 },
    { premium: 400000, db: 0.572674, ltc: 1 },
    { premium: 450000, db: 0.572673, ltc: 1 },
    { premium: 500000, db: 0.572673, ltc: 1 },
  ],
  "sp_joint|55|75|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.289849, ltc: 1.289849 },
    { premium: 75000, db: 0.999991, ltc: 0.999991 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1.017383, ltc: 1.000053 },
    { premium: 375000, db: 1.0833, ltc: 1.000255 },
    { premium: 400000, db: 1.140974, ltc: 1.000429 },
    { premium: 450000, db: 1.237101, ltc: 1.000721 },
    { premium: 500000, db: 1.314, ltc: 1.000953 },
  ],
  "sp_joint|55|75|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.840607, ltc: 1 },
    { premium: 150000, db: 0.84061, ltc: 1 },
    { premium: 200000, db: 0.840613, ltc: 1 },
    { premium: 300000, db: 0.840617, ltc: 1 },
    { premium: 325000, db: 0.840617, ltc: 1 },
    { premium: 350000, db: 0.840617, ltc: 1 },
    { premium: 375000, db: 0.840618, ltc: 1 },
    { premium: 400000, db: 0.840618, ltc: 1 },
    { premium: 450000, db: 0.840619, ltc: 1 },
    { premium: 500000, db: 0.840619, ltc: 1 },
  ],
  "sp_joint|55|75|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000008, ltc: 1.000008 },
    { premium: 350000, db: 1.000007, ltc: 1.000007 },
    { premium: 375000, db: 1.000009, ltc: 1.000009 },
    { premium: 400000, db: 1.007573, ltc: 0.998126 },
    { premium: 450000, db: 1.08091, ltc: 0.979868 },
    { premium: 500000, db: 1.139582, ltc: 0.965263 },
  ],
  "sp_joint|55|75|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.379034, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1 },
    { premium: 150000, db: 1.000009, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.000008, ltc: 1 },
    { premium: 375000, db: 1.000011, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000009, ltc: 1 },
    { premium: 500000, db: 1.000011, ltc: 1 },
  ],
  "sp_joint|55|75|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1.064654, ltc: 1.064654 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 0.999998, ltc: 0.999998 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000001, ltc: 1.000001 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|75|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.35828, ltc: 1.35828 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|75|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.900962, ltc: 1 },
    { premium: 75000, db: 1.267308, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999992, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000003, ltc: 1 },
    { premium: 350000, db: 1.000005, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
    { premium: 450000, db: 1.000004, ltc: 1 },
    { premium: 500000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|55|75|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
    { premium: 450000, db: 1.000004, ltc: 1.000004 },
    { premium: 500000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|55|75|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.382484, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 325000, db: 1.00001, ltc: 1 },
    { premium: 350000, db: 1.00001, ltc: 1 },
    { premium: 375000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000011, ltc: 1 },
    { premium: 500000, db: 1.000011, ltc: 1 },
  ],
  "sp_joint|55|75|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1.000001, ltc: 1.000001 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000003, ltc: 1.000003 },
    { premium: 500000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|55|75|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.20321, ltc: 0.971603 },
    { premium: 400000, db: 1.34779, ltc: 0.951393 },
  ],
  "sp_joint|55|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.014288, ltc: 0.997881 },
    { premium: 400000, db: 1.356378, ltc: 0.946965 },
  ],
  "sp_joint|55|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.477593, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999991, ltc: 1 },
    { premium: 150000, db: 0.999995, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|55|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.079822, ltc: 0.974307 },
    { premium: 400000, db: 1.211945, ltc: 0.931769 },
  ],
  "sp_joint|55|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.046801, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|55|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.07308, ltc: 0.937117 },
  ],
  "sp_joint|55|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|55|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.125293, ltc: 1.007878 },
    { premium: 300000, db: 1.46479, ltc: 1.029216 },
    { premium: 400000, db: 1.634538, ltc: 1.039885 },
  ],
  "sp_joint|55|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.255376, ltc: 1.255376 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999992, ltc: 0.999992 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.329827, ltc: 1.001209 },
    { premium: 400000, db: 1.752931, ltc: 1.002761 },
  ],
  "sp_joint|55|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 1.975153, ltc: 1 },
    { premium: 75000, db: 1.316769, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999992, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.046731, ltc: 1 },
  ],
  "sp_joint|55|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.284225, ltc: 0.983305 },
    { premium: 400000, db: 1.436883, ltc: 0.974336 },
  ],
  "sp_joint|55|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.343752, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.241367, ltc: 1 },
  ],
  "sp_joint|55|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.106982, ltc: 0.954347 },
    { premium: 400000, db: 1.215112, ltc: 0.908198 },
  ],
  "sp_joint|55|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999992, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.204429, ltc: 1 },
  ],
  "sp_joint|55|None|None|25 Months|25 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.00743, ltc: 0.99485 },
    { premium: 400000, db: 1.110295, ltc: 0.923499 },
  ],
  "sp_joint|55|None|None|25 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.071886, ltc: 0.959071 },
  ],
  "sp_joint|55|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1.000007, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|55|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.034321, ltc: 0.964228 },
  ],
  "sp_joint|55|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|55|None|None|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000001, ltc: 1.000001 },
  ],
  "sp_joint|55|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999995, ltc: 1 },
    { premium: 75000, db: 1.000002, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 1 },
    { premium: 150000, db: 1.000002, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000001, ltc: 1 },
  ],
  "sp_joint|60|65|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.044492, ltc: 0.999081 },
    { premium: 325000, db: 1.114944, ltc: 0.997628 },
    { premium: 350000, db: 1.175328, ltc: 0.99638 },
    { premium: 375000, db: 1.227664, ltc: 0.9953 },
    { premium: 400000, db: 1.273456, ltc: 0.994354 },
    { premium: 450000, db: 1.349777, ltc: 0.992779 },
    { premium: 500000, db: 1.410836, ltc: 0.991519 },
  ],
  "sp_joint|60|65|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.319758, ltc: 1.319758 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000008 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.017496, ltc: 0.999031 },
    { premium: 450000, db: 1.205865, ltc: 0.988502 },
    { premium: 500000, db: 1.35656, ltc: 0.980079 },
  ],
  "sp_joint|60|65|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.977372, ltc: 1 },
    { premium: 150000, db: 0.97738, ltc: 1 },
    { premium: 200000, db: 0.97738, ltc: 1 },
    { premium: 300000, db: 0.977387, ltc: 1 },
    { premium: 325000, db: 0.977384, ltc: 1 },
    { premium: 350000, db: 0.977386, ltc: 1 },
    { premium: 375000, db: 0.977383, ltc: 1 },
    { premium: 400000, db: 0.977385, ltc: 1 },
    { premium: 450000, db: 0.977385, ltc: 1 },
    { premium: 500000, db: 0.977384, ltc: 1 },
  ],
  "sp_joint|60|65|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.040019, ltc: 0.993788 },
    { premium: 375000, db: 1.088221, ltc: 0.986304 },
    { premium: 400000, db: 1.130399, ltc: 0.979755 },
    { premium: 450000, db: 1.200694, ltc: 0.968841 },
    { premium: 500000, db: 1.25693, ltc: 0.96011 },
  ],
  "sp_joint|60|65|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.41676, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.000006, ltc: 1 },
    { premium: 375000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
    { premium: 450000, db: 1.000008, ltc: 1 },
    { premium: 500000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|60|65|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.004387, ltc: 0.99757 },
    { premium: 450000, db: 1.056574, ltc: 0.968622 },
    { premium: 500000, db: 1.098324, ltc: 0.945463 },
  ],
  "sp_joint|60|65|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999991, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000006, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
    { premium: 450000, db: 1.000007, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|60|65|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.155091, ltc: 1.155091 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.316046, ltc: 1.043046 },
    { premium: 325000, db: 1.397454, ltc: 1.054133 },
    { premium: 350000, db: 1.46723, ltc: 1.063634 },
    { premium: 375000, db: 1.527705, ltc: 1.071871 },
    { premium: 400000, db: 1.580618, ltc: 1.079076 },
    { premium: 450000, db: 1.668811, ltc: 1.091087 },
    { premium: 500000, db: 1.739364, ltc: 1.100695 },
  ],
  "sp_joint|60|65|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.684216, ltc: 1.684216 },
    { premium: 75000, db: 1.122811, ltc: 1.122811 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1.092596, ltc: 1.005792 },
    { premium: 375000, db: 1.250557, ltc: 1.015673 },
    { premium: 400000, db: 1.388768, ltc: 1.024317 },
    { premium: 450000, db: 1.619124, ltc: 1.038725 },
    { premium: 500000, db: 1.803412, ltc: 1.050253 },
  ],
  "sp_joint|60|65|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.732439, ltc: 1 },
    { premium: 200000, db: 0.732445, ltc: 1 },
    { premium: 300000, db: 0.732445, ltc: 1 },
    { premium: 325000, db: 0.732441, ltc: 1 },
    { premium: 350000, db: 0.732442, ltc: 1 },
    { premium: 375000, db: 0.732444, ltc: 1 },
    { premium: 400000, db: 0.732445, ltc: 1 },
    { premium: 450000, db: 0.732443, ltc: 1 },
    { premium: 500000, db: 0.732445, ltc: 1 },
  ],
  "sp_joint|60|65|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000007, ltc: 1.000007 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000007, ltc: 1.000007 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.134941, ltc: 1.006047 },
    { premium: 325000, db: 1.209051, ltc: 1.009365 },
    { premium: 350000, db: 1.272573, ltc: 1.012209 },
    { premium: 375000, db: 1.327626, ltc: 1.014674 },
    { premium: 400000, db: 1.375797, ltc: 1.016831 },
    { premium: 450000, db: 1.456082, ltc: 1.020426 },
    { premium: 500000, db: 1.520308, ltc: 1.0233 },
  ],
  "sp_joint|60|65|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.833721, ltc: 1 },
    { premium: 75000, db: 1.222481, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000008, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
    { premium: 450000, db: 1.000006, ltc: 1 },
    { premium: 500000, db: 1.063908, ltc: 1 },
  ],
  "sp_joint|60|65|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.046006, ltc: 0.989812 },
    { premium: 350000, db: 1.092213, ltc: 0.979572 },
    { premium: 375000, db: 1.132261, ltc: 0.970698 },
    { premium: 400000, db: 1.167301, ltc: 0.962933 },
    { premium: 450000, db: 1.225705, ltc: 0.949992 },
    { premium: 500000, db: 1.272426, ltc: 0.939639 },
  ],
  "sp_joint|60|65|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.065402, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.000008, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.073052, ltc: 1 },
    { premium: 500000, db: 1.203507, ltc: 1 },
  ],
  "sp_joint|60|65|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.002636, ltc: 0.998853 },
    { premium: 400000, db: 1.035852, ltc: 0.984365 },
    { premium: 450000, db: 1.091211, ltc: 0.960218 },
    { premium: 500000, db: 1.135499, ltc: 0.9409 },
  ],
  "sp_joint|60|65|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1.000006 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.000008, ltc: 1.000008 },
    { premium: 500000, db: 1.050347, ltc: 0.981321 },
  ],
  "sp_joint|60|65|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.335639, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000009, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.000008, ltc: 1 },
    { premium: 375000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
    { premium: 450000, db: 1.000009, ltc: 1 },
    { premium: 500000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|60|65|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
    { premium: 450000, db: 1.004546, ltc: 0.996868 },
    { premium: 500000, db: 1.046074, ltc: 0.968173 },
  ],
  "sp_joint|60|65|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|60|65|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
    { premium: 450000, db: 1.000003, ltc: 1.000003 },
    { premium: 500000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|60|65|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000003, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|60|70|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.087688, ltc: 1.087688 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.068103, ltc: 1.000194 },
    { premium: 375000, db: 1.130604, ltc: 1.000368 },
    { premium: 400000, db: 1.185292, ltc: 1.000521 },
    { premium: 450000, db: 1.276441, ltc: 1.000776 },
    { premium: 500000, db: 1.349358, ltc: 1.000979 },
  ],
  "sp_joint|60|70|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.519626, ltc: 1.519626 },
    { premium: 75000, db: 1.013084, ltc: 1.013084 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 0.999995, ltc: 0.999995 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1.000002 },
    { premium: 500000, db: 1.159029, ltc: 0.994181 },
  ],
  "sp_joint|60|70|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.843983, ltc: 1 },
    { premium: 150000, db: 0.843983, ltc: 1 },
    { premium: 200000, db: 0.843983, ltc: 1 },
    { premium: 300000, db: 0.843983, ltc: 1 },
    { premium: 325000, db: 0.843989, ltc: 1 },
    { premium: 350000, db: 0.843989, ltc: 1 },
    { premium: 375000, db: 0.843988, ltc: 1 },
    { premium: 400000, db: 0.843988, ltc: 1 },
    { premium: 450000, db: 0.843988, ltc: 1 },
    { premium: 500000, db: 0.843987, ltc: 1 },
  ],
  "sp_joint|60|70|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.046397, ltc: 0.99455 },
    { premium: 450000, db: 1.131212, ltc: 0.984585 },
    { premium: 500000, db: 1.199063, ltc: 0.976612 },
  ],
  "sp_joint|60|70|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.633539, ltc: 1 },
    { premium: 75000, db: 1.089026, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.000009, ltc: 1 },
    { premium: 375000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.000007, ltc: 1 },
    { premium: 500000, db: 1.00001, ltc: 1 },
  ],
  "sp_joint|60|70|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999993, ltc: 0.999993 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999999, ltc: 0.999999 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 0.999999, ltc: 0.999999 },
    { premium: 350000, db: 0.999999, ltc: 0.999999 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.004532, ltc: 0.997866 },
    { premium: 500000, db: 1.055577, ltc: 0.973829 },
  ],
  "sp_joint|60|70|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.99999, ltc: 1 },
    { premium: 75000, db: 1.000003, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|60|70|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.301211, ltc: 1.301211 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000008 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.185497, ltc: 1.026477 },
    { premium: 325000, db: 1.278869, ltc: 1.039799 },
    { premium: 350000, db: 1.358902, ltc: 1.051218 },
    { premium: 375000, db: 1.428264, ltc: 1.061115 },
    { premium: 400000, db: 1.488956, ltc: 1.069774 },
    { premium: 450000, db: 1.590109, ltc: 1.084207 },
    { premium: 500000, db: 1.671032, ltc: 1.095753 },
  ],
  "sp_joint|60|70|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.911463, ltc: 1.911463 },
    { premium: 75000, db: 1.274309, ltc: 1.274309 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1.000011 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.00001, ltc: 1.00001 },
    { premium: 300000, db: 1.000013, ltc: 1.000013 },
    { premium: 325000, db: 1.000016, ltc: 1.000016 },
    { premium: 350000, db: 1.000014, ltc: 1.000014 },
    { premium: 375000, db: 1.000017, ltc: 1.000017 },
    { premium: 400000, db: 1.111866, ltc: 1.007764 },
    { premium: 450000, db: 1.379947, ltc: 1.02633 },
    { premium: 500000, db: 1.594415, ltc: 1.041185 },
  ],
  "sp_joint|60|70|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.640727, ltc: 1 },
    { premium: 300000, db: 0.640727, ltc: 1 },
    { premium: 325000, db: 0.640726, ltc: 1 },
    { premium: 350000, db: 0.640724, ltc: 1 },
    { premium: 375000, db: 0.640729, ltc: 1 },
    { premium: 400000, db: 0.640727, ltc: 1 },
    { premium: 450000, db: 0.640729, ltc: 1 },
    { premium: 500000, db: 0.640727, ltc: 1 },
  ],
  "sp_joint|60|70|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.115183, ltc: 1.115183 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.010014, ltc: 1.000624 },
    { premium: 325000, db: 1.09699, ltc: 1.005988 },
    { premium: 350000, db: 1.171545, ltc: 1.010587 },
    { premium: 375000, db: 1.236159, ltc: 1.014573 },
    { premium: 400000, db: 1.292696, ltc: 1.018061 },
    { premium: 450000, db: 1.386924, ltc: 1.023874 },
    { premium: 500000, db: 1.462307, ltc: 1.028524 },
  ],
  "sp_joint|60|70|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.951821, ltc: 1 },
    { premium: 150000, db: 0.951821, ltc: 1 },
    { premium: 200000, db: 0.951821, ltc: 1 },
    { premium: 300000, db: 0.951821, ltc: 1 },
    { premium: 325000, db: 0.951821, ltc: 1 },
    { premium: 350000, db: 0.951827, ltc: 1 },
    { premium: 375000, db: 0.951826, ltc: 1 },
    { premium: 400000, db: 0.951826, ltc: 1 },
    { premium: 450000, db: 0.951825, ltc: 1 },
    { premium: 500000, db: 0.951825, ltc: 1 },
  ],
  "sp_joint|60|70|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.021826, ltc: 0.995968 },
    { premium: 375000, db: 1.06903, ltc: 0.987233 },
    { premium: 400000, db: 1.110331, ltc: 0.979588 },
    { premium: 450000, db: 1.17917, ltc: 0.96685 },
    { premium: 500000, db: 1.234239, ltc: 0.956658 },
  ],
  "sp_joint|60|70|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.208556, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000009, ltc: 1 },
    { premium: 375000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
    { premium: 450000, db: 1.000009, ltc: 1 },
    { premium: 500000, db: 1.048552, ltc: 1 },
  ],
  "sp_joint|60|70|None|None|25 Months|25 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000004, ltc: 1.000004 },
    { premium: 375000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.026194, ltc: 0.990727 },
    { premium: 500000, db: 1.082106, ltc: 0.97092 },
  ],
  "sp_joint|60|70|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.104358, ltc: 1.104358 },
    { premium: 75000, db: 0.999993, ltc: 0.999993 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
    { premium: 450000, db: 1.000002, ltc: 1.000002 },
    { premium: 500000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|60|70|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.574364, ltc: 1 },
    { premium: 75000, db: 1.049576, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000005, ltc: 1 },
    { premium: 500000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|60|70|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|60|70|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.140872, ltc: 1 },
    { premium: 75000, db: 1.000008, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000005, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
    { premium: 450000, db: 1.000008, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|60|70|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1.000001, ltc: 1.000001 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000002, ltc: 1.000002 },
    { premium: 500000, db: 1.000001, ltc: 1.000001 },
  ],
  "sp_joint|60|70|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 325000, db: 1.000004, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000005, ltc: 1 },
  ],
  "sp_joint|60|75|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.29898, ltc: 1.29898 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000008 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
    { premium: 325000, db: 1.000011, ltc: 1.000011 },
    { premium: 350000, db: 1.000009, ltc: 1.000009 },
    { premium: 375000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.023833, ltc: 0.999024 },
    { premium: 450000, db: 1.123798, ltc: 0.994884 },
    { premium: 500000, db: 1.20377, ltc: 0.991571 },
  ],
  "sp_joint|60|75|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.797304, ltc: 1.797304 },
    { premium: 75000, db: 1.198203, ltc: 1.198203 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.000004, ltc: 1.000004 },
    { premium: 500000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|60|75|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.723866, ltc: 1 },
    { premium: 200000, db: 0.723866, ltc: 1 },
    { premium: 300000, db: 0.723866, ltc: 1 },
    { premium: 325000, db: 0.723869, ltc: 1 },
    { premium: 350000, db: 0.723866, ltc: 1 },
    { premium: 375000, db: 0.723868, ltc: 1 },
    { premium: 400000, db: 0.723866, ltc: 1 },
    { premium: 450000, db: 0.72387, ltc: 1 },
    { premium: 500000, db: 0.72387, ltc: 1 },
  ],
  "sp_joint|60|75|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1.133052, ltc: 1.133052 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000008, ltc: 1.000008 },
    { premium: 325000, db: 1.000008, ltc: 1.000008 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.000006, ltc: 1.000006 },
    { premium: 500000, db: 1.070658, ltc: 0.988541 },
  ],
  "sp_joint|60|75|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.920604, ltc: 1 },
    { premium: 75000, db: 1.280403, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000015, ltc: 1 },
    { premium: 150000, db: 1.000013, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000013, ltc: 1 },
    { premium: 325000, db: 1.000018, ltc: 1 },
    { premium: 350000, db: 1.000016, ltc: 1 },
    { premium: 375000, db: 1.000015, ltc: 1 },
    { premium: 400000, db: 1.000014, ltc: 1 },
    { premium: 450000, db: 1.000017, ltc: 1 },
    { premium: 500000, db: 1.000015, ltc: 1 },
  ],
  "sp_joint|60|75|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000007 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.000007, ltc: 1.000007 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.000008, ltc: 1.000008 },
    { premium: 500000, db: 1.000007, ltc: 1.000007 },
  ],
  "sp_joint|60|75|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.177797, ltc: 1 },
    { premium: 75000, db: 1.000008, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.00001, ltc: 1 },
    { premium: 375000, db: 1.000011, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
    { premium: 450000, db: 1.00001, ltc: 1 },
    { premium: 500000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|60|75|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.508667, ltc: 1.508667 },
    { premium: 75000, db: 1.005778, ltc: 1.005778 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000009, ltc: 1.000009 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000008, ltc: 1.000008 },
    { premium: 300000, db: 1.00001, ltc: 1.00001 },
    { premium: 325000, db: 1.088386, ltc: 1.008389 },
    { premium: 350000, db: 1.17022, ltc: 1.016149 },
    { premium: 375000, db: 1.241138, ltc: 1.022872 },
    { premium: 400000, db: 1.303195, ltc: 1.028757 },
    { premium: 450000, db: 1.40662, ltc: 1.038562 },
    { premium: 500000, db: 1.48936, ltc: 1.046407 },
  ],
  "sp_joint|60|75|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.913742, ltc: 0.913742 },
    { premium: 150000, db: 0.913742, ltc: 0.913742 },
    { premium: 200000, db: 0.913742, ltc: 0.913742 },
    { premium: 300000, db: 0.913748, ltc: 0.913748 },
    { premium: 325000, db: 0.913748, ltc: 0.913748 },
    { premium: 350000, db: 0.913747, ltc: 0.913747 },
    { premium: 375000, db: 0.913747, ltc: 0.913747 },
    { premium: 400000, db: 0.913747, ltc: 0.913747 },
    { premium: 450000, db: 0.969505, ltc: 0.915749 },
    { premium: 500000, db: 1.168713, ltc: 0.922894 },
  ],
  "sp_joint|60|75|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.566819, ltc: 1 },
    { premium: 300000, db: 0.566822, ltc: 1 },
    { premium: 325000, db: 0.566826, ltc: 1 },
    { premium: 350000, db: 0.566823, ltc: 1 },
    { premium: 375000, db: 0.566826, ltc: 1 },
    { premium: 400000, db: 0.566824, ltc: 1 },
    { premium: 450000, db: 0.566824, ltc: 1 },
    { premium: 500000, db: 0.566825, ltc: 1 },
  ],
  "sp_joint|60|75|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.301618, ltc: 1.301618 },
    { premium: 75000, db: 0.999987, ltc: 0.999987 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 0.999999, ltc: 0.999999 },
    { premium: 350000, db: 1.008444, ltc: 1.000067 },
    { premium: 375000, db: 1.075618, ltc: 1.000598 },
    { premium: 400000, db: 1.134393, ltc: 1.001061 },
    { premium: 450000, db: 1.232353, ltc: 1.001834 },
    { premium: 500000, db: 1.310721, ltc: 1.002452 },
  ],
  "sp_joint|60|75|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.831151, ltc: 1 },
    { premium: 150000, db: 0.831143, ltc: 1 },
    { premium: 200000, db: 0.831143, ltc: 1 },
    { premium: 300000, db: 0.83115, ltc: 1 },
    { premium: 325000, db: 0.831146, ltc: 1 },
    { premium: 350000, db: 0.831149, ltc: 1 },
    { premium: 375000, db: 0.831151, ltc: 1 },
    { premium: 400000, db: 0.831148, ltc: 1 },
    { premium: 450000, db: 0.831148, ltc: 1 },
    { premium: 500000, db: 0.831151, ltc: 1 },
  ],
  "sp_joint|60|75|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1.005601, ltc: 1.005601 },
    { premium: 75000, db: 0.99999, ltc: 0.99999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 0.999999, ltc: 0.999999 },
    { premium: 350000, db: 0.999999, ltc: 0.999999 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.070515, ltc: 0.982182 },
    { premium: 500000, db: 1.129893, ltc: 0.967179 },
  ],
  "sp_joint|60|75|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.401413, ltc: 1 },
    { premium: 75000, db: 0.999991, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|60|75|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1.066539, ltc: 1.066539 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1.000005, ltc: 1.000005 },
    { premium: 375000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
    { premium: 450000, db: 1.000004, ltc: 1.000004 },
    { premium: 500000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|60|75|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.364302, ltc: 1.364302 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
    { premium: 325000, db: 1.000009, ltc: 1.000009 },
    { premium: 350000, db: 1.00001, ltc: 1.00001 },
    { premium: 375000, db: 1.00001, ltc: 1.00001 },
    { premium: 400000, db: 1.00001, ltc: 1.00001 },
    { premium: 450000, db: 1.000011, ltc: 1.000011 },
    { premium: 500000, db: 1.000011, ltc: 1.000011 },
  ],
  "sp_joint|60|75|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.91461, ltc: 1 },
    { premium: 75000, db: 1.276407, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000008, ltc: 1 },
    { premium: 375000, db: 1.000009, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000011, ltc: 1 },
    { premium: 500000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|60|75|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999991, ltc: 0.999991 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 0.999998 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1.000001, ltc: 1.000001 },
    { premium: 375000, db: 1.000001, ltc: 1.000001 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000001, ltc: 1.000001 },
    { premium: 500000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|60|75|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.395565, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 325000, db: 1.000012, ltc: 1 },
    { premium: 350000, db: 1.00001, ltc: 1 },
    { premium: 375000, db: 1.000012, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000011, ltc: 1 },
    { premium: 500000, db: 1.000011, ltc: 1 },
  ],
  "sp_joint|60|75|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.000004, ltc: 1.000004 },
    { premium: 500000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|60|75|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999991, ltc: 1 },
    { premium: 75000, db: 0.999997, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000003, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
    { premium: 450000, db: 1.000007, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|60|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000007 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.129648, ltc: 0.990327 },
    { premium: 400000, db: 1.314762, ltc: 0.976508 },
  ],
  "sp_joint|60|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.158356, ltc: 1.158356 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.202865, ltc: 0.980121 },
  ],
  "sp_joint|60|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 1.761808, ltc: 1 },
    { premium: 75000, db: 1.174539, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1 },
    { premium: 300000, db: 1.000012, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|60|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.005149, ltc: 0.998816 },
    { premium: 400000, db: 1.174959, ltc: 0.959661 },
  ],
  "sp_joint|60|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.232159, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.00001, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|60|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.041288, ltc: 0.971357 },
  ],
  "sp_joint|60|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|60|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.030768, ltc: 1.030768 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.395769, ltc: 1.041467 },
    { premium: 400000, db: 1.613099, ltc: 1.064236 },
  ],
  "sp_joint|60|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.482851, ltc: 1.482851 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999991, ltc: 0.999991 },
    { premium: 150000, db: 0.999995, ltc: 0.999995 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.025865, ltc: 1.000987 },
    { premium: 400000, db: 1.584028, ltc: 1.022283 },
  ],
  "sp_joint|60|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.848943, ltc: 1 },
    { premium: 150000, db: 0.848943, ltc: 1 },
    { premium: 200000, db: 0.848943, ltc: 1 },
    { premium: 300000, db: 0.848943, ltc: 1 },
    { premium: 400000, db: 0.848943, ltc: 1 },
  ],
  "sp_joint|60|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.215688, ltc: 0.999194 },
    { premium: 400000, db: 1.409897, ltc: 0.998461 },
  ],
  "sp_joint|60|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.589074, ltc: 1 },
    { premium: 75000, db: 1.059382, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|60|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.054847, ltc: 0.982626 },
    { premium: 400000, db: 1.19416, ltc: 0.938482 },
  ],
  "sp_joint|60|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.074978, ltc: 1 },
  ],
  "sp_joint|60|None|None|25 Months|25 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.076755, ltc: 0.957135 },
  ],
  "sp_joint|60|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000006, ltc: 1.000006 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|60|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.154025, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999993, ltc: 1 },
    { premium: 150000, db: 0.999996, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|60|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|60|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|60|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999995, ltc: 0.999995 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|60|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|65|70|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.115904, ltc: 1.115904 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000007 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.043578, ltc: 1.000014 },
    { premium: 375000, db: 1.107361, ltc: 1.000025 },
    { premium: 400000, db: 1.163172, ltc: 1.000033 },
    { premium: 450000, db: 1.256188, ltc: 1.000047 },
    { premium: 500000, db: 1.3306, ltc: 1.000058 },
  ],
  "sp_joint|65|70|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.557833, ltc: 1.557833 },
    { premium: 75000, db: 1.038556, ltc: 1.038556 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000009, ltc: 1.000009 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000008, ltc: 1.000008 },
    { premium: 300000, db: 1.00001, ltc: 1.00001 },
    { premium: 325000, db: 1.000013, ltc: 1.000013 },
    { premium: 350000, db: 1.000011, ltc: 1.000011 },
    { premium: 375000, db: 1.000014, ltc: 1.000014 },
    { premium: 400000, db: 1.000012, ltc: 1.000012 },
    { premium: 450000, db: 1.000012, ltc: 1.000012 },
    { premium: 500000, db: 1.117125, ltc: 0.995496 },
  ],
  "sp_joint|65|70|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.82384, ltc: 1 },
    { premium: 150000, db: 0.823837, ltc: 1 },
    { premium: 200000, db: 0.823844, ltc: 1 },
    { premium: 300000, db: 0.823844, ltc: 1 },
    { premium: 325000, db: 0.823842, ltc: 1 },
    { premium: 350000, db: 0.823841, ltc: 1 },
    { premium: 375000, db: 0.823845, ltc: 1 },
    { premium: 400000, db: 0.823844, ltc: 1 },
    { premium: 450000, db: 0.823846, ltc: 1 },
    { premium: 500000, db: 0.823844, ltc: 1 },
  ],
  "sp_joint|65|70|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.000004, ltc: 1.000004 },
    { premium: 400000, db: 1.023745, ltc: 0.997055 },
    { premium: 450000, db: 1.110108, ltc: 0.986328 },
    { premium: 500000, db: 1.179197, ltc: 0.977745 },
  ],
  "sp_joint|65|70|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.677239, ltc: 1 },
    { premium: 75000, db: 1.118159, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000006, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.000006, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|65|70|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000005 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000007, ltc: 1.000007 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.000007, ltc: 1.000007 },
    { premium: 500000, db: 1.038108, ltc: 0.981339 },
  ],
  "sp_joint|65|70|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.0217, ltc: 1 },
    { premium: 75000, db: 0.999993, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 0.999998, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|70|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.334339, ltc: 1.334339 },
    { premium: 75000, db: 0.999987, ltc: 0.999987 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.153753, ltc: 1.021647 },
    { premium: 325000, db: 1.248994, ltc: 1.035054 },
    { premium: 350000, db: 1.330633, ltc: 1.046548 },
    { premium: 375000, db: 1.401387, ltc: 1.05651 },
    { premium: 400000, db: 1.463296, ltc: 1.065226 },
    { premium: 450000, db: 1.566476, ltc: 1.079752 },
    { premium: 500000, db: 1.64902, ltc: 1.091372 },
  ],
  "sp_joint|65|70|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.95875, ltc: 1.95875 },
    { premium: 75000, db: 1.305833, ltc: 1.305833 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000008 },
    { premium: 150000, db: 1.000013, ltc: 1.000013 },
    { premium: 200000, db: 1.00001, ltc: 1.00001 },
    { premium: 300000, db: 1.000013, ltc: 1.000013 },
    { premium: 325000, db: 1.000015, ltc: 1.000015 },
    { premium: 350000, db: 1.000011, ltc: 1.000011 },
    { premium: 375000, db: 1.000013, ltc: 1.000013 },
    { premium: 400000, db: 1.051896, ltc: 1.003535 },
    { premium: 450000, db: 1.325155, ltc: 1.022077 },
    { premium: 500000, db: 1.543765, ltc: 1.036911 },
  ],
  "sp_joint|65|70|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.625617, ltc: 1 },
    { premium: 300000, db: 0.625621, ltc: 1 },
    { premium: 325000, db: 0.625618, ltc: 1 },
    { premium: 350000, db: 0.625616, ltc: 1 },
    { premium: 375000, db: 0.625619, ltc: 1 },
    { premium: 400000, db: 0.625617, ltc: 1 },
    { premium: 450000, db: 0.625619, ltc: 1 },
    { premium: 500000, db: 0.625619, ltc: 1 },
  ],
  "sp_joint|65|70|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.146848, ltc: 1.146848 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000008, ltc: 1.000008 },
    { premium: 325000, db: 1.066635, ltc: 1.003801 },
    { premium: 350000, db: 1.142484, ltc: 1.008119 },
    { premium: 375000, db: 1.208216, ltc: 1.01186 },
    { premium: 400000, db: 1.265731, ltc: 1.015133 },
    { premium: 450000, db: 1.361593, ltc: 1.02059 },
    { premium: 500000, db: 1.43828, ltc: 1.024954 },
  ],
  "sp_joint|65|70|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.927725, ltc: 1 },
    { premium: 150000, db: 0.927728, ltc: 1 },
    { premium: 200000, db: 0.927731, ltc: 1 },
    { premium: 300000, db: 0.927735, ltc: 1 },
    { premium: 325000, db: 0.927735, ltc: 1 },
    { premium: 350000, db: 0.927736, ltc: 1 },
    { premium: 375000, db: 0.927736, ltc: 1 },
    { premium: 400000, db: 0.927736, ltc: 1 },
    { premium: 450000, db: 0.927737, ltc: 1 },
    { premium: 500000, db: 0.927733, ltc: 1 },
  ],
  "sp_joint|65|70|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.045162, ltc: 0.991042 },
    { premium: 400000, db: 1.087079, ltc: 0.982721 },
    { premium: 450000, db: 1.156944, ltc: 0.968856 },
    { premium: 500000, db: 1.212835, ltc: 0.957763 },
  ],
  "sp_joint|65|70|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.246451, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.000005, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
    { premium: 450000, db: 1.000007, ltc: 1 },
    { premium: 500000, db: 1.004151, ltc: 1 },
  ],
  "sp_joint|65|70|None|None|25 Months|25 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.011242, ltc: 0.995974 },
    { premium: 500000, db: 1.068342, ltc: 0.975489 },
  ],
  "sp_joint|65|70|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.13291, ltc: 1.13291 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.000005, ltc: 1.000005 },
    { premium: 500000, db: 1.000007, ltc: 1.000007 },
  ],
  "sp_joint|65|70|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.613847, ltc: 1 },
    { premium: 75000, db: 1.075898, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000008, ltc: 1 },
    { premium: 450000, db: 1.000005, ltc: 1 },
    { premium: 500000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|65|70|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 0.999999, ltc: 0.999999 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000001, ltc: 1.000001 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|70|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.173164, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 325000, db: 1.000005, ltc: 1 },
    { premium: 350000, db: 1.000005, ltc: 1 },
    { premium: 375000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000004, ltc: 1 },
    { premium: 500000, db: 1.000005, ltc: 1 },
  ],
  "sp_joint|65|70|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 0.999998, ltc: 0.999998 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 0.999999, ltc: 0.999999 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 0.999999, ltc: 0.999999 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|70|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 325000, db: 1.000004, ltc: 1 },
    { premium: 350000, db: 1.000005, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000004, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|65|75|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.319601, ltc: 1.319601 },
    { premium: 75000, db: 0.999991, ltc: 0.999991 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.009577, ltc: 0.999629 },
    { premium: 450000, db: 1.111589, ltc: 0.995653 },
    { premium: 500000, db: 1.193199, ltc: 0.992472 },
  ],
  "sp_joint|65|75|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.827021, ltc: 1.827021 },
    { premium: 75000, db: 1.218014, ltc: 1.218014 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999989, ltc: 0.999989 },
    { premium: 150000, db: 0.999994, ltc: 0.999994 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 0.999997, ltc: 0.999997 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1.000002 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|75|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.711666, ltc: 1 },
    { premium: 200000, db: 0.711666, ltc: 1 },
    { premium: 300000, db: 0.711672, ltc: 1 },
    { premium: 325000, db: 0.711672, ltc: 1 },
    { premium: 350000, db: 0.711671, ltc: 1 },
    { premium: 375000, db: 0.711671, ltc: 1 },
    { premium: 400000, db: 0.711671, ltc: 1 },
    { premium: 450000, db: 0.71167, ltc: 1 },
    { premium: 500000, db: 0.711674, ltc: 1 },
  ],
  "sp_joint|65|75|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1.155612, ltc: 1.155612 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000007, ltc: 1.000007 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.000005, ltc: 1.000005 },
    { premium: 500000, db: 1.056871, ltc: 0.990671 },
  ],
  "sp_joint|65|75|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.957523, ltc: 1 },
    { premium: 75000, db: 1.305015, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.000011, ltc: 1 },
    { premium: 375000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000009, ltc: 1 },
    { premium: 500000, db: 1.000012, ltc: 1 },
  ],
  "sp_joint|65|75|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000001, ltc: 1.000001 },
    { premium: 375000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000003, ltc: 1.000003 },
    { premium: 500000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|65|75|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.208075, ltc: 1 },
    { premium: 75000, db: 1.000008, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1 },
    { premium: 150000, db: 1.000008, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000007, ltc: 1 },
    { premium: 375000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
    { premium: 450000, db: 1.000008, ltc: 1 },
    { premium: 500000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|65|75|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.533115, ltc: 1.533115 },
    { premium: 75000, db: 1.022076, ltc: 1.022076 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000008, ltc: 1.000008 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.07013, ltc: 1.006783 },
    { premium: 350000, db: 1.153663, ltc: 1.014856 },
    { premium: 375000, db: 1.226058, ltc: 1.021852 },
    { premium: 400000, db: 1.289404, ltc: 1.027973 },
    { premium: 450000, db: 1.39498, ltc: 1.038175 },
    { premium: 500000, db: 1.479441, ltc: 1.046337 },
  ],
  "sp_joint|65|75|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.898622, ltc: 0.898622 },
    { premium: 150000, db: 0.898622, ltc: 0.898622 },
    { premium: 200000, db: 0.898622, ltc: 0.898622 },
    { premium: 300000, db: 0.898622, ltc: 0.898622 },
    { premium: 325000, db: 0.898622, ltc: 0.898622 },
    { premium: 350000, db: 0.898622, ltc: 0.898622 },
    { premium: 375000, db: 0.898622, ltc: 0.898622 },
    { premium: 400000, db: 0.898622, ltc: 0.898622 },
    { premium: 450000, db: 0.920577, ltc: 0.89944 },
    { premium: 500000, db: 1.120682, ltc: 0.906883 },
  ],
  "sp_joint|65|75|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.557139, ltc: 1 },
    { premium: 300000, db: 0.557142, ltc: 1 },
    { premium: 325000, db: 0.55714, ltc: 1 },
    { premium: 350000, db: 0.557137, ltc: 1 },
    { premium: 375000, db: 0.557141, ltc: 1 },
    { premium: 400000, db: 0.557139, ltc: 1 },
    { premium: 450000, db: 0.55714, ltc: 1 },
    { premium: 500000, db: 0.557141, ltc: 1 },
  ],
  "sp_joint|65|75|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.327255, ltc: 1.327255 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.056944, ltc: 1.000376 },
    { premium: 400000, db: 1.116706, ltc: 1.000763 },
    { premium: 450000, db: 1.216316, ltc: 1.001411 },
    { premium: 500000, db: 1.296001, ltc: 1.001928 },
  ],
  "sp_joint|65|75|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.815616, ltc: 1 },
    { premium: 150000, db: 0.815624, ltc: 1 },
    { premium: 200000, db: 0.815624, ltc: 1 },
    { premium: 300000, db: 0.815624, ltc: 1 },
    { premium: 325000, db: 0.815627, ltc: 1 },
    { premium: 350000, db: 0.815624, ltc: 1 },
    { premium: 375000, db: 0.815626, ltc: 1 },
    { premium: 400000, db: 0.815624, ltc: 1 },
    { premium: 450000, db: 0.815624, ltc: 1 },
    { premium: 500000, db: 0.815628, ltc: 1 },
  ],
  "sp_joint|65|75|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1.032758, ltc: 1.032758 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
    { premium: 450000, db: 1.053736, ltc: 0.985853 },
    { premium: 500000, db: 1.113859, ltc: 0.970016 },
  ],
  "sp_joint|65|75|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.435779, ltc: 1 },
    { premium: 75000, db: 0.99999, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000006, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000006, ltc: 1 },
    { premium: 500000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|65|75|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1.082916, ltc: 1.082916 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000001, ltc: 1.000001 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|75|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.386106, ltc: 1.386106 },
    { premium: 75000, db: 1.000009, ltc: 1.000009 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000009, ltc: 1.000009 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
    { premium: 325000, db: 1.000011, ltc: 1.000011 },
    { premium: 350000, db: 1.000012, ltc: 1.000012 },
    { premium: 375000, db: 1.000013, ltc: 1.000013 },
    { premium: 400000, db: 1.00001, ltc: 1.00001 },
    { premium: 450000, db: 1.000012, ltc: 1.000012 },
    { premium: 500000, db: 1.000011, ltc: 1.000011 },
  ],
  "sp_joint|65|75|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.946473, ltc: 1 },
    { premium: 75000, db: 1.297649, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000006, ltc: 1 },
    { premium: 325000, db: 1.000012, ltc: 1 },
    { premium: 350000, db: 1.000011, ltc: 1 },
    { premium: 375000, db: 1.00001, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000009, ltc: 1 },
    { premium: 500000, db: 1.000012, ltc: 1 },
  ],
  "sp_joint|65|75|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000002, ltc: 1.000002 },
    { premium: 500000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|65|75|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.422908, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1 },
    { premium: 150000, db: 1.000009, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 325000, db: 1.000013, ltc: 1 },
    { premium: 350000, db: 1.000012, ltc: 1 },
    { premium: 375000, db: 1.000011, ltc: 1 },
    { premium: 400000, db: 1.000011, ltc: 1 },
    { premium: 450000, db: 1.000013, ltc: 1 },
    { premium: 500000, db: 1.000011, ltc: 1 },
  ],
  "sp_joint|65|75|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000007, ltc: 1.000007 },
    { premium: 400000, db: 1.000006, ltc: 1.000006 },
    { premium: 450000, db: 1.000006, ltc: 1.000006 },
    { premium: 500000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|65|75|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.007801, ltc: 0.999721 },
    { premium: 400000, db: 1.239191, ltc: 0.991461 },
  ],
  "sp_joint|65|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.366782, ltc: 1.366782 },
    { premium: 75000, db: 0.999991, ltc: 0.999991 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|65|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.947309, ltc: 1 },
    { premium: 150000, db: 0.947314, ltc: 1 },
    { premium: 200000, db: 0.947311, ltc: 1 },
    { premium: 300000, db: 0.947314, ltc: 1 },
    { premium: 400000, db: 0.947316, ltc: 1 },
  ],
  "sp_joint|65|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.100056, ltc: 0.982404 },
  ],
  "sp_joint|65|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.466907, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|65|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 0.999991, ltc: 1 },
    { premium: 75000, db: 0.999991, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 0.999997, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|65|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.19803, ltc: 1.19803 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.268925, ltc: 1.033798 },
    { premium: 400000, db: 1.53562, ltc: 1.067311 },
  ],
  "sp_joint|65|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 1.740255, ltc: 1.740255 },
    { premium: 75000, db: 1.16017, ltc: 1.16017 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000014, ltc: 1.000014 },
    { premium: 150000, db: 1.000012, ltc: 1.000012 },
    { premium: 200000, db: 1.000009, ltc: 1.000009 },
    { premium: 300000, db: 1.000012, ltc: 1.000012 },
    { premium: 400000, db: 1.310855, ltc: 1.017025 },
  ],
  "sp_joint|65|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.711119, ltc: 1 },
    { premium: 200000, db: 0.711126, ltc: 1 },
    { premium: 300000, db: 0.711126, ltc: 1 },
    { premium: 400000, db: 0.711126, ltc: 1 },
  ],
  "sp_joint|65|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.026346, ltc: 1.026346 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.093406, ltc: 1.002848 },
    { premium: 400000, db: 1.336263, ltc: 1.01024 },
  ],
  "sp_joint|65|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 1.894193, ltc: 1 },
    { premium: 75000, db: 1.262795, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1.000013, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1 },
    { premium: 300000, db: 1.000013, ltc: 1 },
    { premium: 400000, db: 1.000014, ltc: 1 },
  ],
  "sp_joint|65|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.138237, ltc: 0.965856 },
  ],
  "sp_joint|65|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.107871, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|65|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1.000006 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.013536, ltc: 0.99374 },
  ],
  "sp_joint|65|None|None|25 Months|50 Months": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|65|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.383039, ltc: 1 },
    { premium: 75000, db: 0.999991, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000006, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
  ],
  "sp_joint|65|None|None|33 Months|33 Months": [
    { premium: 50000, db: 0.999993, ltc: 0.999993 },
    { premium: 75000, db: 1.000002, ltc: 1.000002 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|65|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.019814, ltc: 1 },
    { premium: 75000, db: 0.99999, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 0.999997, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|65|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999994, ltc: 0.999994 },
    { premium: 75000, db: 0.999998, ltc: 0.999998 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1.000001 },
    { premium: 150000, db: 1.000002, ltc: 1.000002 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|65|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 0.999993, ltc: 1 },
    { premium: 75000, db: 0.999998, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000001, ltc: 1 },
    { premium: 150000, db: 0.999998, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|70|75|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.347827, ltc: 1.347827 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000004, ltc: 1.000004 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000006, ltc: 1.000006 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.092703, ltc: 0.995618 },
    { premium: 500000, db: 1.174783, ltc: 0.991731 },
  ],
  "sp_joint|70|75|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.861957, ltc: 1.861957 },
    { premium: 75000, db: 1.241305, ltc: 1.241305 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000009, ltc: 1.000009 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000011, ltc: 1.000011 },
    { premium: 375000, db: 1.00001, ltc: 1.00001 },
    { premium: 400000, db: 1.000009, ltc: 1.000009 },
    { premium: 450000, db: 1.000008, ltc: 1.000008 },
    { premium: 500000, db: 1.000007, ltc: 1.000007 },
  ],
  "sp_joint|70|75|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.699733, ltc: 1 },
    { premium: 200000, db: 0.699736, ltc: 1 },
    { premium: 300000, db: 0.699739, ltc: 1 },
    { premium: 325000, db: 0.699734, ltc: 1 },
    { premium: 350000, db: 0.699735, ltc: 1 },
    { premium: 375000, db: 0.699735, ltc: 1 },
    { premium: 400000, db: 0.699736, ltc: 1 },
    { premium: 450000, db: 0.699737, ltc: 1 },
    { premium: 500000, db: 0.699738, ltc: 1 },
  ],
  "sp_joint|70|75|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1.185167, ltc: 1.185167 },
    { premium: 75000, db: 0.999992, ltc: 0.999992 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1.038247, ltc: 0.993181 },
  ],
  "sp_joint|70|75|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.997683, ltc: 1 },
    { premium: 75000, db: 1.331788, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000007, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 325000, db: 1.000008, ltc: 1 },
    { premium: 350000, db: 1.000009, ltc: 1 },
    { premium: 375000, db: 1.000009, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000011, ltc: 1 },
    { premium: 500000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|70|75|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 0.99999, ltc: 0.99999 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000007, ltc: 1.000007 },
    { premium: 350000, db: 1.000007, ltc: 1.000007 },
    { premium: 375000, db: 1.000007, ltc: 1.000007 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.000007, ltc: 1.000007 },
    { premium: 500000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|70|75|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.243234, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999998, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000005, ltc: 1 },
    { premium: 375000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
    { premium: 450000, db: 1.000007, ltc: 1 },
    { premium: 500000, db: 1.000005, ltc: 1 },
  ],
  "sp_joint|70|75|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.564144, ltc: 1.564144 },
    { premium: 75000, db: 1.042763, ltc: 1.042763 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.045737, ltc: 1.004134 },
    { premium: 350000, db: 1.129656, ltc: 1.011717 },
    { premium: 375000, db: 1.202386, ltc: 1.01829 },
    { premium: 400000, db: 1.266028, ltc: 1.024042 },
    { premium: 450000, db: 1.372092, ltc: 1.033627 },
    { premium: 500000, db: 1.456943, ltc: 1.041294 },
  ],
  "sp_joint|70|75|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.88267, ltc: 0.88267 },
    { premium: 150000, db: 0.882676, ltc: 0.882676 },
    { premium: 200000, db: 0.882672, ltc: 0.882672 },
    { premium: 300000, db: 0.882676, ltc: 0.882676 },
    { premium: 325000, db: 0.882678, ltc: 0.882678 },
    { premium: 350000, db: 0.882679, ltc: 0.882679 },
    { premium: 375000, db: 0.882676, ltc: 0.882676 },
    { premium: 400000, db: 0.882677, ltc: 0.882677 },
    { premium: 450000, db: 0.88268, ltc: 0.88268 },
    { premium: 500000, db: 1.065999, ltc: 0.888656 },
  ],
  "sp_joint|70|75|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.548249, ltc: 1 },
    { premium: 300000, db: 0.548249, ltc: 1 },
    { premium: 325000, db: 0.548247, ltc: 1 },
    { premium: 350000, db: 0.548246, ltc: 1 },
    { premium: 375000, db: 0.548245, ltc: 1 },
    { premium: 400000, db: 0.548249, ltc: 1 },
    { premium: 450000, db: 0.548247, ltc: 1 },
    { premium: 500000, db: 0.548249, ltc: 1 },
  ],
  "sp_joint|70|75|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.359092, ltc: 1.359092 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1.000011 },
    { premium: 150000, db: 1.000009, ltc: 1.000009 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
    { premium: 325000, db: 1.000008, ltc: 1.000008 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.033303, ltc: 0.999875 },
    { premium: 400000, db: 1.093218, ltc: 0.999631 },
    { premium: 450000, db: 1.193081, ltc: 0.999227 },
    { premium: 500000, db: 1.272971, ltc: 0.998903 },
  ],
  "sp_joint|70|75|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.800384, ltc: 1 },
    { premium: 150000, db: 0.800384, ltc: 1 },
    { premium: 200000, db: 0.800384, ltc: 1 },
    { premium: 300000, db: 0.800384, ltc: 1 },
    { premium: 325000, db: 0.800384, ltc: 1 },
    { premium: 350000, db: 0.800384, ltc: 1 },
    { premium: 375000, db: 0.800384, ltc: 1 },
    { premium: 400000, db: 0.800384, ltc: 1 },
    { premium: 450000, db: 0.800384, ltc: 1 },
    { premium: 500000, db: 0.800384, ltc: 1 },
  ],
  "sp_joint|70|75|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1.065595, ltc: 1.065595 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.033593, ltc: 0.990376 },
    { premium: 500000, db: 1.093801, ltc: 0.973121 },
  ],
  "sp_joint|70|75|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.473956, ltc: 1 },
    { premium: 75000, db: 0.99999, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1 },
    { premium: 350000, db: 1.000004, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000003, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|70|75|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1.107994, ltc: 1.107994 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000008, ltc: 1.000008 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.000008, ltc: 1.000008 },
    { premium: 450000, db: 1.000009, ltc: 1.000009 },
    { premium: 500000, db: 1.000009, ltc: 1.000009 },
  ],
  "sp_joint|70|75|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.415196, ltc: 1.415196 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1.000005 },
    { premium: 325000, db: 1.000005, ltc: 1.000005 },
    { premium: 350000, db: 1.000002, ltc: 1.000002 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.000005, ltc: 1.000005 },
    { premium: 500000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|70|75|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.982986, ltc: 1 },
    { premium: 75000, db: 1.321991, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1.000013, ltc: 1 },
    { premium: 200000, db: 1.00001, ltc: 1 },
    { premium: 300000, db: 1.000013, ltc: 1 },
    { premium: 325000, db: 1.000009, ltc: 1 },
    { premium: 350000, db: 1.000011, ltc: 1 },
    { premium: 375000, db: 1.000013, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.000013, ltc: 1 },
    { premium: 500000, db: 1.000012, ltc: 1 },
  ],
  "sp_joint|70|75|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 325000, db: 1.000003, ltc: 1.000003 },
    { premium: 350000, db: 1.000003, ltc: 1.000003 },
    { premium: 375000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
    { premium: 450000, db: 1.000002, ltc: 1.000002 },
    { premium: 500000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|70|75|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.455993, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000007, ltc: 1 },
    { premium: 300000, db: 1.00001, ltc: 1 },
    { premium: 325000, db: 1.000006, ltc: 1 },
    { premium: 350000, db: 1.000006, ltc: 1 },
    { premium: 375000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000007, ltc: 1 },
    { premium: 450000, db: 1.000008, ltc: 1 },
    { premium: 500000, db: 1.000009, ltc: 1 },
  ],
  "sp_joint|70|75|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999992, ltc: 0.999992 },
    { premium: 75000, db: 1.000003, ltc: 1.000003 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.000004, ltc: 1.000004 },
    { premium: 350000, db: 1.000004, ltc: 1.000004 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.000005, ltc: 1.000005 },
    { premium: 500000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|70|75|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 325000, db: 1.000003, ltc: 1 },
    { premium: 350000, db: 1.000003, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1.000002, ltc: 1 },
  ],
  "sp_joint|70|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.149012, ltc: 1.149012 },
    { premium: 75000, db: 1.000004, ltc: 1.000004 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000007, ltc: 1.000007 },
    { premium: 150000, db: 1.000004, ltc: 1.000004 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.13376, ltc: 0.997751 },
  ],
  "sp_joint|70|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.596456, ltc: 1.596456 },
    { premium: 75000, db: 1.064304, ltc: 1.064304 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|70|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.807392, ltc: 1 },
    { premium: 150000, db: 0.807384, ltc: 1 },
    { premium: 200000, db: 0.807394, ltc: 1 },
    { premium: 300000, db: 0.807391, ltc: 1 },
    { premium: 400000, db: 0.807394, ltc: 1 },
  ],
  "sp_joint|70|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1.002737, ltc: 1.002737 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1.000002 },
    { premium: 150000, db: 1.000003, ltc: 1.000003 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 400000, db: 1.000005, ltc: 1.000005 },
  ],
  "sp_joint|70|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 1.718366, ltc: 1 },
    { premium: 75000, db: 1.145577, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|70|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 0.999995 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999997, ltc: 0.999997 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000002, ltc: 1.000002 },
  ],
  "sp_joint|70|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.05612, ltc: 1 },
    { premium: 75000, db: 1.000007, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1 },
    { premium: 150000, db: 1.000007, ltc: 1 },
    { premium: 200000, db: 1.000005, ltc: 1 },
    { premium: 300000, db: 1.000007, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
  ],
  "sp_joint|70|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.370191, ltc: 1.370191 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000009, ltc: 1.000009 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.116532, ltc: 1.014987 },
    { premium: 400000, db: 1.423922, ltc: 1.054502 },
  ],
  "sp_joint|70|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.998812, ltc: 0.998812 },
    { premium: 150000, db: 0.99882, ltc: 0.99882 },
    { premium: 200000, db: 0.99882, ltc: 0.99882 },
    { premium: 300000, db: 0.99882, ltc: 0.99882 },
    { premium: 400000, db: 0.99882, ltc: 0.99882 },
  ],
  "sp_joint|70|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.614268, ltc: 1 },
    { premium: 300000, db: 0.614268, ltc: 1 },
    { premium: 400000, db: 0.614273, ltc: 1 },
  ],
  "sp_joint|70|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.181345, ltc: 1.181345 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999993, ltc: 0.999993 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.231161, ltc: 1.009355 },
  ],
  "sp_joint|70|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.907886, ltc: 1 },
    { premium: 150000, db: 0.907889, ltc: 1 },
    { premium: 200000, db: 0.907892, ltc: 1 },
    { premium: 300000, db: 0.907895, ltc: 1 },
    { premium: 400000, db: 0.907897, ltc: 1 },
  ],
  "sp_joint|70|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 0.999994, ltc: 0.999994 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 0.999996 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.061183, ltc: 0.986073 },
  ],
  "sp_joint|70|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.283607, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000009, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|70|None|None|25 Months|25 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|70|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.166245, ltc: 1.166245 },
    { premium: 75000, db: 0.999996, ltc: 0.999996 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999993, ltc: 0.999993 },
    { premium: 150000, db: 0.999996, ltc: 0.999996 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
  ],
  "sp_joint|70|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.653172, ltc: 1 },
    { premium: 75000, db: 1.102114, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 0.999994, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|70|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1.000004 },
    { premium: 300000, db: 1.000003, ltc: 1.000003 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
  ],
  "sp_joint|70|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.208026, ltc: 1 },
    { premium: 75000, db: 0.999996, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000002, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000004, ltc: 1 },
    { premium: 400000, db: 1.000006, ltc: 1 },
  ],
  "sp_joint|70|None|None|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1.000005 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1.000003 },
    { premium: 150000, db: 1.000005, ltc: 1.000005 },
    { premium: 200000, db: 1.000003, ltc: 1.000003 },
    { premium: 300000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|70|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1.000005, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 1.000005, ltc: 1 },
    { premium: 200000, db: 1.000004, ltc: 1 },
    { premium: 300000, db: 1.000005, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|75|None|3%|25 Months|25 Months": [
    { premium: 50000, db: 1.370003, ltc: 1.370003 },
    { premium: 75000, db: 1.000009, ltc: 1.000009 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000009, ltc: 1.000009 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
    { premium: 325000, db: 1.000011, ltc: 1.000011 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.000009, ltc: 1.000009 },
    { premium: 400000, db: 1.00001, ltc: 1.00001 },
    { premium: 450000, db: 1.075157, ltc: 0.994237 },
    { premium: 500000, db: 1.154325, ltc: 0.988155 },
  ],
  "sp_joint|75|None|3%|25 Months|50 Months": [
    { premium: 50000, db: 1.878289, ltc: 1.878289 },
    { premium: 75000, db: 1.252193, ltc: 1.252193 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1.000011 },
    { premium: 150000, db: 1.000006, ltc: 1.000006 },
    { premium: 200000, db: 1.000009, ltc: 1.000009 },
    { premium: 300000, db: 1.000006, ltc: 1.000006 },
    { premium: 325000, db: 1.00001, ltc: 1.00001 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.000011, ltc: 1.000011 },
    { premium: 400000, db: 1.000009, ltc: 1.000009 },
    { premium: 450000, db: 1.00001, ltc: 1.00001 },
    { premium: 500000, db: 1.000011, ltc: 1.000011 },
  ],
  "sp_joint|75|None|3%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.698506, ltc: 1 },
    { premium: 200000, db: 0.698516, ltc: 1 },
    { premium: 300000, db: 0.698513, ltc: 1 },
    { premium: 325000, db: 0.698515, ltc: 1 },
    { premium: 350000, db: 0.698512, ltc: 1 },
    { premium: 375000, db: 0.698514, ltc: 1 },
    { premium: 400000, db: 0.698516, ltc: 1 },
    { premium: 450000, db: 0.698515, ltc: 1 },
    { premium: 500000, db: 0.698514, ltc: 1 },
  ],
  "sp_joint|75|None|3%|33 Months|33 Months": [
    { premium: 50000, db: 1.210297, ltc: 1.210297 },
    { premium: 75000, db: 1.000008, ltc: 1.000008 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000005, ltc: 1.000005 },
    { premium: 150000, db: 1.000008, ltc: 1.000008 },
    { premium: 200000, db: 1.000006, ltc: 1.000006 },
    { premium: 300000, db: 1.000008, ltc: 1.000008 },
    { premium: 325000, db: 1.000009, ltc: 1.000009 },
    { premium: 350000, db: 1.00001, ltc: 1.00001 },
    { premium: 375000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.000009, ltc: 1.000009 },
    { premium: 450000, db: 1.000008, ltc: 1.000008 },
    { premium: 500000, db: 1.022175, ltc: 0.995196 },
  ],
  "sp_joint|75|None|3%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.99326, ltc: 1 },
    { premium: 150000, db: 0.99326, ltc: 1 },
    { premium: 200000, db: 0.99327, ltc: 1 },
    { premium: 300000, db: 0.993267, ltc: 1 },
    { premium: 325000, db: 0.993266, ltc: 1 },
    { premium: 350000, db: 0.993266, ltc: 1 },
    { premium: 375000, db: 0.993265, ltc: 1 },
    { premium: 400000, db: 0.99327, ltc: 1 },
    { premium: 450000, db: 0.993269, ltc: 1 },
    { premium: 500000, db: 0.993268, ltc: 1 },
  ],
  "sp_joint|75|None|3%|50 Months|50 Months": [
    { premium: 50000, db: 1, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1.000008 },
    { premium: 150000, db: 1.000007, ltc: 1.000007 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000008, ltc: 1.000008 },
    { premium: 375000, db: 1.000008, ltc: 1.000008 },
    { premium: 400000, db: 1.000007, ltc: 1.000007 },
    { premium: 450000, db: 1.000007, ltc: 1.000007 },
    { premium: 500000, db: 1.000008, ltc: 1.000008 },
  ],
  "sp_joint|75|None|3%|50 Months|Lifetime": [
    { premium: 50000, db: 1.269238, ltc: 1 },
    { premium: 75000, db: 1.000004, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000008, ltc: 1 },
    { premium: 150000, db: 1.000004, ltc: 1 },
    { premium: 200000, db: 1.000006, ltc: 1 },
    { premium: 300000, db: 1.000008, ltc: 1 },
    { premium: 325000, db: 1.000007, ltc: 1 },
    { premium: 350000, db: 1.000009, ltc: 1 },
    { premium: 375000, db: 1.000008, ltc: 1 },
    { premium: 400000, db: 1.00001, ltc: 1 },
    { premium: 450000, db: 1.00001, ltc: 1 },
    { premium: 500000, db: 1.000008, ltc: 1 },
  ],
  "sp_joint|75|None|5%|25 Months|25 Months": [
    { premium: 50000, db: 1.583864, ltc: 1.583864 },
    { premium: 75000, db: 1.055909, ltc: 1.055909 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.029345, ltc: 1.002005 },
    { premium: 350000, db: 1.109981, ltc: 1.007514 },
    { premium: 375000, db: 1.179866, ltc: 1.012288 },
    { premium: 400000, db: 1.241016, ltc: 1.016466 },
    { premium: 450000, db: 1.342928, ltc: 1.023427 },
    { premium: 500000, db: 1.424461, ltc: 1.028997 },
  ],
  "sp_joint|75|None|5%|25 Months|50 Months": [
    { premium: 50000, db: 2, ltc: 2 },
    { premium: 75000, db: 1.333333, ltc: 1.333333 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.878126, ltc: 0.878126 },
    { premium: 150000, db: 0.878116, ltc: 0.878116 },
    { premium: 200000, db: 0.878122, ltc: 0.878122 },
    { premium: 300000, db: 0.878122, ltc: 0.878122 },
    { premium: 325000, db: 0.878124, ltc: 0.878124 },
    { premium: 350000, db: 0.878125, ltc: 0.878125 },
    { premium: 375000, db: 0.878126, ltc: 0.878126 },
    { premium: 400000, db: 0.878122, ltc: 0.878122 },
    { premium: 450000, db: 0.878125, ltc: 0.878125 },
    { premium: 500000, db: 1.042499, ltc: 0.880822 },
  ],
  "sp_joint|75|None|5%|25 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.666667, ltc: 1 },
    { premium: 200000, db: 0.548839, ltc: 1 },
    { premium: 300000, db: 0.548842, ltc: 1 },
    { premium: 325000, db: 0.548844, ltc: 1 },
    { premium: 350000, db: 0.548846, ltc: 1 },
    { premium: 375000, db: 0.548848, ltc: 1 },
    { premium: 400000, db: 0.548844, ltc: 1 },
    { premium: 450000, db: 0.548847, ltc: 1 },
    { premium: 500000, db: 0.548845, ltc: 1 },
  ],
  "sp_joint|75|None|5%|33 Months|33 Months": [
    { premium: 50000, db: 1.382236, ltc: 1.382236 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000011, ltc: 1.000011 },
    { premium: 150000, db: 1.000009, ltc: 1.000009 },
    { premium: 200000, db: 1.000007, ltc: 1.000007 },
    { premium: 300000, db: 1.000009, ltc: 1.000009 },
    { premium: 325000, db: 1.000013, ltc: 1.000013 },
    { premium: 350000, db: 1.000012, ltc: 1.000012 },
    { premium: 375000, db: 1.016063, ltc: 0.999484 },
    { premium: 400000, db: 1.073703, ltc: 0.997588 },
    { premium: 450000, db: 1.169766, ltc: 0.994427 },
    { premium: 500000, db: 1.246619, ltc: 0.991899 },
  ],
  "sp_joint|75|None|5%|33 Months|Lifetime": [
    { premium: 50000, db: 2, ltc: 1 },
    { premium: 75000, db: 1.333333, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.8, ltc: 1 },
    { premium: 150000, db: 0.797131, ltc: 1 },
    { premium: 200000, db: 0.797124, ltc: 1 },
    { premium: 300000, db: 0.797131, ltc: 1 },
    { premium: 325000, db: 0.797129, ltc: 1 },
    { premium: 350000, db: 0.797133, ltc: 1 },
    { premium: 375000, db: 0.797131, ltc: 1 },
    { premium: 400000, db: 0.797129, ltc: 1 },
    { premium: 450000, db: 0.797131, ltc: 1 },
    { premium: 500000, db: 0.797132, ltc: 1 },
  ],
  "sp_joint|75|None|5%|50 Months|50 Months": [
    { premium: 50000, db: 1.093611, ltc: 1.093611 },
    { premium: 75000, db: 1.000007, ltc: 1.000007 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000004, ltc: 1.000004 },
    { premium: 150000, db: 1.000007, ltc: 1.000007 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000008, ltc: 1.000008 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000007, ltc: 1.000007 },
    { premium: 400000, db: 1.000008, ltc: 1.000008 },
    { premium: 450000, db: 1.01672, ltc: 0.9944 },
    { premium: 500000, db: 1.074887, ltc: 0.974879 },
  ],
  "sp_joint|75|None|5%|50 Months|Lifetime": [
    { premium: 50000, db: 1.497327, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1.000003, ltc: 1 },
    { premium: 150000, db: 0.999995, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1 },
    { premium: 350000, db: 1.000002, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000004, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1.000003, ltc: 1 },
  ],
  "sp_joint|75|None|None|25 Months|25 Months": [
    { premium: 50000, db: 1.132885, ltc: 1.132885 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1, ltc: 1 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1, ltc: 1 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1, ltc: 1 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|75|None|None|25 Months|50 Months": [
    { premium: 50000, db: 1.436604, ltc: 1.436604 },
    { premium: 75000, db: 0.99999, ltc: 0.99999 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999994, ltc: 0.999994 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000002, ltc: 1.000002 },
    { premium: 350000, db: 1, ltc: 1 },
    { premium: 375000, db: 1.000002, ltc: 1.000002 },
    { premium: 400000, db: 1.000004, ltc: 1.000004 },
    { premium: 450000, db: 1.000003, ltc: 1.000003 },
    { premium: 500000, db: 1.000003, ltc: 1.000003 },
  ],
  "sp_joint|75|None|None|25 Months|Lifetime": [
    { premium: 50000, db: 1.997922, ltc: 1 },
    { premium: 75000, db: 1.331948, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999996, ltc: 1 },
    { premium: 150000, db: 0.999993, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000005, ltc: 1 },
    { premium: 350000, db: 1.000003, ltc: 1 },
    { premium: 375000, db: 1.000001, ltc: 1 },
    { premium: 400000, db: 1.000005, ltc: 1 },
    { premium: 450000, db: 1.000002, ltc: 1 },
    { premium: 500000, db: 1.000004, ltc: 1 },
  ],
  "sp_joint|75|None|None|33 Months|33 Months": [
    { premium: 50000, db: 1.017728, ltc: 1.017728 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1.000007, ltc: 1.000007 },
    { premium: 200000, db: 1.000005, ltc: 1.000005 },
    { premium: 300000, db: 1.000007, ltc: 1.000007 },
    { premium: 325000, db: 1.000006, ltc: 1.000006 },
    { premium: 350000, db: 1.000006, ltc: 1.000006 },
    { premium: 375000, db: 1.000005, ltc: 1.000005 },
    { premium: 400000, db: 1.000008, ltc: 1.000008 },
    { premium: 450000, db: 1.000007, ltc: 1.000007 },
    { premium: 500000, db: 1.000006, ltc: 1.000006 },
  ],
  "sp_joint|75|None|None|33 Months|Lifetime": [
    { premium: 50000, db: 1.47803, ltc: 1 },
    { premium: 75000, db: 0.999995, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999991, ltc: 1 },
    { premium: 150000, db: 0.999995, ltc: 1 },
    { premium: 200000, db: 0.999993, ltc: 1 },
    { premium: 300000, db: 0.999995, ltc: 1 },
    { premium: 325000, db: 0.999997, ltc: 1 },
    { premium: 350000, db: 0.999998, ltc: 1 },
    { premium: 375000, db: 0.999999, ltc: 1 },
    { premium: 400000, db: 0.999996, ltc: 1 },
    { premium: 450000, db: 0.999998, ltc: 1 },
    { premium: 500000, db: 0.999997, ltc: 1 },
  ],
  "sp_joint|75|None|None|50 Months|50 Months": [
    { premium: 50000, db: 0.999991, ltc: 0.999991 },
    { premium: 75000, db: 0.999997, ltc: 0.999997 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 0.999995, ltc: 0.999995 },
    { premium: 150000, db: 0.999997, ltc: 0.999997 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1, ltc: 1 },
    { premium: 325000, db: 1.000001, ltc: 1.000001 },
    { premium: 350000, db: 1.000001, ltc: 1.000001 },
    { premium: 375000, db: 0.999999, ltc: 0.999999 },
    { premium: 400000, db: 1, ltc: 1 },
    { premium: 450000, db: 1.000001, ltc: 1.000001 },
    { premium: 500000, db: 1, ltc: 1 },
  ],
  "sp_joint|75|None|None|50 Months|Lifetime": [
    { premium: 50000, db: 1.018765, ltc: 1 },
    { premium: 75000, db: 1, ltc: 1 },
    { premium: 100000, db: 1, ltc: 1 },
    { premium: 125000, db: 1, ltc: 1 },
    { premium: 150000, db: 1, ltc: 1 },
    { premium: 200000, db: 1, ltc: 1 },
    { premium: 300000, db: 1.000003, ltc: 1 },
    { premium: 350000, db: 1.000003, ltc: 1 },
    { premium: 375000, db: 1.000003, ltc: 1 },
    { premium: 400000, db: 1.000003, ltc: 1 },
    { premium: 450000, db: 1.000005, ltc: 1 },
    { premium: 500000, db: 1.000004, ltc: 1 },
  ],
};

export const OA_CAT2_AVAILABLE_AGES = [45, 48, 50, 55, 60, 65, 70, 75] as const;

export const OA_CAT2_MIXED_MIN_AGES = [55, 60, 65, 70] as const;
export const OA_CAT2_MIXED_MAX_AGES = [60, 65, 70, 75] as const;
